import _ from "lodash";
import React from "react";
import {
  getIsToddleLibraryWorksheetQueriesV2Enabled,
  getIsWorksheetVideoLagFixEnabled,
  isWorksheetMutationsV2Enabled,
  isWorksheetQueriesV2Enabled,
  getIsWorksheetDocEditorEnabled,
} from "./WorksheetFeatureFlags";
import {
  ORG_RESOURCE_TYPE_WORKSHEET,
  RESOURCE_TYPE_FOLDER,
  QUESTION_TYPE_DETAILS,
  QUESTION_UID_TRUE_FALSE_V2,
  QUESTION_UID_MULTI_PART,
  CONTENT_UID_TEXT_BOX,
  DYNAMIC_FIELD_DETAILS,
  FIELD_UID_SCORE,
  FIELD_UID_VOICE_INSTRUCTIONS,
  FIELD_UID_RESOURCES,
  FIELD_UID_RESPONSE,
  MODE_TEACHER_CREATE,
  MODE_TEACHER_VIEW,
  FIELD_UID_RICH_TEXT_EDITOR,
  FIELD_UID_TITLE,
  FIELD_UID_BLANKS,
  FIELD_UID_BLANKS_ANSWERS,
  FIELD_UID_BLANKS_RESPONSES,
  FIELD_UID_RADIO,
  FIELD_UID_MCQ_CHOICES,
  FIELD_UID_MCQ_ANSWERS,
  FIELD_UID_MCQ_RESPONSE,
  MODE_STUDENT_ATTEMPT,
  MODE_STUDENT_VIEW,
  MODE_STUDENT_EVALUATE,
  MODE_TEACHER_EVALUATE,
  QUESTION_SUBMISSION,
  QUESTION_UID_TEXT_RESPONSE_V3,
  BLANKS_ANSWER_START_CHAR,
  BLANKS_ANSWER_END_CHAR,
  BLANKS_ANSWER_REPLACEMENT,
  BLANKS_ANSWER_REGEX,
  BLANKS_ANSWER_SEPARATOR,
  QUESTION_UID_BLANKS,
  QUESTION_UID_MULTI_CHOICE,
  FIELD_UID_ASSESSMENT_TOOL,
  FIELD_UID_ANSWER,
  FIELD_UID_TEACHER_NOTES,
  FIELD_UID_SETTINGS,
  STUDENT_WORKSHEET_MODES,
  MODE_TEACHER_PREVIEW,
  RESOURCE_TYPE_QUESTION,
  MODE_ASSESSMENT_VIEW,
  MODE_LIBRARY_VIEW,
  LIBRARY_TYPE_OPTIONS,
  QUESTION_ORDER_OPTIONS,
  GRADE_11,
  GRADE_12,
  ASSESSMENT_FIELD_UID_SUBJECTS,
  ADD_QUESTION_FROM_LIBRARY,
  METADATA_ADDED_TO_LIBRARY_KEY,
  QUESTION_UID_GRAPHING,
  FIELD_UID_GRAPH_TEMPLATE,
  FIELD_UID_GRAPH_RESPONSE,
  GRAPH_TYPE_OPTIONS,
  QUESTION_TAG_SUBJECT,
  QUESTION_TAG_TOPIC,
  FIELD_TYPE_RICHTEXT_PORTED,
  SCHOOL_LIBRARY,
  QUESTION_FEED_TYPE_SAVED,
  QUESTION_FEED_TYPE_ALL_QUESTIONS,
  MODE_RESTRICTED_ASSESSMENT_VIEW,
  QUESTION_UID_DRAWING,
  FIELD_UID_WORKBOOK_TEMPLATE,
  FIELD_UID_WORKBOOK_RESPONSE,
  FIELD_UID_WORKBOOK_INTERACTION_SETTING,
  FIELD_UID_ADDITIONAL_FIELD_SETTING,
  FIELD_UID_DRAG_AND_DROP,
  FIELD_UID_DRAG_AND_DROP_RESPONSE,
  fillInTheBlanksAnsRegex,
  blankFormate,
  QUESTION_UID_DRAG_AND_DROP,
  GENERATE_USING_AI,
  SEB_DOWNLOAD_LINK_WINDOWS,
  SEB_DOWNLOAD_LINK_MAC,
  FIELD_UID_DRAG_AND_DROP_ANSWERS,
  QUESTION_UID_FIND_HOTSPOT,
  FIELD_UID_FIND_HOTSPOT,
  FIELD_UID_FIND_HOTSPOT_RESPONSE,
  FIELD_UID_FIND_HOTSPOT_ANSWERS,
  FIELD_UID_ADD_LEARNING_GOALS,
  QUESTION_TYPES_V2,
  QUESTION_UID_MATCHING,
  FIELD_UID_TABLE,
  FIELD_UID_TABLE_ANSWERS,
  TEMPLATE_FIELDS_TO_REMOVE,
  QUESTION_UID_TABLE,
  QUESTION_UID_LABELLING,
  FIELD_UID_MATCHING_RESPONSE,
  FIELD_UID_MATCHING,
  FIELD_UID_MATCHING_ANSWERS,
  DYNAMIC_FIELDS_V2,
  FIELD_UID_LABELLING,
  FIELD_UID_LABELLING_RESPONSE,
  FIELD_UID_LABELLING_ANSWERS,
  AI_GEN_IDENTIFIER,
  FIELD_ERROR_MESSAGES,
  QUESTIONS_REGEX,
  CREATE_DROP_DOWN_OPTIONS,
  WORKSHEET_THEATER_MODE_MIMETYPES,
  EXTRACT_FROM_DOC,
  EXTRACT_FROM_DOC_LOADER,
  QUESTION_UID_SEPARATOR,
  QUESTION_UID_VIDEO,
  QUESTION_UID_AUDIO,
  FIELD_UID_AUDIO_RESPONSE,
  FIELD_UID_VIDEO_RESPONSE,
  FIELD_UID_SUBMISSION_METHOD,
  QUESTION_UID_SECTION,
  AI_SUPPORTED_QUESTION_TYPES,
  FIELD_UID_ALLOW_MULTIPLE_SELECTION_SETTING,
} from "./WorksheetConstants";
import {
  extractContentFromHTML,
  generateRandomId,
  moveElementInArray,
  getRoundedDecimalValue,
  getStyleStrippedText,
  htmlToText,
  getFileType,
  isToddleAppSubdomain,
} from "Utils";
import { Tag } from "@toddle-edu/ds-web";
import {
  CopyOutlined,
  AddToLibraryOutlined,
  ImageSquareOutlined,
} from "@toddle-edu/ds-icons";
import update from "immutability-helper";
import {
  getOrganizationResourceFromCache,
  writeOrganizationResourceInCache,
  getQuestionFieldsFromCache,
  writeQuestionFieldsInCache,
  getQuestionSubmissionFromCache,
  writeQuestionSubmissionInCache,
  getQuestionFromCache,
  writeQuestionInCache,
  getAssessmentQuestionsFromCache,
  getQuestionSubmissionConnectionFromCache,
  writeQuestionSubmissionConnectionInCache,
  getStudentAssignmentQuestionSubmissionsFromCache,
  getStudentQuestionDetailsQueryFromCache,
  getQuestionFromCacheV2,
  writeQuestionInCacheV2,
} from "./WorksheetGraphqlHelpers";
import { getIsCurrentAcademicYear } from "Platform/modules/PlatformModule";
import ACLStore from "lib/aclStore";
import ReactDOMServer from "react-dom/server";
import BlanksInput from "Worksheet/components/Question/QuestionFieldComponent/FillInTheBlanks/BlanksInput";
import {
  getIsIBGradeScaleTool,
  sendMessagePayloadToMobile,
  getAssignmentDetailsQueryVariables,
  getCurrentAndPreviousSubmissions,
  getIsStudentAssignmentRevampEnabled,
  getSubmissionStatus,
} from "ClassRoom/modules/utils";
import QuestionCardTag from "Worksheet/components/QuestionCardTag";
import {
  GRADE,
  SUBJECT,
  QUESTION_TOPIC,
  TOPIC_DEPTH,
} from "QuestionBank/modules/Constants";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_UBD,
  SCORE,
  CURRICULUM_TYPE_MYP,
} from "Constants/stringConstants";
import { getAssessmentDetailsFromCache } from "Assessments/modules/AssessmentGraphqlHelpers";
import { getAssignmentDetailsFromCache } from "ClassRoom/modules/ClassRoomGraphqlHelpers";
import { DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX, colors } from "Constants";
import { logoutUser, setToastMsg } from "Login/modules/LoginModule";
import moment from "moment";
import {
  isWindows,
  isInKioskMode,
  isMobileOrTablet,
  isSafeExamBrowser,
} from "Utils/DeviceDetectHelpers";
import { getOptionsLocale } from "UnitPlans/components/LibraryCommonComponents/ResourceEdit/modules/Utils";
import { getIsMYPGrade } from "routes/routes/ToddleLibrary/modules/ToddleLibraryUtils";
import { getGlobalGradeUid } from "LearningCourses/modules/Utils";
import { getResolvedOptimisticValue } from "modules/ElementValueUtils";
import {
  TABLE_INPUT_END_CHAR,
  TABLE_INPUT_START_CHAR,
  tableInputFormat,
} from "UIComponents/Table/constants";
import {
  getQuestionLibraryQuestionDetailsFromCache,
  writeQuestionLibraryQuestionDetailsInCache,
} from "QuestionBank/modules/QuestionBankGraphqlHelper";
import { LABELLING_CATEGORY } from "../components/Question/QuestionFieldComponent/LabellingField/Labelling/LabellingConstant";
import { getPlannerTemplateFromCache } from "modules/CommonGraphqlHelpers";
import client from "lib/apolloClient/client";
import { getCourseAssignmentFeedWithoutAssignedStudentQuery } from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/ClassRoomQuery";
import { getQueryFiltersMemoize } from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/ClassRoomModule/ClassRoomUtils";
import { getAIConversationsQuery } from "./WorksheetQueries";
import {
  isMYPWorksheetEnabledForLibrary,
  curriculumTypeObj,
  getToddleLibraryVisibilityStatus,
} from "ToddleLibrary/modules/ToddleLibraryUtils";

import { getAssessmentQuery } from "Assessments/modules/AssessmentQuery";
import { store } from "store/createStore";
import {
  MYP_GRADE_LABELS,
  QUESTION,
  QUESTION_V2,
} from "ToddleLibrary/modules/Constants";
import { getStudentWorksheetReopenState } from "Worksheet/components/WorksheetTimer/WorksheetTimerUtils";
import { getFormattedDuration } from "Utils/DateTimeHelpers";

/**
 * @description - Retrieves the appropriate icon from the question details based on the worksheet creation revamp state.
 * @param {object} questionTypeDetails - The details of the question type, which includes the icons.
 * @returns {React.Element} - The icon element to be used for the question type.
 */
export const getIconFromQuestionDetails = _.memoize(
  ({ questionTypeDetails = false }) => {
    const isWorksheetAIEnabled = getIsWorksheetAIEnabled();
    const icon = _.get(questionTypeDetails, "icon");
    const icon2 = _.get(questionTypeDetails, "icon2", icon);
    const icon3 = _.get(questionTypeDetails, "icon3", icon2);
    const illustration = _.get(questionTypeDetails, "illustration");

    if (isWorksheetAIEnabled && illustration) {
      return <img src={illustration} alt={_.get(questionTypeDetails, "key")} />;
    }

    return icon3;
  },
  ({ questionTypeDetails }) =>
    JSON.stringify({
      key: _.get(questionTypeDetails, "key"),
      icon: _.get(questionTypeDetails, "icon"),
      icon2: _.get(questionTypeDetails, "icon2"),
      icon3: _.get(questionTypeDetails, "icon3"),
      illustration: _.get(questionTypeDetails, "illustration"),
      isWorksheetAIEnabled: getIsWorksheetAIEnabled(),
    })
);

/**
 * @description - Retrieves the appropriate locale label from the question details based on the worksheet creation revamp state.
 * @param {object} questionTypeDetails - The details of the question type, which includes the locale labels.
 * @returns {string} - The locale label to be used for the question type.
 */
export const getLocaleLabelFromQuestionDetails = _.memoize(
  ({ questionTypeDetails }) => {
    const localeLabel = _.get(questionTypeDetails, "localeLabel");
    const localeLabel2 = _.get(
      questionTypeDetails,
      "localeLabel2",
      localeLabel
    );
    const localeLabel3 = _.get(questionTypeDetails, "localeLabel3");

    return localeLabel3 ? localeLabel3 : localeLabel2;
  },
  ({ questionTypeDetails }) =>
    JSON.stringify({
      localeLabel: _.get(questionTypeDetails, "localeLabel"),
      localeLabel2: _.get(questionTypeDetails, "localeLabel2"),
      localeLabel3: _.get(questionTypeDetails, "localeLabel3"),
    })
);

/** @returns {Object} - query variables of getAssessmentQuestionsQuery  */
export const getAssessmentQuestionsQueryVariables = _.memoize(
  ({
    parentId,
    parentType,
    portalType,
    userType = "staff",
    mode,
    libraryBannerFilters,
    showAssessmentToolsInQuestions = false,
  }) => {
    const variables = {
      id: parentId,
      type: parentType,
      orgResourceFilters: {
        types: [ORG_RESOURCE_TYPE_WORKSHEET],
        resourceTypes: [
          RESOURCE_TYPE_FOLDER,
        ] /** we only create sections (i.e folders) at the parent level so we are only fetching folders */,
      },
      libraryBannerFilters,
      portalType,
    };

    if (showAssessmentToolsInQuestions) {
      variables.showAssessmentTools = true;
    } else if (_.isEqual(userType, "student")) {
      variables.showAssessmentTools = _.isEqual(mode, MODE_STUDENT_EVALUATE);
    }

    return variables;
  },
  ({
    parentId,
    parentType,
    portalType,
    userType = "staff",
    mode,
    libraryBannerFilters,
    showAssessmentToolsInQuestions = false,
  }) =>
    JSON.stringify({
      parentId,
      parentType,
      portalType,
      userType,
      mode,
      libraryBannerFilters,
      showAssessmentToolsInQuestions,
    })
);

export const getAssessmentSubmissionQueryVariables = _.memoize(
  ({ submissionId, mode }) => {
    if (
      _.includes(
        [MODE_TEACHER_EVALUATE, MODE_TEACHER_VIEW, MODE_STUDENT_EVALUATE],
        mode
      )
    ) {
      return {
        submissionId,
        userFilter: "ALL",
      };
    }

    return {
      submissionId,
      userFilter: "SELF",
    };
  },
  ({ submissionId, mode }) => `${submissionId}|${mode}`
);

/**
 * @description - retrieves the score field's value and converts it into a number
 * @returns - question score as an integer
 */
export const getFormattedQuestionScore = scoreField => {
  const score = _.get(scoreField, "value", null);
  const intScore = _.isEmpty(score) ? 0 : parseFloat(score);

  return intScore;
};

/**
 * @description - converts numbers 0,1,2,3... into alphabets A,B,C,D...
 * @param {Number} number
 * @returns {String} - alphabet corresponding to the number
 */
export const convertNumberToAlphabet = number => {
  const baseCharCode = "A".charCodeAt(0);
  const alphabetIndex = number % 26;

  const charCode = baseCharCode + alphabetIndex;
  return String.fromCharCode(charCode);
};

/** @returns - a boolean whether htmlString contains image */
export const checkForImageInHtmlString = htmlString => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const imgElements = doc.getElementsByTagName("img");
  return imgElements.length > 0;
};

/** @returns - a boolean whether htmlString contains iframe */
export const checkForIframeEmbedInHtmlString = htmlString => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    if (!doc) return false;
    const iframeElements = doc.getElementsByTagName("iframe");
    return !_.isEmpty(iframeElements);
  } catch {
    return false;
  }
};

/** @returns - a boolean whether htmlString contains a video tag */
export const checkForVideoInHtmlString = htmlString => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    if (!doc) return false;
    const videoElements = doc.getElementsByTagName("video");
    return !_.isEmpty(videoElements);
  } catch {
    return false;
  }
};

/**
 * @description - function to extract text, custom image and video components from a HTML string.
 */
export const extractContentWithMediaFromHTML = ({ htmlString }) => {
  const elements = [];

  if (_.isEmpty(htmlString)) {
    return elements;
  }

  if (getIsWorksheetVideoLagFixEnabled()) {
    // Single pass: match text between tags and media tags in document order
    const regex = />([^<>]+)<|<(img|video|iframe)\b/gi;
    let match;
    while ((match = regex.exec(htmlString)) !== null) {
      if (match[1]) {
        const text = _.unescape(_.replace(match[1], /&nbsp;/g, " ")).trim();
        if (text) {
          elements.push(text);
        }
      } else if (match[2]) {
        elements.push(<ImageSquareOutlined size="xxx-small" />);
      }
    }
  } else {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // to traverse text and image elements.
    const walker = document.createTreeWalker(
      tempDiv,
      NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT
    );

    let node;
    // Iterate through nodes to extract text or replace images with components.
    while ((node = walker.nextNode())) {
      if (_.isEqual(node.nodeType, Node.TEXT_NODE) && node.textContent.trim()) {
        elements.push(node.textContent.trim());
      } else if (
        _.isEqual(node.nodeType, Node.ELEMENT_NODE) &&
        (node.tagName === "IMG" || node.tagName === "VIDEO")
      ) {
        elements.push(<ImageSquareOutlined size="xxx-small" />);
      }
    }
  }

  return elements;
};

export const getFormattedHtml = ({ htmlString, t }) => {
  const isVideoLagFixEnabled = getIsWorksheetVideoLagFixEnabled();
  const contentElements = extractContentWithMediaFromHTML({ htmlString });

  const getStyle = ({ element, index }) => ({
    verticalAlign: React.isValidElement(element) ? "middle" : "",
    marginRight: index === _.size(contentElements) - 1 ? "" : "4px",
  });

  return !_.isEmpty(contentElements) ? (
    _.map(contentElements, (element, index) => (
      <span
        key={isVideoLagFixEnabled ? `${index}-${htmlString.length}` : index}
        style={getStyle({ element, index })}
      >
        {element}
      </span>
    ))
  ) : (
    <>{t("worksheet:untitled_question")}</>
  );
};

/**
 * @description - return the question title based on the question type uid
 */
export const getQuestionTitle = ({
  question,
  t,
  shouldIncludeMedia = false,
}) => {
  const typeUid = _.get(question, "questionType.uid", "");
  const fields = _.get(question, "fields", []);

  const getContentFromHtml = shouldIncludeMedia
    ? getFormattedHtml
    : extractContentFromHTML;

  switch (typeUid) {
    case CONTENT_UID_TEXT_BOX: {
      const htmlString = _.get(
        _.find(fields, { uid: FIELD_UID_RICH_TEXT_EDITOR }),
        "value",
        ""
      );
      return { title: getContentFromHtml({ htmlString, t }), htmlString };
    }
    case QUESTION_UID_MULTI_PART: {
      return {
        title: t(_.get(QUESTION_TYPE_DETAILS, [typeUid, "localeLabel"], "")),
        htmlString: false,
      };
    }
    case QUESTION_UID_VIDEO:
    case QUESTION_UID_LABELLING:
    case QUESTION_UID_FIND_HOTSPOT:
    case QUESTION_UID_DRAWING:
    case QUESTION_UID_DRAG_AND_DROP:
    case QUESTION_UID_GRAPHING:
    case QUESTION_UID_TRUE_FALSE_V2:
    case QUESTION_UID_TEXT_RESPONSE_V3:
    case QUESTION_UID_MULTI_CHOICE:
    case QUESTION_UID_MATCHING:
    case QUESTION_UID_TABLE:
    case QUESTION_UID_AUDIO: {
      const title = _.get(
        _.find(fields, { uid: FIELD_UID_TITLE }),
        "value",
        ""
      );
      return {
        title: getContentFromHtml({ htmlString: title, t }),
        htmlString: title,
      };
    }
    case QUESTION_UID_BLANKS: {
      const title = _.get(
        _.find(fields, { uid: FIELD_UID_BLANKS }),
        "value",
        ""
      );
      return {
        title: getContentFromHtml({
          htmlString: _.replace(title, BLANKS_ANSWER_REGEX, "_______"),
          t,
        }),
        htmlString: title,
        htmlStringWithBlank: _.replace(title, BLANKS_ANSWER_REGEX, "_______"),
      };
    }
    default:
      return {
        title: _.get(_.find(fields, { uid: FIELD_UID_TITLE }), "value", ""),
        htmlString: false,
      };
  }
};

/**
 * @description - return the question title based on the question field uid
 */
export const getFormattedQuestionTitle = _.memoize(({ questionTitle }) => {
  const titleUid = _.get(questionTitle, "uid", "");
  const titleValue = _.get(questionTitle, "value", "");

  switch (titleUid) {
    case FIELD_UID_TITLE:
    case FIELD_UID_RICH_TEXT_EDITOR: {
      return {
        title: extractContentFromHTML({ titleValue }),
        htmlString: titleValue,
      };
    }
    case FIELD_UID_BLANKS: {
      return {
        title: extractContentFromHTML({
          htmlString: _.replace(titleValue, BLANKS_ANSWER_REGEX, "_______"),
        }),
        htmlString: _.replace(titleValue, BLANKS_ANSWER_REGEX, "_______"),
      };
    }
    default:
      return {
        title: titleValue,
        htmlString: false,
      };
  }
});

/**
 * Determines if a question type is a visual element that should not be considered
 * for evaluation, scoring, indexing, or included in the overall question count.
 *
 * @param {string} questionTypeUid - The unique identifier of the question type
 * @returns {boolean} - Returns true if the question is purely for visual organization
 */
export const isVisualWorksheetElement = questionTypeUid => {
  return _.includes(
    [CONTENT_UID_TEXT_BOX, QUESTION_UID_SEPARATOR],
    questionTypeUid
  );
};

/**
 *
 * @param {question} Object
 * @param {submission} Object
 * @returns - boolean of whether the question is attempted
 */
export const getIsQuestionAttempted = ({ question, submission }) => {
  if (!submission) return false;
  const questionTypeUid = _.get(question, "questionType.uid");

  const submissionFields = _.get(submission, "fields", []);

  switch (questionTypeUid) {
    case QUESTION_UID_BLANKS: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_BLANKS_RESPONSES }),
        "value",
        {}
      );

      return !_.isEmpty(_.join(_.values(responseValue), ""));
    }
    case QUESTION_UID_TRUE_FALSE_V2: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_RADIO }),
        "value",
        {}
      );
      return _.some(responseValue, value => {
        return !_.isEmpty(value);
      });
    }
    case QUESTION_UID_MULTI_CHOICE: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_MCQ_RESPONSE }),
        "value",
        []
      );

      return _.some(responseValue, responseObject => {
        return _.get(responseObject, "isStudentSelected", false);
      });
    }
    // For content box and separator questions, we consider them as not attempted because they are visual elements
    case CONTENT_UID_TEXT_BOX:
    case QUESTION_UID_SEPARATOR: {
      return false;
    }
    case QUESTION_UID_GRAPHING: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_RESPONSE }),
        "value",
        ""
      );

      const response = extractDataFromHTML({
        value: responseValue,
        uid: questionTypeUid,
      });
      const graphResponseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_GRAPH_RESPONSE }),
        "value",
        ""
      );

      return (
        !_.isEmpty(response) ||
        !_.isEmpty(graphResponseValue) ||
        checkForImageInHtmlString(responseValue) ||
        checkForIframeEmbedInHtmlString(responseValue) ||
        checkForVideoInHtmlString(responseValue)
      );
    }
    case QUESTION_UID_DRAWING: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_RESPONSE }),
        "value",
        ""
      );

      const response = extractDataFromHTML({
        value: responseValue,
        uid: questionTypeUid,
      });
      const workbookResponseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_WORKBOOK_RESPONSE }),
        "resolveFields.attachments[0]",
        {}
      );

      return !_.isEmpty(response) || !_.isEmpty(workbookResponseValue);
    }
    case QUESTION_UID_TEXT_RESPONSE_V3: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_RESPONSE }),
        "value",
        ""
      );
      const fileResponse = _.get(
        _.find(submissionFields, { uid: FIELD_UID_RESOURCES }),
        "resolveFields.attachments",
        ""
      );

      const response = extractDataFromHTML({
        value: responseValue,
        uid: questionTypeUid,
      });

      return (
        !_.isEmpty(response) ||
        !_.isEmpty(fileResponse) ||
        checkForImageInHtmlString(responseValue) ||
        checkForIframeEmbedInHtmlString(responseValue) ||
        checkForVideoInHtmlString(responseValue)
      );
    }
    case QUESTION_UID_FIND_HOTSPOT: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_FIND_HOTSPOT_RESPONSE }),
        "value.answers",
        []
      );

      return !_.isEmpty(responseValue);
    }
    case QUESTION_UID_DRAG_AND_DROP: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_DRAG_AND_DROP_RESPONSE }),
        "value",
        ""
      );

      return Boolean(responseValue && !_.isEmpty(responseValue));
    }
    case QUESTION_UID_TABLE: {
      let isAttempted = false;
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_TABLE }),
        "value.data",
        ""
      );
      _.forEach(responseValue, row => {
        _.forEach(row, (col, id) => {
          if (_.isEqual(id, "id")) return;
          if (!_.isEmpty(col.substring(1, _.size(col) - 1))) isAttempted = true;
        });
      });
      return isAttempted;
    }
    case QUESTION_UID_MATCHING: {
      const response = _.get(
        _.find(submissionFields, { uid: FIELD_UID_MATCHING_RESPONSE }),
        "value",
        ""
      );
      return response && !_.isEmpty(response);
    }
    case QUESTION_UID_LABELLING: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_LABELLING_RESPONSE }),
        "value.answers",
        {}
      );
      // * for answer object if all values are empty, then question in un-attempted
      return !_.isEmpty(_.trim(_.join(_.values(responseValue), "")));
    }
    case QUESTION_UID_AUDIO: {
      const response = _.get(
        _.find(submissionFields, { uid: FIELD_UID_AUDIO_RESPONSE }),
        "resolveFields.attachments",
        []
      );
      return !_.isEmpty(response) && !_.isEmpty(response[0]);
    }
    case QUESTION_UID_VIDEO: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_VIDEO_RESPONSE }),
        "resolveFields.attachments",
        []
      );
      return !_.isEmpty(responseValue) && !_.isEmpty(responseValue[0]);
    }
    default: {
      const responseValue = _.get(
        _.find(submissionFields, { uid: FIELD_UID_RESPONSE }),
        "value",
        ""
      );

      const response = extractDataFromHTML({
        value: responseValue,
        uid: questionTypeUid,
      });

      return !_.isEmpty(response);
    }
  }
};

/** @returns - a boolean of whether assessmentTools contain only IB Grade */
export const getHasIBGradeOnly = ({ assessmentTools }) => {
  const totalCount = _.get(assessmentTools, "totalCount", null);
  const assessmentToolType = _.get(
    assessmentTools,
    "edges[0].node.assessmentToolType"
  );
  return (
    totalCount == 1 &&
    getIsIBGradeScaleTool({
      assessmentToolType,
    })
  );
};

/**
 * @deprecated use getFormattedQuestionOptionV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
const getFormattedQuestionOption = ({
  questionNode,
  t,
  questionIndex,
  submissions,
  showTickIcon,
  tier,
  parentResourceId,
}) => {
  const question = _.get(questionNode, "item", {});
  const questionId = _.get(question, "id");
  const questionTypeUid = _.get(question, "questionType.uid");
  const { title: questionTitle } = getQuestionTitle({
    question,
    t,
    shouldIncludeMedia: true,
  });

  const fields = _.get(question, "fields", []);
  const assessmentTools = _.get(question, "assessmentTools", []);

  const hasIBGradeOnly = getHasIBGradeOnly({ assessmentTools });

  let assessmentToolsEvaluationDetails = {};

  const questionTypeDetails = _.get(QUESTION_TYPE_DETAILS, questionTypeUid, {});

  const scoreField = _.find(fields, { uid: FIELD_UID_SCORE });
  const intScore = getFormattedQuestionScore(scoreField);

  let icon = null,
    isCompleted = false,
    submission = {},
    isQuestion = false,
    isEvaluated = false,
    evaluatedScore;

  if (!isVisualWorksheetElement(questionTypeUid)) {
    icon = (
      <Tag
        dsVersion="2.0"
        _legacy_size="x-small"
        size="small"
        prefix={getIconFromQuestionDetails({
          questionTypeDetails,
        })}
      >
        {questionIndex}
      </Tag>
    );
    isQuestion = true;

    if (!_.isEmpty(submissions)) {
      submission = getQuestionSubmissionItem({
        questionId,
        submissions,
      });

      assessmentToolsEvaluationDetails = {
        parentId: _.get(submission, "id"),
        parentType: "QUESTION_SUBMISSION",
        toolEvaluationResponses: _.get(submission, "toolResponses"),
        ibPYPElementRatings: _.get(submission, "ibPYPElementRatings"),
        elementRemarks: _.get(submission, "elementRemarks"),
        questionFields: fields,
      };

      const scoreObj = getScoreObjFromSubmission({
        ibPYPElementRatings: _.get(submission, "ibPYPElementRatings"),
      });

      evaluatedScore = _.get(scoreObj, "value", null);

      if (!_.isNil(evaluatedScore)) {
        isEvaluated = true;
      }

      isCompleted = _.get(submission, "isQuestionAttempted", false);
    }
  }

  return {
    id: questionId,
    resourceId: _.get(questionNode, "id"),
    icon,
    label: questionTitle,
    tier,
    suffix: isQuestion ? intScore : null,
    maxMarks: isQuestion ? intScore : null,
    score: isQuestion && isEvaluated ? evaluatedScore : null,
    isCompleted,
    isEvaluated,
    showTickIcon: showTickIcon && !_.isEmpty(submission),
    isQuestion,
    submissionId: isQuestion ? _.get(submission, "id") : null,
    assessmentTools,
    hasIBGradeOnly,
    assessmentToolsEvaluationDetails,
    intScore,
    submission,
    evaluatedScore,
    questionTypeUid,
    questionIndex,
    parentResourceId,
  };
};

export const onCreateQuestionAttachment = async ({
  attachments,
  field,
  createAttachment,
  parentType,
}) => {
  const value = _.get(field, "resolveFields.attachments", []);

  let newAttachments = await Promise.all(
    _.map(attachments, attachment => {
      return createAttachment({
        attachment,
        nodeId: field?.id,
        parentType,
        type: parentType,
      });
    })
  );

  newAttachments = _.map(newAttachments, attachments => _.last(attachments));

  return [..._.toArray(value), ..._.toArray(newAttachments)];
};

export const getWorksheetQuestionsCount = ({ data }) => {
  let questionCount = 0;
  data?.forEach(questionType => {
    if (isVisualWorksheetElement(_.get(questionType, "questionTypeUid", "")))
      return;
    questionCount += _.get(questionType, "count", 0);
  });
  return questionCount;
};

/**
 * @deprecated use getSideBarOptionsV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
/** @returns - sidebar options for the worksheet view */
export const getSideBarOptions = ({
  data,
  submissions = [],
  mode,
  t,
  scoreValue = 0,
}) => {
  const options = [];

  let evaluatedCount = 0,
    totalMarks = 0,
    totalScore = 0,
    questionIndex = 1,
    isAllSectionsEvaluated = true;

  const showTickIcon = _.includes(
    [
      MODE_STUDENT_ATTEMPT,
      MODE_STUDENT_VIEW,
      MODE_TEACHER_EVALUATE,
      MODE_TEACHER_VIEW,
    ],
    mode
  );

  data?.forEach(section => {
    const questionOptions = [];
    let sectionMarks = 0,
      sectionScore = 0,
      sectionComplete = true,
      sectionEvaluated = true;

    _.get(section, "childrenV2.edges", [])?.forEach(questionOption => {
      const questionNode = _.get(questionOption, "node", {});
      const question = _.get(questionNode, "item", {});
      const questionTypeUid = _.get(question, "questionType.uid");

      let formattedQuestionOption = getFormattedQuestionOption({
        questionNode,
        t,
        questionIndex,
        submissions,
        showTickIcon,
        tier: 2,
        parentResourceId: _.get(section, "id"),
      });

      const subQuestionOptions = [];
      let subQuestionIndex = 1,
        questionMarks = 0,
        questionScore = 0,
        questionComplete = true,
        questionEvaluated = true;

      _.get(questionNode, "childrenV2.edges", [])?.forEach(
        subQuestionOption => {
          const subQuestionNode = _.get(subQuestionOption, "node", {});
          const subQuestion = _.get(subQuestionNode, "item", {});
          const subQuestionTypeUid = _.get(subQuestion, "questionType.uid");

          const formattedSubQuestionOption = getFormattedQuestionOption({
            questionNode: subQuestionNode,
            t,
            questionIndex: `${questionIndex}.${subQuestionIndex}`,
            submissions,
            showTickIcon,
            tier: 3,
            parentResourceId: _.get(questionNode, "id"),
          });

          if (subQuestionTypeUid != CONTENT_UID_TEXT_BOX) {
            subQuestionIndex++;

            const subQuestionMarks = _.get(
              formattedSubQuestionOption,
              "intScore",
              0
            );
            totalMarks += subQuestionMarks;
            sectionMarks += subQuestionMarks;
            questionMarks += subQuestionMarks;

            if (
              !_.isEmpty(_.get(formattedSubQuestionOption, "submission", {}))
            ) {
              const isSubQuestionCompleted = _.get(
                formattedSubQuestionOption,
                "isCompleted",
                false
              );
              const isSubQuestionEvaluated = _.get(
                formattedSubQuestionOption,
                "isEvaluated",
                false
              );

              sectionComplete = sectionComplete && isSubQuestionCompleted;
              questionComplete = questionComplete && isSubQuestionCompleted;

              sectionEvaluated = sectionEvaluated && isSubQuestionEvaluated;
              questionEvaluated = questionEvaluated && isSubQuestionEvaluated;

              const subQuestionEvaluatedScore = _.get(
                formattedSubQuestionOption,
                "evaluatedScore"
              );

              if (!_.isNil(subQuestionEvaluatedScore)) {
                const subQuestionEvaluatedScoreNum = Number(
                  subQuestionEvaluatedScore
                );

                questionScore += subQuestionEvaluatedScoreNum;
                sectionScore += subQuestionEvaluatedScoreNum;
                totalScore += subQuestionEvaluatedScoreNum;
              }
            }
          }

          subQuestionOptions.push(formattedSubQuestionOption);
        }
      );

      if (!_.isEmpty(subQuestionOptions)) {
        /** if it's a multipart question set the marks/score as the sum of its sub questions */

        questionMarks = getRoundedDecimalValue(questionMarks);
        questionScore = getRoundedDecimalValue(questionScore);

        formattedQuestionOption = update(formattedQuestionOption, {
          suffix: { $set: questionMarks },
          maxMarks: { $set: questionMarks },
          score: { $set: questionScore },
          isCompleted: { $set: questionComplete },
          isEvaluated: { $set: questionEvaluated },
          childOptions: { $set: subQuestionOptions },
        });
      }

      // Skip for separator and text box, they doesn't have score or evaluation associated with them and are for visual purposes only
      if (!isVisualWorksheetElement(questionTypeUid)) {
        questionIndex++;

        const questionMarks = _.get(formattedQuestionOption, "intScore", 0);
        totalMarks += questionMarks;
        sectionMarks += questionMarks;

        if (!_.isEmpty(_.get(formattedQuestionOption, "submission", {}))) {
          const isQuestionCompleted = _.get(
            formattedQuestionOption,
            "isCompleted",
            false
          );
          const isQuestionEvaluated = _.get(
            formattedQuestionOption,
            "isEvaluated",
            false
          );

          if (isQuestionEvaluated) evaluatedCount++;

          sectionComplete = sectionComplete && isQuestionCompleted;
          sectionEvaluated = sectionEvaluated && isQuestionEvaluated;

          const questionEvaluatedScore = _.get(
            formattedQuestionOption,
            "evaluatedScore"
          );

          if (!_.isNil(questionEvaluatedScore)) {
            sectionScore += Number(questionEvaluatedScore);
            totalScore += Number(questionEvaluatedScore);
          }
        }
      }

      questionOptions.push(formattedQuestionOption);
    });

    sectionScore = getRoundedDecimalValue(sectionScore);
    sectionMarks = getRoundedDecimalValue(sectionMarks);

    const parentTitleFieldId = _.get(
      _.find(_.get(section, "item.fields", []), {
        uid: FIELD_UID_TITLE,
      }),
      "id",
      null
    );

    options.push({
      id: _.get(section, "id"),
      resourceId: _.get(section, "id"),
      label: _.get(section, "label", ""),
      tier: 1,
      suffix: sectionMarks,
      maxMarks: sectionMarks,
      score: sectionScore,
      showTickIcon,
      isCompleted: sectionComplete,
      isEvaluated: sectionEvaluated,
      isQuestion: false,
      showSectionActions: mode == MODE_TEACHER_CREATE,
      childOptions: questionOptions,
      // section should be not clickable in revamp
      isNotClickable: true,
      parentItemId: _.get(section, "item.id"),
      parentTitleFieldId,
    });

    isAllSectionsEvaluated = isAllSectionsEvaluated && sectionEvaluated;
  });

  totalMarks = getRoundedDecimalValue(totalMarks);
  totalScore = getRoundedDecimalValue(scoreValue);

  return {
    questionCount: questionIndex - 1,
    evaluatedCount,
    totalMarks,
    options,
    totalScore,
    isAllSectionsEvaluated,
  };
};

const EMPTY_QUESTION_SUBMISSION = {};
export const getQuestionSubmissionItem = ({ questionId, submissions = [] }) => {
  const submission =
    _.find(submissions, item =>
      _.isEqual(questionId, _.get(item, "question.id"))
    ) || EMPTY_QUESTION_SUBMISSION;
  return submission;
};

export const getScoreObjFromSubmission = ({ ibPYPElementRatings = [] }) => {
  // find item which has value as SCORE
  const scoreItem = _.find(
    ibPYPElementRatings,
    item =>
      _.isEqual(_.get(item, "ibPYPElementType"), "SCORE") &&
      _.isNil(_.get(item, "ibPYPElementId"))
  );
  return scoreItem;
};

/**
 * @description - adds new section to cache data
 * @returns - modified cache data with new section
 */
export const getUpdatedAssessmentQuestionsCacheData = ({
  cacheData,
  variables,
}) => {
  const newSection = {
    node: {
      id: generateRandomId(),
      label: _.get(variables, "organizationResources[0].label", ""),
      resourceType: _.get(variables, "organizationResources.resourceType", ""),
      type: _.get(variables, "organizationResources.type", ""),
      item: null,
      childrenV2: {
        resourceTypeBasedCount: {
          totalCount: 0,
          __typename: "OrganizationResourceCount",
        },
        edges: [],
        __typename: "OrganizationResourceConnection",
      },
      __typename: "OrganizationResource",
    },
    __typename: "OrganizationResourceEdge",
  };

  return {
    node: update(cacheData, {
      organizationResourcesV2: {
        edges: {
          [0]: {
            node: {
              childrenV2: {
                edges: { $push: [newSection] },
              },
            },
          },
        },
      },
    }),
  };
};

/** @description - updates the label of a section in cache */
export const updateSectionLabelInCache = ({ id, label }) => {
  const cacheData = getOrganizationResourceFromCache(id, false);

  if (!_.isEmpty(cacheData)) {
    const updatedCacheData = update(cacheData, {
      label: {
        $set: label,
      },
    });

    writeOrganizationResourceInCache(id, updatedCacheData, false);
  }
};

export const updateEvaluateScoreInCache = ({
  submissionId,
  value,
  userFilter = "SELF",
}) => {
  if (_.isNil(submissionId)) return;
  const cacheData = getQuestionSubmissionFromCache({
    id: submissionId,
    userFilter,
  });

  if (!_.isEmpty(cacheData)) {
    const scoreObj = getScoreObjFromSubmission({
      ibPYPElementRatings: _.get(cacheData, "ibPYPElementRatings"),
    });

    const isScoreItemEmpty = _.isEmpty(scoreObj);
    let updatedCacheData;
    if (isScoreItemEmpty) {
      const newScoreObj = {
        academicCriteriaSet: null,
        academicCriteriaValue: null,
        ibPYPElementId: null,
        ibPYPElementType: "SCORE",
        id: generateRandomId(),
        value: value,
        source: null,
        creatorType: "STAFF",
        isDeleted: false,
        evaluationJustification: null,
        __typename: "IBPYPElementRating",
      };

      const newIbPYPElementRatings = _.compact(
        _.concat([newScoreObj], _.get(cacheData, "ibPYPElementRatings", []))
      );

      updatedCacheData = update(cacheData, {
        ibPYPElementRatings: {
          $set: newIbPYPElementRatings,
        },
      });
    } else {
      updatedCacheData = update(cacheData, {
        ibPYPElementRatings: {
          $apply: ibPYPElementRatings => {
            return _.map(ibPYPElementRatings, item => {
              if (_.get(item, "id") == _.get(scoreObj, "id")) {
                return update(item, {
                  value: { $set: value },
                });
              }
              return item;
            });
          },
        },
      });
    }

    writeQuestionSubmissionInCache({
      id: submissionId,
      data: updatedCacheData,
      userFilter,
    });
  }
};

export const updateSubmissionTeacherRemarkInCache = ({
  submissionId,
  message,
}) => {
  if (_.isNil(submissionId)) return;
  const userFilter = "ALL";

  const cacheData = getQuestionSubmissionFromCache({
    id: submissionId,
    userFilter,
  });

  if (!_.isEmpty(cacheData)) {
    const elementRemarkFallback = {
      ibPYPElementId: null,
      ibPYPElementType: "QUESTION_SUBMISSION",
      id: _.get(cacheData, ["elementRemarks", 0, "id"], generateRandomId()),
    };

    const updatedCacheData = {
      ...(cacheData || {}),
      elementRemarks: [
        {
          ..._.get(cacheData, ["elementRemarks", 0], elementRemarkFallback),
          message,
          __typename: "IbPypElementRemark",
        },
      ],
    };

    writeQuestionSubmissionInCache({
      id: submissionId,
      data: updatedCacheData,
      userFilter,
    });
  }
};

/**
 * @returns - extracted data from the HTML string based on the question type
 */
export const extractDataFromHTML = ({ value, uid }) => {
  const extractedData = _.includes(
    [
      QUESTION_UID_MULTI_PART,
      QUESTION_UID_TEXT_RESPONSE_V3,
      FIELD_UID_ANSWER,
      FIELD_UID_TEACHER_NOTES,
      FIELD_UID_TITLE,
      FIELD_UID_RESPONSE,
      QUESTION_UID_TRUE_FALSE_V2,
      QUESTION_UID_MULTI_CHOICE,
      QUESTION_UID_GRAPHING,
      QUESTION_UID_DRAG_AND_DROP,
      QUESTION_UID_FIND_HOTSPOT,
      QUESTION_UID_LABELLING,
      QUESTION_UID_MATCHING,
      QUESTION_UID_VIDEO,
      QUESTION_UID_AUDIO,
    ],
    uid
  )
    ? extractContentFromHTML({ htmlString: value })
    : value;

  return _.trim(extractedData);
};

const FORMATTED_QUESTION_CACHE = new WeakMap();
const SUB_QUESTION_WRAPPER_CACHE = new WeakMap();
const EMPTY_SUB_ITEMS = [];
const _computeFormattedQuestion = ({
  question,
  submissions,
  mode,
  isEvaluationApplicable,
  isSharedWithStudent,
  isStudentEvaluationEnabled,
  isTeacherEvaluationEnabled,
  isStudentSubmissionEnabled,
  isEvaluated,
  isSubmitted,
  isWorksheetEvaluated,
  questionIndex,
  subQuestions,
  isSubQuestion = false,
  isFromInternalTool = false,
  isFromLibrary = false,
  t,
  showAssessmentToolsInQuestions = false,
}) => {
  let questionTitleText = "";
  const questionResourceId = _.get(question, "id");

  const questionData = _.get(question, "item", {});
  const assessmentTools = _.get(questionData, "assessmentTools", []);
  const questionId = _.get(questionData, "id");
  const libraryUid = _.get(questionData, "libraryUid");
  const questionTypeUid = _.get(questionData, "questionType.uid");
  const questionTypeConfig = _.get(questionData, "questionType.config", {});
  const fields = _.concat(
    _.get(questionData, "fields", []),
    _.get(questionData, "answerFields", [])
  );

  const metadata = _.get(questionData, "metadata", {});
  const isAddedToSchoolLibrary = _.get(
    metadata,
    METADATA_ADDED_TO_LIBRARY_KEY,
    false
  );

  const questionTypeDetails = _.get(QUESTION_TYPE_DETAILS, questionTypeUid, {});
  const titleField = _.find(fields, { uid: FIELD_UID_TITLE });
  const title = titleField
    ? _.get(titleField, "value", "") || t("worksheet:untitled_question")
    : null;
  const settings =
    _.get(_.find(fields, { uid: FIELD_UID_SETTINGS }), "value", {}) || {};

  const questionSettings = { ...settings };
  const configAllowInteractionSetting = _.find(
    _.get(
      questionTypeConfig,
      `field_list.${FIELD_UID_SETTINGS}.config.options`,
      []
    ),
    {
      uid: FIELD_UID_WORKBOOK_INTERACTION_SETTING,
    }
  );
  if (_.isEqual(questionTypeUid, QUESTION_UID_DRAWING)) {
    _.set(
      questionSettings,
      FIELD_UID_WORKBOOK_INTERACTION_SETTING,
      _.get(
        questionSettings,
        FIELD_UID_WORKBOOK_INTERACTION_SETTING,
        _.get(configAllowInteractionSetting, "defaultValue")
      )
    );
  }

  if (_.includes([QUESTION_UID_AUDIO, QUESTION_UID_VIDEO], questionTypeUid)) {
    _.set(
      questionSettings,
      FIELD_UID_SUBMISSION_METHOD,
      _.get(_.find(fields, { uid: FIELD_UID_SUBMISSION_METHOD }), "value")
    );
  }

  const submission = getQuestionSubmissionItem({
    questionId,
    submissions,
  });

  const comment = _.get(submission, "elementRemarks[0].message");
  const { title: questionTitle } = getQuestionTitle({
    question: _.get(question, "item"),
    t,
    shouldIncludeMedia: true,
  });

  //To show only question text in Workbook header in drawing question
  if (_.isEqual(questionTypeUid, QUESTION_UID_DRAWING)) {
    const { title: titleText } = getQuestionTitle({
      question: _.get(question, "item"),
      t,
      shouldIncludeMedia: false,
    });

    questionTitleText = _.trim(titleText)
      ? titleText
      : t("worksheet:untitled_question");
  }

  const scoreField = _.find(fields, { uid: FIELD_UID_SCORE });
  const score = getFormattedQuestionScore(scoreField);

  const showDeleteOption =
    mode === MODE_TEACHER_CREATE && (!isFromInternalTool || isSubQuestion);

  const questionTypeLabel = _.get(
    questionTypeDetails,
    "localeLabel2",
    _.get(questionTypeDetails, "localeLabel", null)
  );
  const showAssessmentToolOption =
    (!_.includes(
      [
        MODE_TEACHER_CREATE,
        MODE_TEACHER_EVALUATE,
        MODE_TEACHER_VIEW,
        MODE_TEACHER_PREVIEW,
        MODE_ASSESSMENT_VIEW,
        MODE_RESTRICTED_ASSESSMENT_VIEW,
        MODE_LIBRARY_VIEW,
        MODE_STUDENT_ATTEMPT,
        MODE_STUDENT_VIEW,
      ],
      mode
    ) ||
      showAssessmentToolsInQuestions) &&
    _.size(_.get(questionData, "assessmentTools.edges", [])) > 0;

  const scoreObj = getScoreObjFromSubmission({
    ibPYPElementRatings: _.get(submission, "ibPYPElementRatings"),
  });

  const isQuestionType =
    !_.isEmpty(questionTypeUid) && !isVisualWorksheetElement(questionTypeUid);

  const evaluatedScore = _.get(scoreObj, "value") || 0;
  const isQuestionEvaluated = isQuestionType
    ? !_.isNil(_.get(scoreObj, "value", null))
    : true;
  let label = _.includes(
    [
      MODE_TEACHER_CREATE,
      MODE_ASSESSMENT_VIEW,
      MODE_LIBRARY_VIEW,
      MODE_RESTRICTED_ASSESSMENT_VIEW,
    ],
    mode
  )
    ? questionTypeLabel
    : title;

  const assessmentToolsEvaluationDetails = {
    parentId: _.get(submission, "id"),
    parentType: QUESTION_SUBMISSION,
    toolEvaluationResponses: _.get(submission, "toolResponses"),
    ibPYPElementRatings: _.get(submission, "ibPYPElementRatings"),
    elementRemarks: _.get(submission, "elementRemarks"),
    isSharedWithStudent: isSharedWithStudent
      ? isSharedWithStudent
      : isWorksheetEvaluated,
    isStudentEvaluationEnabled: isStudentEvaluationEnabled,
    isTeacherEvaluationEnabled: isTeacherEvaluationEnabled,
    isStudentSubmissionEnabled: isStudentSubmissionEnabled,
    isEvaluated: isEvaluated,
    isSubmitted: isSubmitted,
    isEvaluationEnable:
      _.includes([MODE_STUDENT_ATTEMPT, MODE_STUDENT_EVALUATE], mode) &&
      isEvaluationApplicable &&
      getIsCurrentAcademicYear() &&
      !isSubmitted,
    worksheetHeaderDetails: {
      label: questionTitle,
      questionIndex,
      headerStyle: {
        paddingLeft: "34px",
        borderRadius: "12px 12px 0px 0px",
      },
    },
  };

  let subQuestionIndex = 0;
  let parentQuestionScore = 0;
  let parentEvaluatedScore = 0;
  let isParentQuestionEvaluated = true;
  let formattedSubQuestions = _.map(subQuestions, subQuestion => {
    const subQuestionData = _.get(subQuestion, "item", {});

    const subQuestionTypeUid = _.get(subQuestionData, "questionType.uid");

    const formattedSubQuestion = getFormattedQuestion({
      question: subQuestion,
      submissions,
      mode,
      isEvaluationApplicable,
      questionIndex: subQuestionIndex,
      subQuestions: EMPTY_SUB_ITEMS,
      isSharedWithStudent,
      isStudentEvaluationEnabled,
      isStudentSubmissionEnabled,
      isEvaluated,
      isSubmitted,
      isWorksheetEvaluated,
      isFromInternalTool,
      isSubQuestion: true,
      t,
    });

    if (subQuestionTypeUid != CONTENT_UID_TEXT_BOX) subQuestionIndex++;
    parentQuestionScore += Number(
      _.get(formattedSubQuestion, "headerConfig.score", 0)
    );
    parentEvaluatedScore += Number(
      _.get(formattedSubQuestion, "headerConfig.evaluatedScore", 0)
    );

    isParentQuestionEvaluated =
      isParentQuestionEvaluated &&
      _.get(formattedSubQuestion, "headerConfig.isQuestionEvaluated", false);

    const index =
      isFromInternalTool || isFromLibrary
        ? subQuestionIndex
        : `${questionIndex}.${subQuestionIndex}`;

    const canUseWrapperCache =
      mode === MODE_STUDENT_ATTEMPT && _.isObject(formattedSubQuestion);

    if (canUseWrapperCache) {
      const cachedWrapper = SUB_QUESTION_WRAPPER_CACHE.get(
        formattedSubQuestion
      );
      if (
        cachedWrapper &&
        cachedWrapper.subQuestionParentId === questionResourceId &&
        cachedWrapper.questionIndex === index
      ) {
        return cachedWrapper.outer;
      }
    }

    const outer = {
      ...formattedSubQuestion,
      isSubQuestion: true,
      subQuestionParentId: questionResourceId,
      questionIndex: index,
      assessmentToolsEvaluationDetails: update(
        _.get(formattedSubQuestion, "assessmentToolsEvaluationDetails"),
        {
          worksheetHeaderDetails: {
            questionIndex: { $set: index }, // to update questionIndex of subquestion
          },
        }
      ),
    };

    if (canUseWrapperCache) {
      SUB_QUESTION_WRAPPER_CACHE.set(formattedSubQuestion, {
        outer,
        subQuestionParentId: questionResourceId,
        questionIndex: index,
      });
    }

    return outer;
  });

  const isMultipart = !_.isEmpty(formattedSubQuestions);

  if (
    isMultipart &&
    _.includes([...STUDENT_WORKSHEET_MODES, MODE_LIBRARY_VIEW], mode)
  ) {
    const firstSubQuestion = _.first(formattedSubQuestions);
    if (
      _.get(firstSubQuestion, "questionTypeUid", "") == CONTENT_UID_TEXT_BOX
    ) {
      // if the first sub question is a text box, then use its value as the label instead
      label = _.get(
        _.find(
          _.get(firstSubQuestion, "questionFields", []),
          "uid",
          FIELD_UID_RICH_TEXT_EDITOR
        ),
        "value",
        ""
      );

      formattedSubQuestions = _.drop(formattedSubQuestions);
    } else {
      if (_.isEqual(MODE_LIBRARY_VIEW, mode)) {
        label = t(label);
      }
    }
  }

  parentQuestionScore = getRoundedDecimalValue(parentQuestionScore);
  parentEvaluatedScore = getRoundedDecimalValue(parentEvaluatedScore);

  //Update question type config to filter out question settings options based on question type
  const updatedQuestionTypeConfig = _.cloneDeep(questionTypeConfig);
  const questionSettingsPath = "field_list.settings.config.options";
  const questionSettingsOptions = _.get(
    updatedQuestionTypeConfig,
    questionSettingsPath,
    []
  );
  const filteredQuestionSettingsOptions = getFilteredQuestionSettings({
    options: questionSettingsOptions,
    questionTypeUid,
  });
  _.set(
    updatedQuestionTypeConfig,
    questionSettingsPath,
    filteredQuestionSettingsOptions
  );

  return {
    id: questionId,
    libraryUid,
    resourceId: questionResourceId,
    questionTypeUid,
    questionTypeConfig: updatedQuestionTypeConfig,
    questionFields: fields,
    assessmentTools,
    assessmentToolsEvaluationDetails,
    questionIndex,
    comment,
    isAddedToSchoolLibrary,
    headerConfig: {
      label,
      score: isMultipart ? parentQuestionScore : score,
      evaluatedScore: isMultipart ? parentEvaluatedScore : evaluatedScore,
      isQuestionEvaluated: isMultipart
        ? isParentQuestionEvaluated
        : isQuestionEvaluated,
      scoreField,
      showDeleteOption,
      showAssessmentToolOption,
    },
    submissionItem: submission,
    isQuestion: isQuestionType,
    subQuestions: formattedSubQuestions,
    questionData,
    questionSettings,
    questionTitleText,
  };
};

// * Cached Formatted Question Cache (student-attempt only)
export const getFormattedQuestion = args => {
  const { question, submissions, mode } = args;
  const questionId = _.get(question, "item.id");
  const item = _.get(question, "item");

  if (mode !== MODE_STUDENT_ATTEMPT || !questionId || !_.isObject(item)) {
    return _computeFormattedQuestion(args);
  }

  const questionResourceId = _.get(question, "id");
  const submission = getQuestionSubmissionItem({ questionId, submissions });
  const subQuestionItems = _.isEmpty(args.subQuestions)
    ? EMPTY_SUB_ITEMS
    : _.map(args.subQuestions, sq => _.get(sq, "item"));
  const subQuestionSubmissions = _.isEmpty(args.subQuestions)
    ? EMPTY_SUB_ITEMS
    : _.map(args.subQuestions, sq => {
        const subQId = _.get(sq, "item.id");
        return subQId
          ? getQuestionSubmissionItem({ questionId: subQId, submissions })
          : undefined;
      });

  const cached = FORMATTED_QUESTION_CACHE.get(item);
  if (
    cached &&
    cached.mode === args.mode &&
    cached.submission === submission &&
    cached.questionResourceId === questionResourceId &&
    cached.isEvaluated === args.isEvaluated &&
    cached.isSubmitted === args.isSubmitted &&
    cached.questionIndex === args.questionIndex &&
    cached.isFromLibrary === (args.isFromLibrary ?? false) &&
    cached.isSubQuestion === (args.isSubQuestion ?? false) &&
    cached.isSharedWithStudent === args.isSharedWithStudent &&
    cached.isWorksheetEvaluated === args.isWorksheetEvaluated &&
    cached.subQuestionItems.length === subQuestionItems.length &&
    cached.isEvaluationApplicable === args.isEvaluationApplicable &&
    cached.isFromInternalTool === (args.isFromInternalTool ?? false) &&
    cached.isStudentEvaluationEnabled === args.isStudentEvaluationEnabled &&
    cached.isTeacherEvaluationEnabled === args.isTeacherEvaluationEnabled &&
    cached.isStudentSubmissionEnabled === args.isStudentSubmissionEnabled &&
    cached.showAssessmentToolsInQuestions ===
      (args.showAssessmentToolsInQuestions ?? false) &&
    _.every(cached.subQuestionItems, (it, i) => it === subQuestionItems[i]) &&
    _.every(
      cached.subQuestionSubmissions,
      (s, i) => s === subQuestionSubmissions[i]
    )
  ) {
    return cached.result;
  }

  const result = _computeFormattedQuestion(args);
  FORMATTED_QUESTION_CACHE.set(item, {
    submission,
    mode: args.mode,
    questionResourceId,
    subQuestionItems,
    subQuestionSubmissions,
    isEvaluated: args.isEvaluated,
    isSubmitted: args.isSubmitted,
    questionIndex: args.questionIndex,
    isSubQuestion: args.isSubQuestion ?? false,
    isFromLibrary: args.isFromLibrary ?? false,
    isSharedWithStudent: args.isSharedWithStudent,
    isWorksheetEvaluated: args.isWorksheetEvaluated,
    isEvaluationApplicable: args.isEvaluationApplicable,
    isFromInternalTool: args.isFromInternalTool ?? false,
    isStudentEvaluationEnabled: args.isStudentEvaluationEnabled,
    isTeacherEvaluationEnabled: args.isTeacherEvaluationEnabled,
    isStudentSubmissionEnabled: args.isStudentSubmissionEnabled,
    showAssessmentToolsInQuestions:
      args.showAssessmentToolsInQuestions ?? false,
    result,
  });

  return result;
};

/**
 *
 * @returns {Object} Formatted question data for rendering
 */
export const getFormattedQuestionV2 = ({
  question,
  subQuestions: subQuestionsOverride,
  ...rest
}) => {
  const questionId = _.get(question, "id");
  const resourceId = _.get(question, "parentEntity.id", questionId);

  const questionNode = {
    id: resourceId,
    item: question,
  };

  const sortedChildEdges = _.sortBy(
    _.get(question, "children.edges", []),
    "sequence"
  );
  const subQuestions =
    subQuestionsOverride ||
    _.map(sortedChildEdges, child => ({
      id: _.get(child, "parentEntity.id", _.get(child, "id")),
      item: child,
    }));

  return getFormattedQuestion({
    question: questionNode,
    subQuestions,
    ...rest,
  });
};

/**
 * @deprecated use getFormattedSectionFeedDetailsV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
/**
 * @returns - section-wise question data formatted based on the questions' type and the worksheet mode
 */
export const getFormattedSectionFeedDetails = ({
  sections,
  mode,
  submissions = [],
  isEvaluationApplicable,
  isSharedWithStudent,
  isStudentEvaluationEnabled,
  isTeacherEvaluationEnabled,
  isStudentSubmissionEnabled,
  isEvaluated,
  isSubmitted,
  isWorksheetEvaluated,
  t,
  showAssessmentToolsInQuestions = false,
}) => {
  const sectionData = {};
  let questionIndex = 1;

  _.forEach(sections, section => {
    const sectionId = _.get(section, "id");
    let sectionScore = 0;
    let sectionMarks = 0; // for Evaluated student (achieved score)
    const sectionQuestions = _.map(
      _.get(section, "childrenV2.edges", []),
      "node"
    );

    const formattedQuestions = _.map(sectionQuestions, question => {
      const questionData = _.get(question, "item", {});
      const questionTypeUid = _.get(questionData, "questionType.uid");

      const subQuestions = _.map(
        _.get(question, "childrenV2.edges", []),
        "node"
      );

      const formattedQuestion = getFormattedQuestion({
        question,
        submissions,
        mode,
        isEvaluationApplicable,
        isSharedWithStudent,
        isStudentEvaluationEnabled,
        isTeacherEvaluationEnabled,
        isStudentSubmissionEnabled,
        isEvaluated,
        isSubmitted,
        isWorksheetEvaluated,
        questionIndex,
        subQuestions,
        t,
        showAssessmentToolsInQuestions,
      });

      if (!isVisualWorksheetElement(questionTypeUid)) questionIndex++;
      sectionScore += _.toNumber(
        _.get(formattedQuestion, ["headerConfig", "score"], 0)
      );

      sectionMarks += _.toNumber(
        _.get(formattedQuestion, ["headerConfig", "evaluatedScore"], 0)
      );

      sectionMarks = parseFloat(sectionMarks.toFixed(2));

      return formattedQuestion;
    });

    sectionData[sectionId] = {
      questions: formattedQuestions,
      score: _.round(sectionScore, 2),
      marks: sectionMarks,
    };
  });

  return sectionData;
};

/**
 * Updates question fields in the Apollo cache.
 * This function updates field data, resolves fields, and handles score field updates.
 *
 * @param {Object} params - The parameters for updating question fields in cache
 * @param {Array} params.fields - Array of field objects to update in the cache
 * @param {Object} params.extraFields - Additional fields data for optimistic updates
 * @param {boolean} params.isFromInternalTool - Whether the update is coming from an internal tool
 * @param {string} params.questionId - The ID of the question containing these fields
 * @param {boolean} params.isSubQuestion - Whether the question is a sub-question
 * @param {string} params.subQuestionParentId - The ID of the parent question if this is a sub-question
 * @param {boolean} params.isQueriesV2Enabled - Whether to use V2 queries for cache updates
 */
export const updateQuestionFieldsInCache = ({
  fields,
  extraFields,
  isFromInternalTool,
  questionId = null,
  isSubQuestion = false,
  subQuestionParentId = null,
  isQueriesV2Enabled = false,
}) => {
  // Iterate through each field that needs to be updated
  _.forEach(fields, field => {
    if (field?.id) {
      // Get the current field data from cache
      const fieldData = getQuestionFieldsFromCache({ id: field.id });
      const resolveFields = _.get(fieldData, "resolveFields", {});

      // Initialize resolved minimal tree for optimistic updates
      let resolvedMinimalTree = {};
      if (!_.isEmpty(extraFields)) {
        const { uid, value, extraParams, fieldTemplateObj } = extraFields;

        // Generate optimistic value for the field
        resolvedMinimalTree = getResolvedOptimisticValue({
          resolvedValue: _.get(fieldData, "resolvedMinimalTree", {}),
          fieldUID: uid,
          fieldTemplateObj,
          params: extraParams,
          value,
        });
      }

      // Prepare updated resolve fields by merging existing and new data
      const updatedResolveFields = {
        resolveFields: {
          ...resolveFields,
          ...field?.resolveFields,
        },
      };

      // Only proceed if we have existing field data to update
      if (!_.isEmpty(fieldData)) {
        // Create the updated data object with conditional property updates
        const updatedData = {
          ...fieldData,
          // Only include value if it exists in the field parameter
          ...(_.has(field, "value") ? { value: field?.value } : {}),
          // Only include resolveFields if they exist in the field parameter
          ...(_.has(field, "resolveFields") ? updatedResolveFields : {}),
          // Only include resolvedMinimalTree if it's not empty
          ...(_.isEmpty(resolvedMinimalTree) ? {} : { resolvedMinimalTree }),
        };

        // Write the updated data back to the cache
        writeQuestionFieldsInCache({
          id: field.id,
          data: updatedData,
        });

        // Special handling for score field updates
        // If this is a score field and we have a questionId, update the question's score in cache
        if (questionId && _.get(fieldData, "uid") === FIELD_UID_SCORE) {
          const updatedScore = _.get(updatedData, "value", "");
          updateQuestionScoreInCache({
            id: questionId,
            questionScore: updatedScore,
            isFromInternalTool: isFromInternalTool,
            isSubQuestion: isSubQuestion,
            subQuestionParentId: subQuestionParentId,
            isQueriesV2Enabled,
          });
        }
      }
    }
  });
};

export const getFieldValue = ({
  fieldData,
  fieldKey,
  questionFields,
  fieldMode,
  questionFieldType,
}) => {
  let fieldValue = _.get(fieldData, "value", "");

  switch (fieldKey) {
    case FIELD_UID_VOICE_INSTRUCTIONS:
    case FIELD_UID_RESOURCES: {
      const fieldAttachments = _.get(
        fieldData,
        "resolveFields.attachments",
        []
      );
      fieldValue = fieldAttachments;
      break;
    }
    case FIELD_UID_MCQ_RESPONSE: {
      const questionField = _.find(questionFields, {
        uid: FIELD_UID_MCQ_CHOICES,
      });

      const answerField = _.find(questionFields, {
        uid: FIELD_UID_MCQ_ANSWERS,
      });

      const response = getMcqResponseValue({
        questions: _.get(questionField, "value"),
        answers: _.get(answerField, "value"),
        submissions: _.get(fieldData, "value"),
      });
      fieldValue = response;
      break;
    }
    case FIELD_UID_MCQ_CHOICES: {
      const answerField = _.find(questionFields, {
        uid: FIELD_UID_MCQ_ANSWERS,
      });

      const questionsFieldValue = _.get(fieldData, "value", []);
      const answerFieldValue = _.get(answerField, "value", []);

      const mergedQuestionAnswers = _.map(questionsFieldValue, questionObj => {
        const answerObj = _.find(answerFieldValue, ["id", questionObj.id]);
        return _.merge({}, questionObj, answerObj);
      });

      fieldValue = mergedQuestionAnswers;
      break;
    }
    case FIELD_UID_BLANKS: {
      const answerField = _.find(questionFields, {
        uid: FIELD_UID_BLANKS_ANSWERS,
      });

      fieldValue =
        fieldMode == "create"
          ? _.get(answerField, "value.fullField", null)
          : {
              question: _.get(fieldData, "value", ""),
              answers: _.get(answerField, "value.answers", null),
              fullValue: _.get(answerField, "value.fullField", null),
            };
      break;
    }
    case FIELD_UID_BLANKS_RESPONSES: {
      const questionField = _.find(questionFields, { uid: FIELD_UID_BLANKS });
      const answerField = _.find(questionFields, {
        uid: FIELD_UID_BLANKS_ANSWERS,
      });

      const updatedResponses = _.mapValues(
        _.get(fieldData, "value", {}),
        value => _.trim(value)
      );
      fieldValue = {
        question: _.get(questionField, "value", ""),
        responses: updatedResponses,
        answers: _.get(answerField, "value.answers", null),
      };
      break;
    }
    case FIELD_UID_GRAPH_TEMPLATE:
    case FIELD_UID_GRAPH_RESPONSE: {
      if (!fieldValue) {
        fieldValue = _.get(
          _.find(questionFields, { uid: FIELD_UID_GRAPH_TEMPLATE }),
          "value",
          ""
        );
      }

      if (!_.isObject(fieldValue)) {
        try {
          fieldValue = JSON.parse(fieldValue);
        } catch {}
      }
      break;
    }
    case FIELD_UID_VIDEO_RESPONSE:
    case FIELD_UID_WORKBOOK_TEMPLATE:
    case FIELD_UID_WORKBOOK_RESPONSE:
    case FIELD_UID_AUDIO_RESPONSE: {
      fieldValue = _.get(fieldData, "resolveFields.attachments[0]", {});
      if (_.isEmpty(fieldValue)) {
        fieldValue = _.get(
          _.find(questionFields, { uid: FIELD_UID_WORKBOOK_TEMPLATE }),
          "resolveFields.attachments[0]",
          {}
        );
      }
      break;
    }
    case FIELD_UID_DRAG_AND_DROP:
    case FIELD_UID_DRAG_AND_DROP_RESPONSE: {
      const answerField = _.find(questionFields, {
        uid: FIELD_UID_DRAG_AND_DROP_ANSWERS,
      });
      const dragAndDropAnswers = _.get(answerField, "value", {}) || {};

      if (_.includes(["view", "edit"], fieldMode) && fieldValue) {
        if (
          !_.isEmpty(_.get(fieldValue, "elements", [])) &&
          _.isObject(fieldValue)
        ) {
          fieldValue = {
            elements: _.get(fieldValue, "elements", []),
            answersMapping: _.get(fieldValue, "answersMapping", {}),
            dragAndDropAnswers,
          };
        } else {
          fieldValue = {
            elements: _.get(fieldValue, "elements", []),
            dragAndDropAnswers,
          };
        }
      } else {
        if (!_.get(fieldValue, "elements")) {
          const elementData =
            _.find(questionFields, { uid: FIELD_UID_DRAG_AND_DROP }) ||
            _.find(questionFields, { uid: FIELD_UID_DRAG_AND_DROP_RESPONSE });
          fieldValue = {
            elements: _.get(elementData, "value.elements", ""),
            dragAndDropAnswers,
          };
        } else {
          fieldValue = {
            elements: _.get(fieldValue, "elements", []),
            dragAndDropAnswers,
          };
        }
      }
      break;
    }

    case FIELD_UID_FIND_HOTSPOT:
    case FIELD_UID_FIND_HOTSPOT_RESPONSE: {
      const answerField = _.find(questionFields, {
        uid: FIELD_UID_FIND_HOTSPOT_ANSWERS,
      });
      let findHotspotAnswers = _.get(answerField, "value", []) || [];
      if (!_.isArray(findHotspotAnswers)) findHotspotAnswers = [];

      if (_.includes(["view", "edit"], fieldMode) && fieldValue) {
        fieldValue = {
          answers: _.get(fieldValue, "answers", []),
          elements: _.get(fieldValue, "elements", []),
          findHotspotAnswers,
        };
      } else {
        if (!_.get(fieldValue, "elements")) {
          const elementData =
            _.find(questionFields, { uid: FIELD_UID_FIND_HOTSPOT }) ||
            _.find(questionFields, { uid: FIELD_UID_FIND_HOTSPOT_RESPONSE });
          fieldValue = {
            elements: _.get(elementData, "value.elements", ""),
            findHotspotAnswers,
          };
        } else {
          fieldValue = {
            elements: _.get(fieldValue, "elements", []),
            findHotspotAnswers,
          };
        }
      }
      break;
    }
    case FIELD_UID_TABLE: {
      const newFieldValue = {};

      const tableAnswers = _.get(
        _.find(questionFields, item => {
          return _.get(item, "uid", "") === FIELD_UID_TABLE_ANSWERS;
        }),
        "value"
      );
      if (!_.isNil(tableAnswers)) {
        newFieldValue["tableAnswers"] = tableAnswers;
      }

      newFieldValue["table"] = _.get(
        _.find(questionFields, item => {
          return _.get(item, "uid", "") === FIELD_UID_TABLE;
        }),
        "value"
      );

      // For view, edit, evaluate when student response is there, it will replace it
      if (
        _.includes(["view", "edit", "evaluate", "teacher-preview"], fieldMode)
      ) {
        // If there is no response, then this will create one
        if (_.isNil(_.get(fieldData, "value"))) {
          const emptyTableAnswers = [];
          const cols = _.get(newFieldValue, ["table", "columns"]);
          _.forEach(_.get(newFieldValue, ["table", "data"]), row => {
            const newRow = { id: _.get(row, "id") };
            _.forEach(cols, col => {
              const accessorKey = _.get(col, "accessorKey");
              if (_.isEqual(row[accessorKey], tableInputFormat)) {
                newRow[accessorKey] = "{}";
              } else {
                newRow[accessorKey] = row[accessorKey];
              }
            });
            emptyTableAnswers.push(newRow);
          });
          newFieldValue["table"] = {
            ...newFieldValue["table"],
            data: emptyTableAnswers,
          };
        } else {
          const studentResponseData = _.get(fieldData, ["value", "data"]);
          const questionData = _.get(newFieldValue, ["table", "data"]);
          const mergedFieldValueData = [];
          const cols = _.get(newFieldValue, ["table", "columns"]);
          _.forEach(questionData, row => {
            const rowId = _.get(row, "id");
            const newRow = { id: rowId };
            _.forEach(cols, col => {
              const accessorKey = _.get(col, "accessorKey");
              if (_.isEqual(row[accessorKey], tableInputFormat)) {
                const questionRow = _.find(studentResponseData, qRow =>
                  _.isEqual(_.get(qRow, "id"), rowId)
                );

                newRow[accessorKey] = _.get(questionRow, accessorKey, "{}");
              } else {
                newRow[accessorKey] = row[accessorKey];
              }
            });
            mergedFieldValueData.push(newRow);
          });
          newFieldValue["table"] = {
            ..._.get(fieldData, "value"),
            data: mergedFieldValueData,
          };
        }
      }

      // For create mode, both table and tableAnswers will be same value
      if (_.isEqual("create", fieldMode)) {
        newFieldValue["table"] = {
          ...newFieldValue["table"],
          data: tableAnswers,
        };
      }

      // For Preview, table answers should not be shown
      if (_.isEqual("preview", fieldMode)) {
        const emptyTable = [];
        const cols = _.get(newFieldValue, ["table", "columns"]);
        _.forEach(_.get(newFieldValue, ["tableAnswers"]), row => {
          const newRow = { id: _.get(row, "id") };
          _.forEach(cols, col => {
            const accessorKey = _.get(col, "accessorKey");
            if (_.isEmpty(row[accessorKey])) {
              newRow[accessorKey] = "{}";
            } else {
              newRow[accessorKey] = row[accessorKey];
            }
          });
          emptyTable.push(newRow);
        });
        newFieldValue["table"] = {
          ...newFieldValue["table"],
          data: emptyTable,
        };
      }

      // For restricted-assessment-view, table answers should be blanks
      if (_.isEqual("restricted-view", fieldMode)) {
        const emptyTableAnswers = [];
        const cols = _.get(newFieldValue, ["table", "columns"]);
        _.forEach(_.get(newFieldValue, ["table", "data"]), row => {
          const newRow = { id: _.get(row, "id") };
          _.forEach(cols, col => {
            const accessorKey = _.get(col, "accessorKey");
            if (_.isEqual(row[accessorKey], tableInputFormat)) {
              newRow[accessorKey] = "{}";
            } else {
              newRow[accessorKey] = row[accessorKey];
            }
          });
          emptyTableAnswers.push(newRow);
        });
        newFieldValue["table"] = {
          ...newFieldValue["table"],
          data: emptyTableAnswers,
        };
      }

      fieldValue = newFieldValue;
      break;
    }
    case FIELD_UID_MATCHING: {
      const newFieldValue = {};
      if (_.isNil(fieldValue)) {
        newFieldValue["matchingPairs"] = _.get(
          _.find(questionFields, item => {
            return _.get(item, "uid", "") === FIELD_UID_MATCHING;
          }),
          "value"
        );
      } else {
        newFieldValue["matchingPairs"] = fieldValue;
      }
      const matchingPairAnswers = _.get(
        _.find(questionFields, item => {
          return _.get(item, "uid", "") === FIELD_UID_MATCHING_ANSWERS;
        }),
        "value"
      );
      if (!_.isNil(matchingPairAnswers)) {
        newFieldValue["matchingPairAnswers"] = matchingPairAnswers;
      }
      fieldValue = newFieldValue;
      break;
    }
    case FIELD_UID_LABELLING:
    case FIELD_UID_LABELLING_RESPONSE: {
      const answerField = _.find(questionFields, {
        uid: FIELD_UID_LABELLING_ANSWERS,
      });

      let labellingAnswer = _.get(answerField, "value", {}) || {};
      if (!_.isObject(labellingAnswer)) labellingAnswer = {};

      const answers = _.get(fieldValue, "answers");
      let elements = _.get(fieldValue, "elements", []);

      if (!fieldValue) fieldValue = {};

      if (!_.get(fieldValue, "elements")) {
        // * Get elements from labelling elements or response if not exist in fieldValue
        const elementData = _.find(questionFields, ({ uid }) =>
          [FIELD_UID_LABELLING, FIELD_UID_LABELLING_RESPONSE].includes(uid)
        );
        elements = _.get(elementData, "value.elements", []);
      }

      // * Update field value with element
      if (!_.get(fieldValue, "elements")) {
        _.set(fieldValue, "elements", elements || []);
      }

      // * Update field value with labelling answer
      if (labellingAnswer && _.isObject(fieldValue)) {
        fieldValue = { ...fieldValue, labellingAnswer };
      }

      // * Update field value with answer
      if (answers && _.isArray(answers)) {
        fieldValue = { ...fieldValue, answers };
      }

      break;
    }
    default:
      break;
  }

  const shouldSanitizeHTML =
    _.isEqual(questionFieldType, FIELD_TYPE_RICHTEXT_PORTED) &&
    _.isEqual(fieldMode, "view");

  if (shouldSanitizeHTML) {
    fieldValue = getStyleStrippedText({
      text: fieldValue,
      type: "DOCUMENT_EDITOR",
    });
  }

  return fieldValue;
};

/**
 *
 * @param {Object} fields - list of the dynamic fields that added to the question
 * @param {Function} t
 * @returns - list of dynamic fields options that are not already added to the question
 */

/**
 * @description - check if score is two digit decimal with one leading zero
 * @updated_logic
 * - Score can be decimal value
 * - After decimal there can be only one or two digit
 * - Checked, there shouldn't be multiple decimal points
 */
export const checkScoreFieldValidity = number => {
  return !isNaN(number) && DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX.test(number);
};

/**
 *
 * @description - util to check if the question type is allowed in the dropdown based on it's permission and the context of the dropdown
 */
export const getFilteredQuestionTypeOptions = (options, isSubQuestion, t) => {
  const filteredOptions = [];

  options.forEach(option => {
    const typeDetails = _.get(QUESTION_TYPE_DETAILS, option, {});

    let isEnabled = true;

    if (isSubQuestion) {
      isEnabled = isEnabled && _.get(typeDetails, "isSubQuestion", false);
    }

    if (!_.isNil(_.get(typeDetails, "perm"))) {
      isEnabled = isEnabled && ACLStore.can(typeDetails.perm);
    }

    if (isEnabled) {
      const label = t(
        getLocaleLabelFromQuestionDetails({
          questionTypeDetails: typeDetails,
        })
      );
      const icon = getIconFromQuestionDetails({
        questionTypeDetails: typeDetails,
      });

      filteredOptions.push({
        key: _.get(typeDetails, "key"),
        label,
        icon,
        isQuestionCreationMethod: _.get(
          typeDetails,
          "isQuestionCreationMethod",
          false
        ),
      });
    }
  });

  return filteredOptions;
};

/**
 * @returns - list of options for the add question dropdown
 */

/**
 * @description generating question types dropdown options
 * @returns list of groupedOptions for the add question dropdown V2, content option (Text/Content box - Add instructions)
 */
export const getQuestionDropdownOptionsV2 = ({
  t,
  isSubQuestion,
  curriculumType,
  isFromInternalTool,
}) => {
  const isWorksheetAIEnabled = getIsWorksheetAIEnabled();

  const FILTERED_QUESTION_TYPES_V2 = !isWorksheetAIEnabled
    ? _.filter(
        QUESTION_TYPES_V2,
        option => option !== GENERATE_USING_AI && option !== EXTRACT_FROM_DOC
      )
    : QUESTION_TYPES_V2;

  const options = getFilteredQuestionTypeOptions(
    FILTERED_QUESTION_TYPES_V2,
    isSubQuestion,
    t
  );

  const { isDP, isMYP } = curriculumTypeObj({ curriculumType });

  const globalGradeUid = getGlobalGradeUid();
  const isEligibleMYPGrade = isMYP && getIsMYPGrade({ globalGradeUid });

  const showToddleLibraryImport =
    isDP || (isEligibleMYPGrade && isMYPWorksheetEnabledForLibrary());

  const groupedOptions = [];
  const group1 = [],
    group2 = [];

  _.forEach(options, option => {
    const optionKey = _.get(option, "key");

    switch (optionKey) {
      case GENERATE_USING_AI:
      case EXTRACT_FROM_DOC:
        group1.push(option);
        break;

      case ADD_QUESTION_FROM_LIBRARY:
        if (!isFromInternalTool) {
          if (showToddleLibraryImport) {
            group1.push({
              ...option,
              label: t("toddleLibrary:import_from_toddle_library"),
            });
          } else {
            group1.push({
              ...option,
              label: t("worksheet:import_from_school_library"),
            });
          }
        }
        break;

      default:
        group2.push(option);
        break;
    }
  });

  if (!_.isEmpty(group1)) groupedOptions.push(group1);
  groupedOptions.push(group2);

  const contentOption = getFilteredQuestionTypeOptions(
    [CONTENT_UID_TEXT_BOX],
    isSubQuestion,
    t
  )[0];

  const separatorOption = getFilteredQuestionTypeOptions(
    [QUESTION_UID_SEPARATOR],
    isSubQuestion,
    t
  )[0];

  return {
    groupedOptions,
    contentOption,
    separatorOption,
  };
};

/**
 * Calculates the total number of questions attempted across all sections, based on their submissions.
 * @param {Array} sections - An array of section objects. Each section contains a list of questions.
 * @param {Object} submissions - contains submitted answers for questions.
 * @returns - attempted question count
 */
export const getAttemptedQuestionCount = ({
  sections = [],
  submissions = {},
}) => {
  let attemptedQuestionCount = 0;

  if (!_.isEmpty(sections) && !_.isEmpty(submissions)) {
    const submissionNodes = _.map(_.get(submissions, "edges", []), "node");

    sections.forEach(section => {
      _.get(section, "node.childrenV2.edges", []).forEach(question => {
        const questionItem = _.get(question, "node.item");
        const questionTypeUid = _.get(questionItem, "questionType.uid");
        const questionId = _.get(questionItem, "id");

        switch (questionTypeUid) {
          case CONTENT_UID_TEXT_BOX:
            /** not a question */
            break;
          case QUESTION_UID_MULTI_PART: {
            /** check if all sub question responses are empty */
            const subQuestions = _.get(question, "node.childrenV2.edges", []);
            let areSubQuestionsAttempted = true;

            subQuestions.forEach(subQuestion => {
              const subQuestionItem = _.get(subQuestion, "node.item");
              const submission = getQuestionSubmissionItem({
                questionId: _.get(subQuestion, "node.item.id"),
                submissions: submissionNodes,
              });

              const subQuestionTypeUid = _.get(
                subQuestionItem,
                "questionType.uid"
              );

              if (isVisualWorksheetElement(subQuestionTypeUid)) return;

              areSubQuestionsAttempted =
                areSubQuestionsAttempted &&
                getIsQuestionAttempted({
                  question: subQuestionItem,
                  submission,
                });
            });

            if (areSubQuestionsAttempted) {
              attemptedQuestionCount++;
            }

            break;
          }
          default: {
            const submission = getQuestionSubmissionItem({
              questionId,
              submissions: submissionNodes,
            });

            if (
              getIsQuestionAttempted({ question: questionItem, submission })
            ) {
              attemptedQuestionCount++;
            }

            break;
          }
        }
      });
    });
  }

  return attemptedQuestionCount;
};

export const checkScoreValueValidity = ({ newScoreValue, maxMarks }) => {
  const scoreFloat = parseFloat(newScoreValue);

  // allow only numbers and upto 2 decimals
  if (!DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX.test(newScoreValue) && newScoreValue)
    return false;

  // Do not update if the entered value is more than max score
  if (scoreFloat > parseFloat(maxMarks)) return false;

  return true;
};

export const checkQuestionNumberValidity = ({
  numberOfQuestions,
  totalNumberOfQuestions,
}) => {
  if (_.isNil(numberOfQuestions)) return false;
  const num = _.toInteger(numberOfQuestions);

  var reg = /^\d+$/;
  if (!reg.test(numberOfQuestions) && numberOfQuestions) return false;
  if (num > totalNumberOfQuestions) return false;

  return true;
};

/** @returns - a boolean of whether subQuestion is selected */
export const getIsSubQuestionSelected = ({
  subQuestions = [],
  activeQuestion,
}) => {
  return _.some(
    subQuestions,
    subQuestion => _.get(subQuestion, "id") == activeQuestion
  );
};

/** @returns - a boolean of whether field is empty */
export const getIsFieldEmpty = ({ value, fieldUid }) => {
  switch (fieldUid) {
    case FIELD_UID_ANSWER:
    case FIELD_UID_TEACHER_NOTES:
    case FIELD_UID_TITLE:
    case FIELD_UID_RESPONSE:
    case FIELD_UID_BLANKS:
      return (
        _.isEmpty(extractDataFromHTML({ value, uid: fieldUid })) &&
        !checkForImageInHtmlString(value) &&
        !checkForIframeEmbedInHtmlString(value) &&
        !checkForVideoInHtmlString(value)
      );
    case FIELD_UID_RADIO: {
      return _.isEmpty(_.get(value, [0, "correct"], ""));
    }
    case FIELD_UID_MCQ_CHOICES: {
      return (
        _.isEmpty(value) ||
        _.some(value, choice =>
          getIsFieldEmpty({
            value: _.get(choice, "value", ""),
            fieldUid: FIELD_UID_TITLE /** placeholder uid for checking rich text value */,
          })
        )
      );
    }
    case FIELD_UID_MATCHING: {
      return _.isEmpty(_.get(value, "matchingPairs", ""));
    }
    default:
      return _.isEmpty(value);
  }
};

/**
 *
 * @param {Boolean} showOnlyOnActiveQuestion
 * @param {Boolean} isActiveQuestion
 * @param {Array} showOnlyOnModes
 * @param {String} mode
 * @param {String} value
 * @param {String} fieldUid
 * @param {Boolean} showDynamicFields
 * @param {Boolean} isSubQuestionSelected
 * @returns - a boolean of whether a field should be hidden
 */
export const getIsFieldHidden = ({
  showOnlyOnActiveQuestion,
  isActiveQuestion,
  showOnlyOnModes,
  mode,
  value,
  fieldUid,
  showDynamicFields,
  isSubQuestionSelected,
  id,
}) => {
  let hideField = false;

  if (_.includes(id, AI_GEN_IDENTIFIER) && _.isNull(value)) {
    return true;
  }
  const isFieldEmpty = getIsFieldEmpty({ value, fieldUid });
  const hideDynamicFieldsView = showDynamicFields
    ? !isSubQuestionSelected && !isActiveQuestion
    : !isActiveQuestion;

  switch (fieldUid) {
    case FIELD_UID_ANSWER: {
      if (
        (isFieldEmpty &&
          _.includes(
            [
              MODE_TEACHER_EVALUATE,
              MODE_STUDENT_EVALUATE,
              MODE_TEACHER_VIEW,
              MODE_RESTRICTED_ASSESSMENT_VIEW,
            ],
            mode
          )) ||
        (mode == MODE_TEACHER_CREATE && hideDynamicFieldsView)
      ) {
        hideField = true;
      }
      break;
    }

    case FIELD_UID_TEACHER_NOTES: {
      if (
        (isFieldEmpty &&
          _.includes([MODE_TEACHER_EVALUATE, MODE_TEACHER_VIEW], mode)) ||
        (mode == MODE_TEACHER_CREATE && hideDynamicFieldsView) ||
        mode == MODE_STUDENT_EVALUATE
      ) {
        hideField = true;
      }
      break;
    }
    case FIELD_UID_SETTINGS: {
      if (
        (mode == MODE_TEACHER_CREATE && !isActiveQuestion) ||
        mode !== MODE_TEACHER_CREATE
      ) {
        hideField = true;
      }
      break;
    }
    case FIELD_UID_ASSESSMENT_TOOL: {
      if (
        (mode == MODE_TEACHER_CREATE && hideDynamicFieldsView) ||
        mode !== MODE_TEACHER_CREATE
      ) {
        hideField = true;
      }
      break;
    }
    case FIELD_UID_RESPONSE: {
      if (
        isFieldEmpty &&
        !_.includes([MODE_STUDENT_ATTEMPT, MODE_TEACHER_PREVIEW], mode)
      ) {
        hideField = true;
      }
      break;
    }
    case FIELD_UID_RESOURCES: {
      if (isFieldEmpty) {
        hideField = true;
      }
      break;
    }
    case FIELD_UID_AUDIO_RESPONSE:
    case FIELD_UID_VIDEO_RESPONSE: {
      if (
        isFieldEmpty &&
        !_.includes([MODE_STUDENT_ATTEMPT, MODE_TEACHER_PREVIEW], mode)
      ) {
        hideField = true;
      }
      break;
    }

    default: {
      /** check if field should only be visible when the question is selected */
      if (showOnlyOnActiveQuestion && !isActiveQuestion) {
        hideField = true;
      }

      /** check if field should be visible only on certain modes */
      if (!_.isEmpty(showOnlyOnModes) && !_.includes(showOnlyOnModes, mode)) {
        hideField = true;
      }
    }
  }
  return hideField;
};

/**
 *
 * @param {String} type
 * @param {String} viewType
 * @param {String} mode
 * @param {Boolean} isActiveQuestion
 * @param {Boolean} showDynamicFields
 * @param {Boolean} isSubQuestionSelected
 * @returns - either viewType or type based on the mode and active question
 */
export const getFieldType = ({
  type,
  viewType,
  mode,
  isActiveQuestion,
  showDynamicFields,
  isSubQuestionSelected,
}) => {
  let fieldType = type;

  if (!_.isNil(viewType)) {
    if (
      _.includes(
        [MODE_TEACHER_EVALUATE, MODE_TEACHER_VIEW, MODE_STUDENT_EVALUATE],
        mode
      ) ||
      (mode == MODE_TEACHER_CREATE && showDynamicFields
        ? !isSubQuestionSelected && !isActiveQuestion
        : !isActiveQuestion)
    ) {
      fieldType = viewType;
    }
  }

  return fieldType;
};

/**
 *
 * @param {mode}             String  - Worksheet mode
 * @param {fieldUid}         String  - Uid of the field
 * @param {isActiveQuestion} Boolean - if the current question is selected
 * @returns - the mode of the field component
 */
export const getFieldComponentMode = ({
  mode = "",
  fieldUid = "",
  isActiveQuestion = false,
}) => {
  switch (mode) {
    case MODE_TEACHER_CREATE: {
      switch (fieldUid) {
        case FIELD_UID_ASSESSMENT_TOOL:
          /** assessment tools are always in edit mode */
          return "edit";
        case FIELD_UID_GRAPH_TEMPLATE:
        case FIELD_UID_WORKBOOK_TEMPLATE:
          return "create";
        case FIELD_UID_TABLE:
        case FIELD_UID_MATCHING:
          return isActiveQuestion ? "create" : "preview";
        case FIELD_UID_MCQ_CHOICES:
        case FIELD_UID_BLANKS:
        case FIELD_UID_RADIO:
        case FIELD_UID_DRAG_AND_DROP:
        case FIELD_UID_FIND_HOTSPOT:
        case FIELD_UID_LABELLING:
        case FIELD_UID_VIDEO_RESPONSE:
          return isActiveQuestion ? "create" : "preview";
        default:
          return isActiveQuestion ? "edit" : "view";
      }
    }
    case MODE_ASSESSMENT_VIEW:
    case MODE_LIBRARY_VIEW: {
      switch (fieldUid) {
        case FIELD_UID_MCQ_CHOICES:
        case FIELD_UID_BLANKS:
        case FIELD_UID_RADIO:
        case FIELD_UID_TABLE:
          return "preview";
        case FIELD_UID_WORKBOOK_TEMPLATE:
          return "library_view";
        case FIELD_UID_LABELLING:
        case FIELD_UID_FIND_HOTSPOT:
        case FIELD_UID_DRAG_AND_DROP:
          return "solution_view";
        default:
          return "view";
      }
    }
    case MODE_STUDENT_ATTEMPT:
      return "edit";
    case MODE_TEACHER_PREVIEW:
      switch (fieldUid) {
        case FIELD_UID_GRAPH_RESPONSE:
        case FIELD_UID_WORKBOOK_RESPONSE:
        case FIELD_UID_DRAG_AND_DROP_RESPONSE:
        case FIELD_UID_FIND_HOTSPOT_RESPONSE:
        case FIELD_UID_LABELLING_RESPONSE:
        case FIELD_UID_VIDEO_RESPONSE:
          return "preview";
        case FIELD_UID_TABLE:
        case FIELD_UID_MCQ_RESPONSE:
          return "teacher-preview";
        default:
          return "edit";
      }
    case MODE_STUDENT_EVALUATE:
      switch (fieldUid) {
        case FIELD_UID_GRAPH_RESPONSE:
          return "view";
        case FIELD_UID_MCQ_RESPONSE:
        case FIELD_UID_BLANKS_RESPONSES:
        case FIELD_UID_RADIO:
        case FIELD_UID_TABLE:
        case FIELD_UID_MATCHING:
          return "evaluate";
        default:
          return "view";
      }
    case MODE_TEACHER_EVALUATE:
      switch (fieldUid) {
        case FIELD_UID_GRAPH_TEMPLATE:
        case FIELD_UID_GRAPH_RESPONSE:
        case FIELD_UID_TABLE:
          return "evaluate";
        case FIELD_UID_BLANKS_RESPONSES:
        case FIELD_UID_RADIO:
        case FIELD_UID_MCQ_CHOICES:
        case FIELD_UID_MCQ_RESPONSE:
        case FIELD_UID_WORKBOOK_RESPONSE:
        case FIELD_UID_MATCHING:
          return "evaluate";
        default:
          return "view";
      }
    case MODE_TEACHER_VIEW:
      switch (fieldUid) {
        case FIELD_UID_GRAPH_TEMPLATE:
        case FIELD_UID_MCQ_CHOICES:
        case FIELD_UID_MCQ_RESPONSE:
        case FIELD_UID_BLANKS_RESPONSES:
        case FIELD_UID_RADIO:
        case FIELD_UID_TABLE:
          return "evaluate";
        default:
          return "view";
      }
    case MODE_RESTRICTED_ASSESSMENT_VIEW:
      switch (fieldUid) {
        case FIELD_UID_RADIO:
        case FIELD_UID_TABLE:
        case FIELD_UID_MCQ_CHOICES:
          return "restricted-view";
        default:
          return "view";
      }
    default:
      return "view";
  }
};

/**
 *
 * @param {String} fieldValue - the value of the blanks field
 * @description - extracts the question text and the answers from the blanks field value
 */
export const decodeBlanksContent = (fieldValue = "") => {
  /** 1. get the text part of the html */
  const fieldTextValue = extractContentFromHTML({
    htmlString: fieldValue,
  });

  /** 2. get the answers array and the question text without the answer */
  const answers = [];
  let questionText = fieldValue;

  let start = -1;
  let end = -1;

  for (let i = 0; i < _.size(fieldValue); i++) {
    if (fieldValue[i] == BLANKS_ANSWER_START_CHAR && start == -1) {
      start = i;
    } else if (fieldValue[i] == BLANKS_ANSWER_END_CHAR && start > -1) {
      end = i;

      const blankContent = fieldValue.substring(start, end + 1);

      if (_.includes(fieldTextValue, _.unescape(blankContent))) {
        questionText = _.replace(
          questionText,
          blankContent,
          BLANKS_ANSWER_REPLACEMENT
        );
      }

      start = -1;
      end = -1;
    }
  }

  for (let i = 0; i < fieldTextValue.length; i++) {
    if (fieldTextValue[i] == BLANKS_ANSWER_START_CHAR && start == -1) {
      start = i;
    } else if (fieldTextValue[i] == BLANKS_ANSWER_END_CHAR && start > -1) {
      end = i;

      answers.push(
        _.trim(fieldTextValue.substring(start + 1, end)).split(
          BLANKS_ANSWER_SEPARATOR
        )
      );

      start = -1;
      end = -1;
    }
  }

  return { questionText, answers };
};

// Recursively removes empty non-void leaf elements (e.g. <span></span> left
// behind when } sits at position 0 of a span's text node).
const removeEmptyLeaves = el => {
  const BLANK_VOID_ELEMENTS = ["img", "br", "hr", "col", "embed"];

  _.forEach(_.toArray(el.children), child => {
    removeEmptyLeaves(child);
    if (
      _.isEmpty(_.trim(child.innerHTML)) &&
      !_.includes(BLANK_VOID_ELEMENTS, _.toLower(child.tagName))
    ) {
      child.remove();
    }
  });
};

// Builds the answer options array from the extracted blank content.
// Splits innerHTML by the separator; the browser auto-completes any broken
// tags when each part is assigned to innerHTML.
const buildAnswerOptions = tempDiv => {
  return _.map(
    _.trim(tempDiv.innerHTML).split(BLANKS_ANSWER_SEPARATOR),
    part => {
      const partDiv = document.createElement("div");
      partDiv.innerHTML = _.trim(part);
      return _.trim(partDiv.innerHTML);
    }
  );
};

export const decodeBlanksContentDocEditor = (fieldValue = "") => {
  if (!fieldValue) return { questionText: "", answers: [] };

  const parser = new DOMParser();
  const doc = parser.parseFromString(fieldValue, "text/html");
  const answers = [];

  // Processes one blank at a time; returns true if a blank was found.
  // We restart the walker after each DOM mutation.
  const findAndReplaceNextBlank = () => {
    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
    let startNode = null;
    let startOffset = -1;
    let node;

    while ((node = walker.nextNode())) {
      const text = node.nodeValue;
      for (let i = 0; i < text.length; i++) {
        if (text[i] === BLANKS_ANSWER_START_CHAR && startNode === null) {
          startNode = node;
          startOffset = i;
        } else if (text[i] === BLANKS_ANSWER_END_CHAR && startNode !== null) {
          // Extract the HTML between { and }
          const innerRange = doc.createRange();
          innerRange.setStart(startNode, startOffset + 1); // after {
          innerRange.setEnd(node, i); // before }

          const fragment = innerRange.cloneContents();
          const tempDiv = doc.createElement("div");
          tempDiv.appendChild(fragment);

          removeEmptyLeaves(tempDiv);
          answers.push(buildAnswerOptions(tempDiv));

          // Replace the full {…} span (including surrounding elements) with &BLANKS&
          const outerRange = doc.createRange();
          outerRange.setStart(startNode, startOffset);
          outerRange.setEnd(node, i + 1);
          outerRange.deleteContents();
          outerRange.insertNode(doc.createTextNode(BLANKS_ANSWER_REPLACEMENT));

          return true; // Restart the walker after DOM mutation
        }
      }
    }
    return false;
  };

  while (findAndReplaceNextBlank()) {
    // keep going until all blanks are processed
  }

  return { questionText: doc.body.innerHTML, answers };
};

//Takes table data as input and gives an object that returns row and col position of answer cell.
export const getTableAnswers = (data, headerType) => {
  const hasRowHeader = _.includes(headerType, "ROW");
  const hasColHeader = _.includes(headerType, "COL");
  const answers = [];
  _.forEach(data, (row, rowIndex) => {
    const isRowHeader = hasRowHeader && rowIndex == 0;
    if (isRowHeader) return;
    const newRow = { id: _.get(row, "id") };
    let colIndex = 0;
    _.forEach(row, (col, colKey) => {
      const isColHeader = hasColHeader && colIndex === 1;
      colIndex++;
      if (isColHeader || colKey === "id") return;
      const colValue = extractTextWithLatex(col);
      if (
        _.isEmpty(colValue) ||
        (_.isEqual(colValue.at(0), TABLE_INPUT_START_CHAR) &&
          _.isEqual(colValue.at(-1), TABLE_INPUT_END_CHAR))
      ) {
        newRow[colKey] = col;
      }
    });
    answers.push(newRow);
  });
  return answers;
};

// Take table data and removes answers form it, instead and special marker for answer cell.
export const getTableWithoutAnswers = data => {
  const tableData = _.get(data, "data", []);
  const headerType = _.get(data, "headerType", []);
  const hasRowHeader = _.includes(headerType, "ROW");
  const hasColHeader = _.includes(headerType, "COL");
  const table = _.cloneDeep(tableData);
  _.forEach(table, (row, rowIndex) => {
    const isRowHeader = hasRowHeader && rowIndex == 0;
    if (isRowHeader) return;
    let colIndex = 0;
    _.forEach(row, (col, colKey) => {
      const isColHeader = hasColHeader && colIndex === 1;
      colIndex++;
      if (isColHeader || colKey === "id") return;
      const colValue = extractTextWithLatex(col);
      if (
        _.isEmpty(colValue) ||
        (_.isEqual(colValue.at(0), TABLE_INPUT_START_CHAR) &&
          _.isEqual(colValue.at(-1), TABLE_INPUT_END_CHAR))
      ) {
        table[rowIndex][colKey] = tableInputFormat;
      }
    });
  });
  return { ...data, data: table };
};

/**
 * @param {String} question - question text
 * @param {Array} answers - list of answers
 * @param {Object} responses - list of responses
 * @param {String} mode - field component mode
 * @param {Function} t - Locales function
 * @description - embeds input fields for the blanks in the question html wherever required
 */
export const encodeBlanksContent = ({
  question,
  answers,
  responses,
  mode,
  t,
  isAiGeneratedField = false,
}) => {
  let blankIndex = 0;

  const encodedHtml = _.replace(question, BLANKS_ANSWER_REGEX, () => {
    const answerArray = _.get(answers, blankIndex, []);
    const answerBlock = _.join(
      answerArray,
      isAiGeneratedField ? "" : BLANKS_ANSWER_SEPARATOR
    );

    const placeholder =
      (_.isEqual(mode, "preview") || _.isEqual(mode, "insight")) &&
      !_.isEqual(mode, "restricted-view")
        ? extractContentFromHTML({ htmlString: answerBlock })
        : null;

    const inputValue = _.includes(["view", "evaluate"], mode)
      ? _.get(responses, blankIndex, "")
      : null;

    blankIndex++;

    return ReactDOMServer.renderToString(
      <BlanksInput
        mode={mode}
        placeholder={placeholder}
        name={blankIndex - 1}
        value={inputValue}
        answerBlock={_.isEqual(mode, "evaluate") ? answerBlock : null}
        answerArray={_.isEqual(mode, "evaluate") ? answerArray : null}
        t={t}
      />
    );
  });

  return removeEmptyLines(encodedHtml);
};

// Replaces each {answer} token in the question HTML with a __BLANK_N__ placeholder
// and builds a blanksMeta map with per-mode render data for each blank.
export const encodeBlanksContentDocEditor = ({
  question,
  answers,
  responses,
  mode,
  t,
  isAiGeneratedField = false,
  onInputChange = _.noop,
}) => {
  let blankIndex = 0;
  const blanksMeta = {};

  const encodedHtml = _.replace(question, BLANKS_ANSWER_REGEX, () => {
    const answerArray = _.get(answers, blankIndex, []);
    const answerBlock = _.join(
      answerArray,
      isAiGeneratedField ? "" : BLANKS_ANSWER_SEPARATOR
    );

    const placeholder =
      (_.isEqual(mode, "preview") || _.isEqual(mode, "insight")) &&
      !_.isEqual(mode, "restricted-view")
        ? answerBlock
        : null;

    blanksMeta[blankIndex] = {
      value: _.get(responses, blankIndex, ""),
      placeholder,
      answerBlock: _.isEqual(mode, "evaluate") ? answerBlock : null,
      answerArray: _.isEqual(mode, "evaluate") ? answerArray : null,
      mode,
      t,
      responses,
      onInputChange,
    };

    const currentIndex = blankIndex;
    blankIndex++;

    return `__BLANK_${currentIndex}__`;
  });

  return {
    html: removeEmptyLines(encodedHtml),
    blanksMeta,
  };
};
export const getResolvedFieldLabel = (labelText, isRequired = false) =>
  isRequired ? `${labelText}*` : labelText;

export const getMcqResponseValue = ({
  questions = [],
  answers = [],
  submissions = [],
}) => {
  return _.map(questions, question => {
    const answerItem = _.find(answers, answer => {
      return answer?.id === question?.id;
    });

    const submissionItem = _.find(submissions, submission => {
      return submission?.id === question?.id;
    });

    return {
      id: question.id,
      value: question.value,
      isStudentSelected: _.get(submissionItem, "isStudentSelected", false),
      isCorrect: _.get(answerItem, "isSelected", false),
    };
  });
};

/**
 * @deprecated use getErrorCountV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
export const getErrorCount = (data, errorState) => {
  let errorCount = 0;

  const filteredErrorStates = _.keys(_.pickBy(errorState, _.identity));

  _.forEach(data, section => {
    const questionEdges = _.get(section, "childrenV2.edges", []);
    _.forEach(questionEdges, questionEdge => {
      const question = _.get(questionEdge, "node.item", null);
      if (!_.isEmpty(question)) {
        const questionId = _.get(question, "id");

        if (_.includes(filteredErrorStates, questionId)) {
          errorCount += 1;
        }
      }

      const subQuestionEdges = _.get(questionEdge, "node.childrenV2.edges", []);
      _.some(subQuestionEdges, subQuestionEdge => {
        const subQuestion = _.get(subQuestionEdge, "node.item", null);
        if (!_.isEmpty(subQuestion)) {
          const subQuestionId = _.get(subQuestion, "id");
          if (_.includes(filteredErrorStates, subQuestionId)) {
            errorCount += 1;
            return true;
          }
        }
        return false;
      });
    });
  });

  return errorCount;
};

export const isValidRevamped = (
  currentFields,
  errors = [],
  setErrors = () => {}
) => {
  let totalErrorCount = 0;
  const errorsList = [];

  // check if score is not empty
  const scoreField = _.find(currentFields, { uid: FIELD_UID_SCORE });
  const isFieldEmpty = getIsFieldEmpty({
    value: _.get(scoreField, "value"),
    fieldUid: FIELD_UID_SCORE,
  });
  if (scoreField && isFieldEmpty) {
    totalErrorCount++;
    errorsList.push(_.get(FIELD_ERROR_MESSAGES, FIELD_UID_SCORE));
  }

  // check all fields are valid
  _.forEach(currentFields, currentField => {
    const key = _.get(currentField, "uid", null);
    let errorMsg = "";
    errorMsg = validateCustomQuestionFieldRevamped({
      fieldUid: key,
      value: _.get(_.find(currentFields, { uid: key }), "value", ""),
    });

    if (!_.isEmpty(errorMsg)) {
      totalErrorCount++;
      errorsList.push(errorMsg);
    }
  });

  // update error list
  if (!_.isEqual(errors, errorsList)) {
    setErrors?.(errorsList);
  }

  return totalErrorCount;
};

export const validateCustomQuestionFieldRevamped = ({ fieldUid, value }) => {
  switch (fieldUid) {
    case FIELD_UID_TITLE /** Check if title is empty **/:
      return getIsFieldEmpty({ value, fieldUid })
        ? "worksheet:enter_question_text"
        : "";
    case FIELD_UID_MCQ_CHOICES /** Check if there is any non-empty option */: {
      return getIsFieldEmpty({ value, fieldUid })
        ? "toastMsgs:please_fill_all_required_fields"
        : "";
    }
    case FIELD_UID_MCQ_ANSWERS: {
      /** Check if correct option is selected **/
      const isCorrectAnswerSelected = _.some(value, option =>
        _.get(option, "isSelected")
      );

      return !isCorrectAnswerSelected
        ? _.get(FIELD_ERROR_MESSAGES, FIELD_UID_MCQ_CHOICES, "")
        : "";
    }
    case FIELD_UID_BLANKS: {
      /** check if field is not empty and that there are any blanks */
      const isFieldEmpty = getIsFieldEmpty({ value, fieldUid });

      if (isFieldEmpty) {
        return "worksheet:enter_question_text";
      } else {
        return "";
      }
    }
    case FIELD_UID_BLANKS_ANSWERS: {
      /** Check if there are no blanks or if blanks are empty **/
      const answers = _.get(value, "answers", []);
      const isBlanksEmpty = _.isEmpty(answers);
      const areBlanksEmpty = _.some(answers, answer =>
        _.isEmpty(_.first(answer))
      );

      if (isBlanksEmpty) {
        return "worksheet:blanks_correct_answer_toast";
      } else if (areBlanksEmpty) {
        return "toastMsgs:please_fill_all_required_fields";
      } else {
        return "";
      }
    }
    case FIELD_UID_RADIO /** Check if one of the options: "true" or "false" is selected  */: {
      return _.isEmpty(value)
        ? "toastMsgs:please_fill_all_required_fields"
        : "";
    }
    case FIELD_UID_DRAG_AND_DROP: {
      const elements = _.get(value, "elements");
      const dropzoneItems = _.find(elements, { category: "DROPZONE" });
      const draggableItems = _.find(elements, { category: "DRAGGABLE" });

      if (_.isEmpty(dropzoneItems)) {
        return "worksheet:no_dropzone_items";
      }
      if (_.isEmpty(draggableItems)) {
        return "worksheet:no_draggable_item";
      }
      return "";
    }
    case FIELD_UID_DRAG_AND_DROP_ANSWERS: {
      if (_.isEmpty(value)) {
        return "worksheet:dropzone_not_tagged";
      }
      return "";
    }
    case FIELD_UID_FIND_HOTSPOT: {
      const elements = _.get(value, "elements");
      const hotspotZones = _.find(elements, { category: "DROPZONE" });
      if (_.isEmpty(hotspotZones)) {
        return "worksheet:no_hotspots";
      }
      return "";
    }
    case FIELD_UID_FIND_HOTSPOT_ANSWERS: {
      if (_.isEmpty(value)) {
        return "worksheet:hotspots_not_marked";
      }
      return "";
    }
    case FIELD_UID_TABLE: {
      const data = _.get(value, "data", []);
      const hasAnswerValue = _.some(data, item =>
        _.some(_.values(item), value => value === tableInputFormat)
      );

      // check if we have atleast one blank
      if (!hasAnswerValue) {
        return "worksheet:no_blanks_table";
      }
      return "";
    }
    case FIELD_UID_MATCHING: {
      const showDocEditor = getIsWorksheetDocEditorEnabled();
      const matchingPairs = _.get(value, "matchingPairs", []);

      // Check if at least one prompt has a non-empty value
      const arePromptsPresent = _.some(matchingPairs, item => {
        const promptValue = _.get(item, "prompt.value", "");
        return !_.isEmpty(
          showDocEditor
            ? extractContentWithMediaFromHTML({
                htmlString: _.toString(promptValue),
              })
            : promptValue
        );
      });

      if (!arePromptsPresent) {
        return "worksheet:no_prompts";
      }

      // Check if all elements have non-empty answer value
      const areAnswersPresent = _.every(matchingPairs, item => {
        const answerValue = _.get(item, "answer.value", "");
        return !_.isEmpty(
          showDocEditor
            ? extractContentWithMediaFromHTML({
                htmlString: _.toString(answerValue),
              })
            : answerValue
        );
      });

      if (!areAnswersPresent) {
        return "toastMsgs:please_fill_all_required_fields";
      }

      // check if two non-empty answer values are present
      const answerValues = _.filter(
        matchingPairs,
        item => !_.isEmpty(_.get(item, "answer.value"))
      );

      if (_.size(answerValues) < 2) {
        return "worksheet:no_answers";
      }
      return "";
    }
    case FIELD_UID_LABELLING: {
      const elements = _.get(value, "elements", []);

      // check if atleast one label is present
      const hasLabels = _.some(elements, item => {
        return _.get(item, "category", "") === LABELLING_CATEGORY.LABEL;
      });

      if (!hasLabels) {
        return "worksheet:no_labels";
      }
      return "";
    }
    default:
      return "";
  }
};

export const validateCustomQuestionField = ({ fieldUid, value }) => {
  switch (fieldUid) {
    case FIELD_UID_RADIO /** Check if one of the options: "true" or "false" is selected  */: {
      return getIsFieldEmpty({ value, fieldUid })
        ? "toastMsgs:please_fill_all_required_fields"
        : "";
    }
    case FIELD_UID_MCQ_CHOICES /** Check if there is any non-empty option */: {
      const isCorrectAnswerSelected = _.some(value, option =>
        _.get(option, "isSelected")
      );

      return getIsFieldEmpty({ value, fieldUid }) || !isCorrectAnswerSelected
        ? "toastMsgs:please_fill_all_required_fields"
        : "";
    }
    case FIELD_UID_BLANKS: {
      /** check if field is not empty and that there are any blanks */
      const showDocEditor = getIsWorksheetDocEditorEnabled();
      const decodedBlanks = showDocEditor
        ? decodeBlanksContentDocEditor(value || "")
        : decodeBlanksContent(value || "");

      const isFieldEmpty = getIsFieldEmpty({ value, fieldUid });
      const isBlanksEmpty = _.isEmpty(_.get(decodedBlanks, "answers", []));

      if (isFieldEmpty) {
        return "worksheet:enter_question_text";
      } else if (isBlanksEmpty) {
        return "worksheet:blanks_correct_answer_toast";
      } else {
        return "";
      }
    }
    default:
      return "";
  }
};

/**
 * @description - Generates a dummy question field entity in apollo cache
 *  for the given field uid and returns the dummy field
 */
export const generateDummyQuestionsFieldsInCache = ({ field }) => {
  const dummyFieldId = generateRandomId();

  const dummyField = {
    id: dummyFieldId,
    uid: field,
    value: null,
    resolveFields: {
      id: generateRandomId(),
      type: "UNDEFINED_ENTITY",
      __typename: "UndefinedEntity",
    },
    resolvedMinimalTree: {
      __typename: "UndefinedEntity",
    },
    __typename: "QuestionFields",
  };

  writeQuestionFieldsInCache({ id: dummyFieldId, data: dummyField });

  return dummyField;
};

/**
 * Generates submission objects for an array of questions, creating appropriate fields
 * based on each question's configuration.
 *
 * @param {Array} questionArray - An array of question objects to generate submissions for
 * @returns {Array} An array of submission objects with appropriate fields and metadata
 */
export const getDummySubmissionsFromQuestions = questionArray => {
  return _.reduce(
    questionArray,
    (acc, question) => {
      const studentFields = _.keys(
        _.get(question, "questionType.config.student_field_list", {})
      );
      const questionData = {
        id: _.get(question, "id"),
        __typename: "Question",
      };
      const submission = {
        id: generateRandomId(),
        fields: _.map(studentFields, field =>
          generateDummyQuestionsFieldsInCache({ field })
        ),
        question: questionData,
        toolResponses: [],
        ibPYPElementRatings: [],
        elementRemarks: null,
        __typename: "QuestionSubmission",
      };

      acc.push(submission);

      return acc;
    },
    []
  );
};

/**
 * @deprecated use getDummyWorksheetSubmissionV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
/**
 * @description - Creates an array of mock question submission based on
 * the question type configuration
 */
export const getDummyWorksheetSubmission = _.once(({ sections = [] }) => {
  const questionArray = [];

  _.forEach(sections, item => {
    const questionEdgeArray = _.get(item, "childrenV2.edges", []);

    _.forEach(questionEdgeArray, questionEdge => {
      const question = _.get(questionEdge, "node.item", {});

      questionArray.push(question);

      _.get(questionEdge, "node.childrenV2.edges", []).forEach(
        subQuestionEdge => {
          const subQuestion = _.get(subQuestionEdge, "node.item", {});

          questionArray.push(subQuestion);
        }
      );
    });
  });

  return getDummySubmissionsFromQuestions(questionArray);
});

export const getUpdatedSubmissionFieldsFromCache = fields => {
  return _.map(fields, field => {
    const id = _.get(field, "id");

    return getQuestionFieldsFromCache({ id });
  });
};

export const getReorderedWorksheetCacheData = ({
  cacheData,
  fromIndex,
  toIndex,
  oldParentResourceId,
  newParentResourceId,
  resourceType,
  switchParent,
  oldParentId,
  newParentId,
}) => {
  const organizationResources = _.get(
    cacheData,
    "organizationResourcesV2.edges[0].node.childrenV2.edges",
    []
  );
  const isMutationsV2Enabled = isWorksheetMutationsV2Enabled();
  if (resourceType == RESOURCE_TYPE_FOLDER) {
    const updatedOrganizationResources = moveElementInArray({
      array: organizationResources,
      fromIndex: fromIndex,
      toIndex: toIndex,
    });

    return update(cacheData, {
      organizationResourcesV2: {
        edges: {
          [0]: {
            node: {
              childrenV2: {
                edges: {
                  $set: updatedOrganizationResources,
                },
              },
            },
          },
        },
      },
    });
  } else if (resourceType == RESOURCE_TYPE_QUESTION) {
    const sectionIndex = _.findIndex(organizationResources, resource =>
      isMutationsV2Enabled
        ? _.isEqual(_.get(resource, "node.item.id"), oldParentId)
        : _.isEqual(_.get(resource, "node.id"), oldParentResourceId)
    );

    if (sectionIndex == -1) return cacheData;

    if (switchParent) {
      const newSectionIndex = _.findIndex(organizationResources, resource =>
        isMutationsV2Enabled
          ? _.isEqual(_.get(resource, "node.item.id"), newParentId)
          : _.isEqual(_.get(resource, "node.id"), newParentResourceId)
      );

      if (newSectionIndex == -1) return cacheData;

      const questionResource = _.get(
        organizationResources,
        [sectionIndex, "node", "childrenV2", "edges", fromIndex],
        {}
      );

      /** remove from old section and add to new section */
      return update(cacheData, {
        organizationResourcesV2: {
          edges: {
            [0]: {
              node: {
                childrenV2: {
                  edges: {
                    [newSectionIndex]: {
                      node: {
                        childrenV2: {
                          edges: {
                            $splice: [[toIndex, 0, questionResource]],
                          },
                        },
                      },
                    },
                    [sectionIndex]: {
                      node: {
                        childrenV2: {
                          edges: {
                            $splice: [[fromIndex, 1]],
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      });
    } else {
      const sectionResources = _.get(
        organizationResources,
        [sectionIndex, "node", "childrenV2", "edges"],
        []
      );

      const updatedSectionResource = moveElementInArray({
        array: sectionResources,
        fromIndex: fromIndex,
        toIndex: toIndex,
      });

      return update(cacheData, {
        organizationResourcesV2: {
          edges: {
            [0]: {
              node: {
                childrenV2: {
                  edges: {
                    [sectionIndex]: {
                      node: {
                        childrenV2: {
                          edges: {
                            $set: updatedSectionResource,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      });
    }
  }
};

const getQuestionLabelWithCount = ({ questionTypeUid, count, t }) => {
  let label = "";
  switch (questionTypeUid) {
    case QUESTION_UID_TEXT_RESPONSE_V3:
      label = t("worksheet:text_response_with_count", { count });
      break;
    case QUESTION_UID_TRUE_FALSE_V2:
      label = t("worksheet:true_or_false_with_count", { count });
      break;
    case QUESTION_UID_MULTI_PART:
      label = t("worksheet:multipart_with_count", { count });
      break;
    case QUESTION_UID_BLANKS:
      label = t("worksheet:fill_in_the_blank_with_count", { count });
      break;
    case QUESTION_UID_MULTI_CHOICE:
      label = t("worksheet:mcq_with_count", { count });
      break;
    case QUESTION_UID_GRAPHING:
      label = t("worksheet:graphing_with_count", { count });
      break;
    case QUESTION_UID_DRAG_AND_DROP:
      label = t("worksheet:drag_and_drop_with_count", { count });
      break;
    case QUESTION_UID_FIND_HOTSPOT:
      label = t("worksheet:hotspot_with_count", { count });
      break;
    case QUESTION_UID_MATCHING:
      label = t("worksheet:matching_with_count", { count });
      break;
    case QUESTION_UID_LABELLING:
      label = t("worksheet:labelling_with_count", { count });
      break;
    case QUESTION_UID_DRAWING:
      label = t("worksheet:drawing_with_count", { count });
      break;
    case QUESTION_UID_TABLE:
      label = t("worksheet:table_with_count", { count });
      break;
    case QUESTION_UID_AUDIO:
      label = t("worksheet:audio_with_count", { count });
      break;
    case QUESTION_UID_VIDEO:
      label = t("worksheet:video_with_count", { count });
      break;
    default:
      break;
  }
  return label;
};

export const getQuestionsCountLabel = ({ questionTypeWiseCount, t }) => {
  const questionTypeCountLabels = [];
  _.forEach(questionTypeWiseCount, questionType => {
    const { questionTypeUid, count } = questionType;

    const label = getQuestionLabelWithCount({ questionTypeUid, count, t });

    if (!_.isEmpty(label)) {
      questionTypeCountLabels.push(label);
    }
  });

  return questionTypeCountLabels.join(", ");
};

export const getAssessmentViewQuestionsCountLabel = ({
  options = [],
  t,
  source = "assessment",
}) => {
  const questionTypeCountLabels = [];

  let questionsArray = [];
  let propertyToCountBy;

  if (source === "assessment") {
    propertyToCountBy = "questionTypeUid";
  }

  switch (source) {
    case "assessment":
      questionsArray = _.reduce(
        options,
        (acc, option) => {
          const childOptions = _.get(option, "childOptions", []);
          acc.push(...childOptions);
          return acc;
        },
        []
      );
      break;

    case "selectedFeed":
    default:
      questionsArray = _.map(options, "questionTypeUid");
      break;
  }
  const countResult = propertyToCountBy
    ? _.countBy(questionsArray, propertyToCountBy)
    : _.countBy(questionsArray);

  _.forEach(countResult, (count, value) => {
    const label = getQuestionLabelWithCount({
      questionTypeUid: value,
      count,
      t,
    });

    if (!_.isEmpty(label)) {
      questionTypeCountLabels.push(label);
    }
  });

  return questionTypeCountLabels;
};

export const scrollIntoViewWithOffset = ({
  element,
  // block = "start",
  // inline = "nearest",
  checkForElementInViewPort = false,
  parentElement,
  offset = 0,
}) => {
  if (!element) {
    console.error("please check the element you have passed");
    return;
  } else if (checkForElementInViewPort && parentElement && element) {
    // Checking viewport and scrolling according to parent element
    const elementRec = element.getBoundingClientRect();
    const parentRec = parentElement.getBoundingClientRect();

    // Calculating and Checking, if child is out of parent viewport
    const isChildOutOfParentUpperBoundary =
      elementRec.top <= parentRec.top + 56; // 56px is tabs height;
    const isChildOutOfParentLowerBoundary =
      elementRec.bottom > parentRec.height;
    const isChildOutOfParentContainer =
      isChildOutOfParentUpperBoundary || isChildOutOfParentLowerBoundary;

    if (isChildOutOfParentContainer) {
      // Initial scroll position i.e. top of parent element
      let scrollTopPosition = element.offsetTop;

      if (isChildOutOfParentUpperBoundary) {
        // If the child element is inside the 'upper' boundary of its parent
        // Scroll down by {offset}px from the top of the parent element
        scrollTopPosition -= offset;
      } else {
        // If the child element is inside the 'lower' boundary of its parent
        // if element height is greater than parent viewport
        //      -> Scroll down by {offset}px from the top of the parent element
        // else if element height is small than parent viewport
        //      -> Scroll up and keep bottom offset of {offset}px
        const heightDifference =
          parentElement.clientHeight - element.clientHeight;
        scrollTopPosition -= Math.max(heightDifference - offset, offset);
      }

      parentElement.scrollTo({
        top: scrollTopPosition,
        behavior: "smooth",
      });
    }
  }
};

export const getLibraryTypeOptions = ({ t }) => {
  return _.map(LIBRARY_TYPE_OPTIONS, option => ({
    ...option,
    label: t(option.label),
  }));
};

export const getQuestionOrderOptions = t => {
  return _.map(QUESTION_ORDER_OPTIONS, option => ({
    ...option,
    label: t(option.label),
  }));
};

export const getGraphTypeOptions = t => {
  return _.map(GRAPH_TYPE_OPTIONS, option => ({
    ...option,
    label: t(option.label),
  }));
};
/**
 * @param {Object} state - redux state
 * @returns the variables for the school question library feed query
 */
export const getSchoolQuestionLibraryFeedQueryVariables = _.memoize(
  ({
    organizationId,
    isSubQuestion = false,
    questionLibraryFilters,
    curriculumProgramId,
    parentEntity,
  }) => {
    const state = store.getState();

    const questionsToExclude = getPresetQuestionIdsFromCache(parentEntity);
    const isQueriesV2Enabled = isWorksheetQueriesV2Enabled();

    const variables = isQueriesV2Enabled
      ? {
          questionFilters: {
            questionNotToInclude: questionsToExclude,
          },
          first: 10,
          orgId: organizationId,
          orderBy: _.get(questionLibraryFilters, "orderBy", "CREATED_AT"),
          portalType: "PLANNER",
        }
      : {
          orgResourceFilters: {
            types: ["QUESTION_BANK_RESOURCE"],
            resourceType: "QUESTION",
            questionFilters: {
              questionNotToInclude: questionsToExclude,
            },
          },
          first: 10,
          orgId: organizationId,
          orderBy: _.get(questionLibraryFilters, "orderBy", "CREATED_AT"),
          portalType: "PLANNER",
        };

    // Handle curriculum program ID
    if (!_.isEmpty(curriculumProgramId)) {
      if (isQueriesV2Enabled) {
        _.set(variables, "questionFilters.curriculumProgramIds", [
          curriculumProgramId,
        ]);
      } else {
        _.set(variables, "orgResourceFilters.curriculumProgramIds", [
          curriculumProgramId,
        ]);
      }
    }

    // Handle grades filter
    const grades = _.get(questionLibraryFilters, "selectedGrades", []);
    if (!_.isEmpty(grades)) {
      const gradesPath = isQueriesV2Enabled
        ? "questionFilters.grades"
        : "orgResourceFilters.questionFilters.grades";
      _.set(variables, gradesPath, grades);
    }

    // Handle subjects filter
    const subjects = _.get(questionLibraryFilters, "selectedSubjects", []);
    if (!_.isEmpty(subjects)) {
      const subjectsPath = isQueriesV2Enabled
        ? "questionFilters.subjects"
        : "orgResourceFilters.questionFilters.subjects";
      _.set(variables, subjectsPath, subjects);
    }

    // Handle topics filter
    const topics = _.get(questionLibraryFilters, "selectedTopics", []);
    if (!_.isEmpty(topics)) {
      const topicsPath = isQueriesV2Enabled
        ? "questionFilters.topics"
        : "orgResourceFilters.questionFilters.topics";
      _.set(variables, topicsPath, topics);
    }

    // Handle question types filter
    const questionTypes = _.get(
      questionLibraryFilters,
      "selectedQuestionTypes",
      []
    );
    if (!_.isEmpty(questionTypes)) {
      const questionTypesPath = isQueriesV2Enabled
        ? "questionFilters.questionTypes"
        : "orgResourceFilters.questionFilters.questionTypes";
      _.set(variables, questionTypesPath, questionTypes);
    } else if (isSubQuestion) {
      // filter out multipart question if we are adding a subQuestion
      const subQuestionTypes = _.map(
        _.filter(QUESTION_TYPE_DETAILS, questionType => {
          return (
            _.get(questionType, "canAddToLibrary", false) &&
            _.get(questionType, "isSubQuestion", false)
          );
        }),
        "key"
      );

      const questionTypesPath = isQueriesV2Enabled
        ? "questionFilters.questionTypes"
        : "orgResourceFilters.questionFilters.questionTypes";
      _.set(variables, questionTypesPath, subQuestionTypes);
    }

    // Handle created by filter
    const createdBy = _.get(questionLibraryFilters, "selectedStaff", []);
    if (!_.isEmpty(createdBy)) {
      const createdByPath = isQueriesV2Enabled
        ? "questionFilters.createdBy"
        : "orgResourceFilters.questionFilters.createdBy";
      _.set(variables, createdByPath, createdBy);
    }

    // Handle difficulty filter
    const difficulty = _.get(questionLibraryFilters, "selectedDifficulty", []);
    if (!_.isEmpty(difficulty)) {
      const difficultyPath = isQueriesV2Enabled
        ? "questionFilters.difficulty"
        : "orgResourceFilters.questionFilters.difficulty";
      _.set(variables, difficultyPath, difficulty);
    }

    // Handle search text filter
    const searchText = _.get(questionLibraryFilters, "searchText", "");
    if (!_.isEmpty(searchText)) {
      const searchTextPath = isQueriesV2Enabled
        ? "questionFilters.searchText"
        : "orgResourceFilters.questionFilters.searchText";
      _.set(variables, searchTextPath, searchText);
    }

    return variables;
  }
);

export const getToddleQuestionLibraryFeedQueryVariables = _.memoize(
  ({ userId, parentEntity, questionLibraryFilters, isSubQuestion = false }) => {
    const questionsToExclude = getPresetQuestionIdsFromCache(parentEntity);

    const variables = {
      id: userId,
      entityTypes: getIsToddleLibraryWorksheetQueriesV2Enabled()
        ? QUESTION_V2
        : QUESTION,
      first: 10,
      seed: -0.47,
      questionFilters: {
        questionNotToInclude: questionsToExclude,
      },
      filters: {},
      showOnlyAccessible: true,
      portalType: "COMMUNITY",
    };

    /** Search */
    const searchText = _.get(questionLibraryFilters, "searchText", "");
    if (!_.isEmpty(searchText)) {
      _.set(variables, "questionFilters.searchText", searchText);
    }

    /** Subjects */
    const subjects = _.get(questionLibraryFilters, "selectedSubjects", []);
    if (!_.isEmpty(subjects)) {
      _.set(variables, "filters.subjects", subjects);
    }

    /** Paper type */
    const paperTypes = _.get(questionLibraryFilters, "selectedPaperTypes", []);
    if (!_.isEmpty(paperTypes)) {
      _.set(variables, "questionFilters.paperTypes", paperTypes);
    }

    /** Question types */
    const questionTypes = _.get(
      questionLibraryFilters,
      "selectedQuestionTypes",
      []
    );
    if (!_.isEmpty(questionTypes)) {
      _.set(variables, "questionFilters.questionTypes", questionTypes);
    } else if (isSubQuestion) {
      // filter out multipart question if we are adding a subQuestion
      const subQuestionTypes = _.map(
        _.filter(QUESTION_TYPE_DETAILS, questionType => {
          return (
            _.get(questionType, "canAddToLibrary", false) &&
            _.get(questionType, "isSubQuestion", false)
          );
        }),
        "key"
      );

      _.set(variables, "questionFilters.questionTypes", subQuestionTypes);
    }

    /** Difficulty */
    const difficulty = _.get(questionLibraryFilters, "selectedDifficulty", []);
    if (!_.isEmpty(difficulty)) {
      _.set(variables, "questionFilters.difficulty", difficulty);
    }

    /** PlannerElementNodes */
    const topics = _.get(questionLibraryFilters, "selectedTopics", []);
    const subTopics = _.get(questionLibraryFilters, "selectedSubTopics", []);
    if (!_.isEmpty(topics) || !_.isEmpty(subTopics)) {
      _.set(
        variables,
        ["questionFilters", "plannerElementNodes"],
        _.union(subTopics, topics)
      );
    }

    /** QuestionFeedType */
    const questionFeedType = _.get(
      questionLibraryFilters,
      "questionFeedType",
      ""
    );
    if (
      !_.isEmpty(questionFeedType) &&
      questionFeedType === QUESTION_FEED_TYPE_SAVED
    ) {
      _.set(variables, "feedType", questionFeedType);
    }

    return variables;
  }
);

export const getRandomQuestionLibraryFeedQueryVariables = ({
  questionLibraryFeedVariables,
  numberOfQuestions,
  libraryType,
  selectedQuestions,
}) => {
  _.set(questionLibraryFeedVariables, ["first"], parseInt(numberOfQuestions));
  if (libraryType === SCHOOL_LIBRARY) {
    _.set(questionLibraryFeedVariables, "orderBy", "RANDOM");
    const excludeQuestions =
      _.get(
        questionLibraryFeedVariables,
        ["orgResourceFilters", "questionFilters", "questionNotToInclude"],
        []
      ) || [];
    _.forEach(selectedQuestions, item => {
      excludeQuestions.push(_.get(item, "questionId"));
    });
    _.set(
      questionLibraryFeedVariables,
      ["orgResourceFilters", "questionFilters", "questionNotToInclude"],
      excludeQuestions
    );
  } else {
    _.set(questionLibraryFeedVariables, "sortBy", "RANDOM");
    const excludeQuestions =
      _.get(
        questionLibraryFeedVariables,
        ["questionFilters", "questionNotToInclude"],
        []
      ) || [];
    _.forEach(selectedQuestions, item => {
      excludeQuestions.push(_.get(item, "questionId"));
    });
    _.set(
      questionLibraryFeedVariables,
      ["questionFilters", "questionNotToInclude"],
      excludeQuestions
    );
  }

  return questionLibraryFeedVariables;
};

const shouldShowToddleLibraryForCurriculum = ({
  curriculumType,
  globalGradeUid,
}) => {
  const isWorksheetEnabledForMYP =
    isMYPWorksheetEnabledForLibrary() &&
    _.includes(MYP_GRADE_LABELS, globalGradeUid) &&
    _.isEqual(curriculumType, CURRICULUM_TYPE_MYP);
  return (
    ((_.isEqual(curriculumType, CURRICULUM_TYPE_DP) ||
      _.isEqual(curriculumType, CURRICULUM_TYPE_UBD)) &&
      _.includes([GRADE_11, GRADE_12], globalGradeUid)) ||
    isWorksheetEnabledForMYP
  );
};

export const isToddleLibraryEnabledForWorksheets = ({
  curriculumType,
  globalGradeUid,
}) => {
  const canImportForCurriculum = shouldShowToddleLibraryForCurriculum({
    curriculumType,
    globalGradeUid,
  });

  const state = store?.getState();
  const organizationCurriculumPrograms = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );

  return (
    canImportForCurriculum &&
    getToddleLibraryVisibilityStatus({
      curriculumPrograms: organizationCurriculumPrograms,
    })
  );
};

export const libraryCardKeys = ["total_marks", "total_questions", "subjects"];

export const getLibraryQuestionCardDetails = ({
  questionResource,
  t,
  isSideBarPreview = false,
  isToddleLibrary = false,
}) => {
  const question = _.get(questionResource, "item");
  const questionResourceId = _.get(questionResource, "id", "");
  const questionId = _.get(question, "id", "");
  const questionTypeUid = _.get(question, "questionType.uid", "");
  const questionTitle = _.get(question, "questionTitle", {});
  const questionScore = _.get(question, "questionScore", 0);
  const difficulty = _.get(question, "difficulty", "");

  const questionTypeLabel = t(
    _.get(
      QUESTION_TYPE_DETAILS,
      [questionTypeUid, "localeLabel"],
      "common:untitled"
    )
  );

  const formattedMarks = parseFloat?.(questionScore) || 0;
  const formattedTitle =
    _.get(getFormattedQuestionTitle({ questionTitle }), "htmlString", false) ||
    _.get(getQuestionTitle({ question, t }), "htmlString", false) ||
    t("worksheet:untitled_question");

  const groupedTags = _.groupBy(
    _.get(question, "associatedEntities", []),
    "__typename"
  );

  const tagLabels = {};

  const subjects = _.get(question, "librarySubjects", []);
  const subjectLabel = _.get(_.first(subjects), "label", "");
  const subjectTooltip = _.map(subjects, "label");

  if (!_.isEmpty(subjectLabel)) {
    tagLabels[QUESTION_TAG_SUBJECT] = (
      <QuestionCardTag
        label={subjectLabel}
        tooltips={subjectTooltip}
        count={_.size(subjects) - 1}
        isSideBarPreview={isSideBarPreview}
        t={t}
      />
    );
  }

  const syllabusContentTopics = _.filter(
    _.get(groupedTags, "PlannerElementNode", []),
    item => _.get(item, "depth") == TOPIC_DEPTH
  );

  const genericTopics = _.filter(
    _.get(groupedTags, "GenericTag", []),
    item => _.get(item, "type") == QUESTION_TOPIC
  );

  const topics = isToddleLibrary ? syllabusContentTopics : genericTopics;

  const topicLabel = _.get(_.first(topics), "label", "");
  const topicTooltip = _.map(topics, "label");

  if (!_.isEmpty(topicLabel)) {
    tagLabels[QUESTION_TAG_TOPIC] = (
      <QuestionCardTag
        label={topicLabel}
        tooltips={topicTooltip}
        count={_.size(topics) - 1}
        isSideBarPreview={isSideBarPreview}
        t={t}
      />
    );
  }

  return {
    key: questionResourceId,
    id: questionResourceId,
    questionId,
    questionTypeLabel,
    marks: formattedMarks,
    title: formattedTitle,
    questionTypeUid,
    tagLabels,
    difficulty,
  };
};

/** @returns - variables that is sent to add to library mutation */
export const getAddQuestionToLibraryVariables = ({
  tagDetails,
  questionId,
  curriculumProgramId,
}) => {
  /** grades */
  const gradesArray = _.map(_.get(tagDetails, "grades"), grade => ({
    id: _.get(grade, "value", ""),
    type: GRADE,
  }));

  /** subjects */
  const subjectsArray = _.map(_.get(tagDetails, "subjects"), subject => ({
    id: _.get(subject, "value", ""),
    type: SUBJECT,
  }));

  /** topics */
  const topicsArray = _.map(_.get(tagDetails, "topics"), topic => ({
    id: _.get(topic, "value", ""),
    type: QUESTION_TOPIC,
  }));

  const associatedEntities = _.flatMap([
    gradesArray,
    subjectsArray,
    topicsArray,
  ]);
  const variables = {
    questionId,
    difficulty: _.get(tagDetails, "difficulty.value", null),
    associatedEntities,
    curriculumProgramId,
  };

  return variables;
};

export const getMultiSelectDropdownOptions = list => {
  return _.map(list, value => ({
    value: _.get(value, "id"),
    label: _.get(value, "name"),
  }));
};

export const getAssignmentSubjects = _.memoize(
  ({ assessmentId, collaboratorsFilter }) => {
    const assessmentDetails = getAssessmentDetailsFromCache({
      id: assessmentId,
      collaboratorsFilter,
    });

    return _.get(
      _.find(_.get(assessmentDetails, "allFields"), {
        uid: ASSESSMENT_FIELD_UID_SUBJECTS,
      }),
      "resolvedMinimalTree.subjects",
      []
    );
  },

  ({ assessmentId, collaboratorsFilter }) =>
    JSON.stringify({
      assessmentId,
      collaboratorsFilter,
    })
);

export const getWorksheetSectionsData = _.memoize(
  data => {
    return _.map(
      _.get(data, "organizationResourcesV2.edges[0].node.childrenV2.edges", []),
      "node"
    );
  },
  data => {
    const edges = _.get(
      data,
      "organizationResourcesV2.edges[0].node.childrenV2.edges",
      []
    );
    return JSON.stringify(edges);
  }
);

export const getWorksheetSubmissions = _.memoize(
  submissionData => {
    return _.map(submissionData, questionEdge => {
      const submissionItem = _.get(questionEdge, "node", {});
      return submissionItem;
    });
  },
  submissionData => {
    return JSON.stringify({
      submissionData: _.map(submissionData, edge => {
        const node = _.get(edge, "node", {});
        return {
          id: _.get(node, "id"),
          question: _.get(node, "question.id"),
          fields: _.get(node, "fields", []),
          elementRemarks: _.get(node, "elementRemarks"),
          toolResponses: _.get(node, "toolResponses", []),
          ibPYPElementRatings: _.get(node, "ibPYPElementRatings", []),
          isQuestionAttempted: _.get(node, "isQuestionAttempted", false),
        };
      }),
    });
  }
);

export const getAssignmentDetailsFromCacheMemoized = _.memoize(
  ({
    assignmentId,
    userType,
    curriculumProgramType,
    userId,
    childID,
    academicYearId,
  }) => {
    const variables = getAssignmentDetailsQueryVariables({
      assignmentId,
      userType,
      curriculumProgramType,
      userId,
      childID,
      academicYearId,
    });
    return getAssignmentDetailsFromCache(variables);
  },
  ({
    assignmentId,
    userType,
    curriculumProgramType,
    userId,
    childID,
    academicYearId,
  }) =>
    JSON.stringify({
      assignmentId,
      userType,
      curriculumProgramType,
      userId,
      childID,
      academicYearId,
    })
);

export const getErrorState = _.memoize(
  ({ mode, errorStateData }) => {
    return mode == MODE_TEACHER_CREATE ? errorStateData : {};
  },
  ({ mode, errorStateData }) =>
    JSON.stringify({
      mode,
      errorStateData,
    })
);

export const getDurationForTimedTest = ({ t, durationInSeconds }) => {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds - hours * 3600) / 60);
  const seconds = Math.floor(durationInSeconds - hours * 3600 - minutes * 60);

  const minutesToDisplay = _.padStart(minutes, 2, "0");
  const secondsToDisplay = _.padStart(seconds, 2, "0");

  if (hours > 0) {
    const localeKey =
      hours == 1 && minutes == 0 && seconds == 0
        ? "common:hour_with_label"
        : "common:hours_with_label";

    return t(localeKey, {
      label: `${hours}:${minutesToDisplay}:${secondsToDisplay}`,
    });
  } else if (minutes > 0) {
    const localeKey =
      minutes == 1 && seconds == 0
        ? "common:minute_with_label"
        : "common:minutes_with_label";

    return t(localeKey, { label: `${minutes}:${secondsToDisplay}` });
  } else {
    const localeKey =
      seconds == 1 ? "common:second_with_label" : "common:seconds_with_label";

    return t(localeKey, { label: seconds });
  }
};

/**
 * @deprecated use updateQuestionMetadataInCacheV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
export const updateQuestionMetadataInCache = (id, metadata) => {
  const questionCacheData = getQuestionFromCache({ id });
  const updatedData = update(questionCacheData, {
    metadata: { $set: metadata },
  });

  writeQuestionInCache({
    id,
    data: updatedData,
  });
};

export const getShowWorksheetAssessmentTool = assessmentTools => {
  return _.some(assessmentTools, toolEdge => {
    return _.get(toolEdge, "node.assessmentToolType") !== SCORE;
  });
};

export const getPresetQuestionIdsFromCache = parentEntity => {
  const variables = getAssessmentQuestionsQueryVariables({
    parentId: _.get(parentEntity, "id"),
    parentType: _.get(parentEntity, "type"),
  });

  const cacheData = getAssessmentQuestionsFromCache(variables);
  const sections = _.get(
    cacheData,
    "organizationResourcesV2.edges.[0].node.childrenV2.edges",
    []
  );

  const presetQuestionIds = _.reduce(
    sections,
    (acc, section) => {
      const questions = _.get(section, "node.childrenV2.edges", []);

      const presetIdsOfSection = _.compact(
        questions.map(question => {
          return _.get(question, "node.item.presetQuestionId", null);
        })
      );

      acc.push(...presetIdsOfSection);

      return acc;
    },
    []
  );

  return presetQuestionIds;
};

export const getQuestionFeedTypeOptions = t => {
  return [
    {
      key: QUESTION_FEED_TYPE_ALL_QUESTIONS,
      label: t("common:all_label", {
        label: t("common:question_plural"),
      }),
      value: QUESTION_FEED_TYPE_ALL_QUESTIONS,
    },
    {
      key: QUESTION_FEED_TYPE_SAVED,
      label: t("common:my_bookmarks"),
      value: QUESTION_FEED_TYPE_SAVED,
    },
  ];
};

const replaceImgTagsWithLatex = htmlString => {
  const imgRegex = /<img[^>]+alt="([^"]+)"[^>]*>/g;

  const replacedHtml = _.replace(
    htmlString,
    imgRegex,
    (match, latexContent) => {
      return `$${latexContent}$`;
    }
  );

  return replacedHtml;
};

export const convertQuestionObjectToAiText = ({ questionData, t }) => {
  let finalQuestionString = "";

  const fields = _.get(questionData, "fields", []);

  const questionTextObj = getQuestionTitle({ question: questionData, t });
  const questionText = extractContentFromHTML({
    htmlString: replaceImgTagsWithLatex(questionTextObj?.htmlString),
  });

  const choicesArr = _.map(
    _.get(_.find(fields, { uid: "choices" }), "value", []),
    choice => {
      return extractContentFromHTML({
        htmlString: replaceImgTagsWithLatex(_.get(choice, "value", "")),
      });
    }
  );

  const isMultipleChoice = _.isEqual(
    _.get(questionData, "questionType.uid", ""),
    QUESTION_UID_MULTI_CHOICE
  );

  let answerText = "";

  const answerField = _.find(_.get(questionData, "answerFields", []), {
    uid: FIELD_UID_MCQ_ANSWERS,
  });

  const answerValueArr = _.get(answerField, "value", []);

  if (isMultipleChoice) {
    const correctAnsIndex = _.findIndex(answerValueArr, { isSelected: true });
    answerText = _.get(choicesArr, correctAnsIndex, "");
  } else {
    answerText = extractContentFromHTML({
      htmlString: replaceImgTagsWithLatex(answerValueArr),
    });
  }

  // add question to string
  finalQuestionString += `**Q1** ${questionText}\n\n`;

  // add options to string
  _.forEach(choicesArr, choice => {
    finalQuestionString += `- ${choice}\n`;
  });

  // add extra nexline if question is multiple choice
  if (isMultipleChoice) finalQuestionString += "\n";

  // Add answer string to question string
  finalQuestionString += `**Answer Text**\n${answerText}`;

  return finalQuestionString;
};

const sendMessageToMobile = (
  status = "ERROR",
  token = "",
  messageObject = {}
) => {
  sendMessagePayloadToMobile(
    JSON.stringify({
      STATUS: _.toUpper(status),
      MESSAGE_TOKEN: token,
      PAYLOAD: messageObject,
    })
  );
};

export const sendMessageToParentApp = (msg, messagePayload = {}) => {
  msg = _.toUpper(msg);
  switch (msg) {
    case "SUBMIT_WORKSHEET":
      sendMessageToMobile("SUCCESS", "SUBMIT_WORKSHEET");
      break;
    case "SAVE_AND_EXIT":
      sendMessageToMobile("SUCCESS", "CLOSE_WORKSHEET");
      break;
    case "SAVE_FAILED":
      sendMessageToMobile("ERROR", msg, messagePayload);
      break;
    case "OPEN_LINK":
    case "OPEN_WORKBOOK":
      sendMessageToMobile("SUCCESS", msg, messagePayload);
      break;
    case "WORKSHEET_STARTED":
      sendMessageToMobile("SUCCESS", "WORKSHEET_STARTED");
      break;
    default:
      break;
  }
};

export const getQuestionFieldsFromTemplate = _.memoize(
  ({ mode, questionTypeConfig, questionSettings, questionTypeUid }) => {
    const canAddResponseTextField = _.get(
      questionSettings,
      FIELD_UID_ADDITIONAL_FIELD_SETTING,
      false
    );
    let questionFields = _.includes(
      [
        MODE_TEACHER_CREATE,
        MODE_ASSESSMENT_VIEW,
        MODE_RESTRICTED_ASSESSMENT_VIEW,
        MODE_LIBRARY_VIEW,
      ],
      mode
    )
      ? _.get(questionTypeConfig, "fields", [])
      : _.get(questionTypeConfig, "student_field", []);
    if (
      _.includes(
        [
          QUESTION_UID_DRAWING,
          QUESTION_UID_TRUE_FALSE_V2,
          QUESTION_UID_MULTI_CHOICE,
        ],
        questionTypeUid
      ) &&
      !canAddResponseTextField
    ) {
      questionFields = _.without(questionFields, FIELD_UID_RESPONSE);
    }
    return questionFields;
  },
  ({ mode, questionTypeConfig, questionSettings, questionTypeUid }) =>
    JSON.stringify({
      mode,
      questionTypeConfig: _.pick(questionTypeConfig, [
        "fields",
        "student_field",
      ]),
      questionSettings: _.get(
        questionSettings,
        FIELD_UID_ADDITIONAL_FIELD_SETTING,
        false
      ),
      questionTypeUid,
    })
);

export const isFillInTheBlankRes = string => {
  return _.some(blankFormate, substring => _.includes(string, substring));
};
/**
 * Formats answers from nested array to ordered list.
 * Takes a string with nested array syntax and converts it into an ordered list.
 *
 * @param {string} input - The input string containing nested array syntax.
 * @returns {string} The formatted string with ordered list.
 */
const formatFillInTheBlanksAnswer = input => {
  input = _.trim(input);

  // Match the content inside the outermost double brackets, allowing spaces
  const match = input.match(fillInTheBlanksAnsRegex);
  const innerStr = _.get(match, "[1]");

  // If there is no match or the match is empty, return the original input
  if (_.isEmpty(innerStr)) {
    return input;
  }

  // Split the matched string into array parts, allowing spaces around brackets
  const arrayParts = _.split(innerStr, /\s*\],\s*\[/);
  let result = "";

  // Iterate over each part and process it
  _.forEach(arrayParts, part => {
    // Remove quotes and extra spaces, split by commas, and join items with a comma
    const items = part.replace(/["'\s]+/g, "").split(/\s*,\s*/);
    result += `${items.join(", ")}\n`;
  });

  // Return the result without trimming to preserve the final newline character
  return result;
};
/**
 * Formats AI response to the desired format.
 * Replaces fill-in-the-blanks placeholders with input elements,
 * and formats nested answers contained within double square brackets.
 *
 * @param {string} text - The AI response text to be formatted.
 * @returns {string}  formatted response for markdown.
 */

export const formatAiFillResponse = text => {
  const updatedText = _.replace(text, /#BLAN(?:K|KS|K1)#/g, `_________`);
  const formattedAnswer = formatFillInTheBlanksAnswer(updatedText);
  return _.replace(updatedText, fillInTheBlanksAnsRegex, formattedAnswer);
};

/**
 * Copies an image to the clipboard.
 * Due to limitations in Firefox with ClipboardItem support, this function creates a temporary element,
 * copies the image to it, selects the content, and then attempts to copy it to the clipboard.
 * @param {HTMLElement} image - The image element to copy.
 */
export const copyImageToClipboard = image => {
  const clipboardDiv = document.createElement("div");
  clipboardDiv.style.fontSize = "12pt";
  clipboardDiv.style.border = "0";
  clipboardDiv.style.padding = "0";
  clipboardDiv.style.margin = "0";
  // hiding element
  clipboardDiv.style.position = "fixed";
  clipboardDiv.style["right"] = "-9999px";
  clipboardDiv.style.top =
    (window.pageYOffset || document.documentElement.scrollTop) + "px";
  clipboardDiv.setAttribute("readonly", "");
  clipboardDiv.style.opacity = 0;
  clipboardDiv.style.pointerEvents = "none";
  clipboardDiv.style.zIndex = -1000;
  clipboardDiv.setAttribute("tabindex", -1); // so it can be focused

  clipboardDiv.innerHTML = image.outerHTML;

  document.body.appendChild(clipboardDiv);

  clipboardDiv.focus();

  window.getSelection().removeAllRanges();
  var range = document.createRange();
  range.setStartBefore(clipboardDiv.firstChild);
  range.setEndAfter(clipboardDiv.lastChild);
  window.getSelection().addRange(range);

  try {
    if (document.execCommand("copy")) {
      setToastMsg({
        msg: "toastMsgs:equation_copied_successfully",
        type: "success",
        position: "toast-bottom-left",
      });
    } else {
      console.error("Copy failed");
    }
  } catch (err) {
    console.error("Copy failed with exception: ", err);
  }
  document.body.removeChild(clipboardDiv);
};

export const getQuestionHeaderOptions = ({
  t,
  isSubQuestion,
  isAddedToSchoolLibrary,
  showAddToLibraryButton,
  isDuplicatingQuestion = false,
}) => {
  const addToLibraryLabel = isAddedToSchoolLibrary
    ? t("worksheet:question_added_to_school_library")
    : t("common:add_to_label", {
        label: t("common:school_library"),
      });
  const options = [
    {
      key: "duplicate",
      label: t("common:duplicate"),
      icon: <CopyOutlined />,
      disabled: isDuplicatingQuestion,
    },
  ];
  if (showAddToLibraryButton && !isSubQuestion) {
    options.unshift({
      key: "addToLibrary",
      label: addToLibraryLabel,
      icon: <AddToLibraryOutlined />,
      disabled: isAddedToSchoolLibrary,
    });
  }

  return options;
};
/**
 * Updates the attempted status of questions within a specific submission in the cache.
 * This function performs two main updates: it first updates the attempted status of a single question,
 * then updates the count of attempted questions within the entire submission based on an assessment.
 * @param {Object} question - The question object whose attempted status is to be updated.
 * @param {string} submissionId - The ID of the submission containing the question.
 * @param {Object} parentEntityDetails - The details of the parent entity.
 * @param {string} portalType - The portal type indicating the context in which the assessment is used.
 * @param {string} userType - The user type of the current user.
 * @param {string} mode - The mode in which the assessment is being accessed.
 */
export const updateQuestionSubmissionInCache = ({
  question,
  submissionId,
  portalType,
  parentEntityDetails,
  userType,
  mode,
}) => {
  const userFilter = "SELF";
  let updatedData = {};
  const assignmentSubmissionId = _.get(parentEntityDetails, "submissionId");

  const submissionCacheData = getQuestionSubmissionConnectionFromCache({
    id: assignmentSubmissionId,
    userFilter,
  });
  const questionSubmissionData = _.find(
    _.get(submissionCacheData, "edges", []),
    edge => _.isEqual(_.get(edge, "node.id"), submissionId)
  );

  const assessmentQuestionsQueryVariables = getAssessmentQuestionsQueryVariables(
    {
      parentId: _.get(parentEntityDetails, "id"),
      parentType: _.get(parentEntityDetails, "type"),
      portalType,
      userType,
      mode,
    }
  );
  const worksheetData = getStudentQuestionDetailsQueryFromCache(
    assessmentQuestionsQueryVariables
  );

  const worksheetSections = _.get(
    worksheetData,
    "organizationResourcesV2.edges[0].node.childrenV2.edges",
    []
  );
  const attemptedQuestionCount = getAttemptedQuestionCount({
    sections: worksheetSections,
    submissions: submissionCacheData,
  });

  const isQuestionAttempted = getIsQuestionAttempted({
    question,
    submission: _.get(questionSubmissionData, "node"),
  });

  const edgeIndex = _.findIndex(_.get(submissionCacheData, "edges", []), edge =>
    _.isEqual(_.get(edge, "node.id"), submissionId)
  );
  if (edgeIndex >= 0) {
    updatedData = update(submissionCacheData, {
      totalQuestionAttempted: { $set: attemptedQuestionCount }, // Update totalQuestionAttempted
      edges: {
        [edgeIndex]: {
          node: {
            isQuestionAttempted: { $set: isQuestionAttempted }, // Update specific edge's isQuestionAttempted
          },
        },
      },
    });
  }

  writeQuestionSubmissionConnectionInCache({
    id: assignmentSubmissionId,
    data: updatedData,
    userFilter,
  });
};

/**
 * Constructs an array of custom fields with labels, icons, and disabled status based on provided fields.
 * @param {Array} fields - The list of currently added fields, used to determine if a field is already included.
 * @param {function} t - A translation function commonly used in internationalization to translate the labels.
 * @param {boolean} isSubQuestion - A flag to determine if the custom fields are for a subquestion.
 * @param {string} curriculumType - The type of curriculum to determine the dynamic fields to include.
 * @param {boolean} isFromInternalTool - A flag to determine if this is invoked from internal tool or not
 * @returns {Array} An array of objects, each representing a custom field with its `key`, translated `label`, `icon`, and `isDisabled` status.
 */
export const getCustomFields = ({
  fields,
  t,
  isSubQuestion = false,
  curriculumType,
  isFromInternalTool = false,
}) => {
  const customFields = [];
  const fieldsToRemove = [
    FIELD_UID_ASSESSMENT_TOOL,
    FIELD_UID_TEACHER_NOTES,
    FIELD_UID_ADD_LEARNING_GOALS,
  ];
  let updatedDynamicFields = DYNAMIC_FIELD_DETAILS({ curriculumType });

  if (isFromInternalTool) {
    // * for now hide assessment tool and learning goal from internal tools
    updatedDynamicFields = _.omit(updatedDynamicFields, [
      FIELD_UID_ASSESSMENT_TOOL,
      FIELD_UID_ADD_LEARNING_GOALS,
    ]);
  }

  if (isSubQuestion)
    updatedDynamicFields = _.omit(updatedDynamicFields, fieldsToRemove);

  _.forEach(DYNAMIC_FIELDS_V2, key => {
    const value = _.get(updatedDynamicFields, key, {});
    const isFieldAdded = _.findIndex(fields, { uid: key }) != -1;
    const isDropdown = _.get(value, "isDropdown", false);

    if (!_.isEmpty(value)) {
      customFields.push({
        key,
        label: t(_.get(value, "tooltipLabel", _.get(value, "localeLabel", ""))),
        icon: _.get(value, "icon", null),
        isDisabled: isFieldAdded && !isDropdown,
        options: _.get(value, "fieldConfig.config.defaultOptions", []),
        isDropdown,
      });
    }
  });
  return customFields;
};

/**
 * @deprecated use getDetailsFromSectionsV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
/**
 * Locates a question within nested sections and returns its resource ID, its index in a flat list of all questions,
 * and the ID of the section containing the question.
 * @param {Array} sections - A list of sections, each containing a collection of questions including potentially nested subquestions.
 * @param {string} activeQuestionId - The ID of the question to locate.
 * @returns {Object} An object containing the `questionResourceId`, `questionIndex`, and `sectionId` of the found question.
 */
export const getDetailsFromSections = (sections = [], activeQuestionId) => {
  let questionResourceId = null;
  let questionIndex = 0;
  const questions = _.flatMapDeep(sections, section => {
    return section?.childrenV2?.edges;
  });
  _.some(questions, question => {
    questionIndex++;
    if (_.get(question, "node.item.id") === activeQuestionId) {
      questionResourceId = _.get(question, "node.id");
    }
    const subQuestions = _.get(question, "node.childrenV2.edges");

    if (_.size(subQuestions) > 0) {
      _.some(subQuestions, subQuestion => {
        if (_.get(subQuestion, "node.item.id") === activeQuestionId) {
          questionResourceId = _.get(question, "node.id");
          return true; // Return true to stop the iteration once the question is found.
        }
        return false; // Continue searching through other questions.
      });
    }
    if (questionResourceId) return true;
    return false; // Continue searching through other questions.
  });

  const sectionId = _.get(
    _.find(sections, section =>
      _.some(
        _.get(section, "childrenV2.edges"),
        edge => _.get(edge, "node.id") === questionResourceId
      )
    ),
    "id"
  );

  return { questionResourceId, questionIndex, sectionId };
};

/**
 * @deprecated use getAllQuestionsFromSectionsV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
/**
 *
 * @param {Array} sections - Array of section objects containing questions and potentially nested subquestions.
 * @param {boolean} isSubQuestion - A flag to determine if the active question is a subquestion.
 * @returns {Array} The array of question's objects
 */
export const getAllQuestionsFromSections = (
  sections = [],
  isSubQuestion = false
) => {
  let allQuestions = [];
  const isMutationV2Enabled = isWorksheetMutationsV2Enabled();

  // Flatten the questions and subquestions into a single array
  _.forEach(sections, section => {
    _.forEach(section.childrenV2.edges, question => {
      const subQuestions = _.get(question, "node.childrenV2.edges");
      const sectionId = isMutationV2Enabled
        ? _.get(section, "item.id", "")
        : _.get(section, "id", "");
      if (isSubQuestion) {
        if (_.size(subQuestions) > 0) {
          allQuestions = allQuestions.concat(
            _.map(subQuestions, subQuestion => ({
              ...subQuestion?.node,
              sectionId,
            }))
          );
        }
      }
      allQuestions.push({ ...question?.node, sectionId });
    });
  });

  return allQuestions;
};

/**
 * Finds the next or the last question relative to an active question in a nested structure.
 * @param {Array} sections - Array of section objects containing questions and potentially nested subquestions.
 * @param {string} questionId - The ID of the active question.
 * @param {boolean} isSubQuestion - A flag to determine if the active question is a subquestion.
 * @returns {string|null} The question id after the active question, or the question before if the active is last or not found.
 */
export const getNextQuestionId = ({
  sections = [],
  questionId, //questionResourceId if mutationV2 is not enabled
  isSubQuestion = false,
}) => {
  const allQuestions = getAllQuestionsFromSections(sections, isSubQuestion);

  const activeIndex = _.findIndex(
    allQuestions,
    question =>
      (isWorksheetMutationsV2Enabled()
        ? _.get(question, "item.id")
        : _.get(question, "id")) === questionId
  );

  const nextQuestionId = _.get(allQuestions[activeIndex + 1], "item.id");
  const previousQuestionId = _.get(allQuestions[activeIndex - 1], "item.id");

  return nextQuestionId || previousQuestionId || null;
};

export const getRemainingTimeFromStartTime = time => {
  const currentTime = moment();
  const endTime = moment(time);
  const difference = endTime.diff(currentTime);
  const duration = moment.duration(difference);
  return duration;
};

export const formatDuration = (t, durationInMinutes) => {
  const duration = moment.duration(durationInMinutes, "minutes");
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  let formattedDuration = "";
  if (hours > 0) {
    formattedDuration += t("worksheet:hours_label", { hours });
  }
  if (minutes > 0) {
    hours > 0 ? (formattedDuration += " ") : null;
    formattedDuration += t("worksheet:mins_label", { minutes });
  }

  return formattedDuration.trim();
};

export const downloadRedirect = () => {
  const redirectUrl = isWindows()
    ? SEB_DOWNLOAD_LINK_WINDOWS
    : SEB_DOWNLOAD_LINK_MAC;
  window.location.href = redirectUrl;
};

/**
 * Navigate to the quit link used in SEB
 **/
export const handleQuitSebNavigate = async () => {
  const currentUrl = new URL(window.location.href);
  const path = currentUrl?.pathname;
  currentUrl.pathname = path.endsWith("/")
    ? path + "quit_seb"
    : path + "/quit_seb";

  await logoutUser({ redirectUri: currentUrl.toString() });
  window.location.href = currentUrl.toString();
};

/**
 * @description getting details of assessment details from cache using id
 * @param {string} assessmentId - assessment id
 * @param {object} collaboratorsFilter - filters to fetch collaborators of assessment's unit plan
 * @returns object of assessment data
 */
export const getAssessmentDetailsData = ({
  assessmentId,
  collaboratorsFilter,
}) => {
  const assessmentDetails = getAssessmentDetailsFromCache({
    id: assessmentId,
    collaboratorsFilter,
  });

  const worksheetTemplateId = _.get(assessmentDetails, "templateId");
  const unitPlanTemplateId = _.get(
    assessmentDetails,
    "unitPlan.templateId",
    ""
  );
  const allFields = _.get(assessmentDetails, "allFields", []);

  const unitPlanField = _.find(allFields, { uid: "unitPlan" });
  const unitPlanResolvedMinimalTree = _.get(
    unitPlanField,
    "resolvedMinimalTree.unitPlan",
    {}
  );
  const unitPlanFields = _.get(unitPlanResolvedMinimalTree, "allFields", []);
  const unitType = _.get(
    _.find(unitPlanFields, { uid: "unitType" }),
    "value",
    ""
  );

  const assessmentTypeField = _.find(allFields, { uid: "assessmentType" });
  const assessmentType = _.get(assessmentTypeField, "value");

  const subjectsField = _.find(allFields, { uid: "subjects" });

  const aiConversationId = getAiConversationId(assessmentDetails);

  const assessmentTitle = _.get(assessmentDetails, "title.value", "");

  const descriptionField = _.find(allFields, { uid: "description" });
  const worksheetInstructions = _.get(descriptionField, "value", "");

  const isWorksheetExtractionInProgress = _.get(
    assessmentDetails,
    "isWorksheetExtractionInProgress",
    false
  );

  return {
    worksheetTemplateId,
    assessmentType,
    unitPlanTemplateId,
    unitType,
    assessmentDetails,
    unitPlanField,
    subjectsField,
    assessmentFields: allFields,
    worksheetInstructions,
    aiConversationId,
    assessmentTitle,
    isWorksheetExtractionInProgress,
    assessmentTools: _.get(assessmentDetails, "assessmentTools", []),
  };
};

/**
 *
 * @param {*} `fieldList` - list of fields, `t` - translation utility function for support localisation, `fieldUid` - uid of field
 * @returns array of options from field
 */
export const getOptionsFromField = ({ fieldList, fieldUid, t }) => {
  const { config: { options } = {} } = fieldList[fieldUid]
    ? fieldList[fieldUid]
    : {};

  return getOptionsLocale({ options, key: fieldUid, t });
};

/**
 * @description generating object of learning goals fields, added extra property `isAddedToQuestion` for determine field is added into question or not
 * @param {object} originalTemplate
 * @param {object} updatedTemplate
 * @returns object of learning goals fields
 */
export const getLearningGoalsFields = template => {
  const fieldList = _.get(template, "field_list", {});
  if (_.isEmpty(fieldList)) return {};

  const learningGoalsFieldsUid =
    _.get(template, "step_list.pypElements.fields") ||
    _.get(template, "step_list.dpElements.fields") ||
    [];

  return _.reduce(
    learningGoalsFieldsUid,
    (learningGoalsFields, fieldUid) => {
      if (
        !_.includes([FIELD_UID_ADD_LEARNING_GOALS, "enableRating"], fieldUid)
      ) {
        learningGoalsFields[fieldUid] = _.get(fieldList, fieldUid);
      }
      return learningGoalsFields;
    },
    {}
  );
};

/*
 * Processes a string containing XML-like tags by performing the following transformations:
 * 1. Removes all closing tags (e.g., `</tag>`).
 * 2. Removes any empty tags (e.g., `<tag></tag>`).
 * 3. Replaces all starting tags (e.g., `<tag>`) with the tag name enclosed in double asterisks (e.g., `**tag**`).
 *
 * @param {string} input - The input string containing XML-like tags.
 * @returns {string} - The processed string with the described transformations.
 *
 */

/**
 * Splits the input text by "###" and categorizes each segment as either "question" or "plaintext".
 * Segments containing <question>...</question> are tagged as "question"; others as "plaintext".
 *
 * @param {string} inputText - The input text containing segments separated by "###".
 * @returns {Array<Object>} - Array of objects with 'text' and 'type' properties.
 *
 * */

export const convertStreamedXmlToQuestionChunk = inputText => {
  const separator = "###";

  const parts = _.split(inputText, separator);

  const result = [];

  _.forEach(parts, part => {
    part = _.trim(part);

    const matches = part.match(QUESTIONS_REGEX) || [];

    if (_.size(matches) > 0) {
      const questions = _.map(matches, match => ({
        text: match,
        type: "question",
      }));

      result.push(...questions);
    }
  });

  return result;
};

/**
 * @description organization resource for create section
 * @param {string} sectionKey
 * @returns {Array}
 */
export const getOrganizationResources = (sectionKey = "") => [
  {
    label: `Section ${sectionKey}`,
    type: ORG_RESOURCE_TYPE_WORKSHEET,
    resourceType: RESOURCE_TYPE_FOLDER,
  },
];

/**
 * @deprecated use getLearningGoalsMappingFromSectionsV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
// This function returns a object of learning goals id mapped to question title, type and id
export const getLearningGoalsMappingFromSections = _.memoize(
  ({ sections, learningGoalsFields, t }) => {
    const learningGoalsMapping = {};
    _.map(learningGoalsFields, (goal, key) => {
      learningGoalsMapping[key] = {};
    });
    const questions = getAllQuestionsFromSections(sections);

    let questionIndex = 0;
    _.forEach(questions, question => {
      const fields = _.get(question, "item.fields");
      const questionData = _.get(question, "item");
      const questionTypeUid = _.get(question, "item.questionType.uid");
      if (isVisualWorksheetElement(questionTypeUid)) return;
      questionIndex++;
      const questionTypeDetails = _.get(
        QUESTION_TYPE_DETAILS,
        questionTypeUid,
        {}
      );
      const { title: questionTitle } = getQuestionTitle({
        question: questionData,
        t,
      });
      const icon = (
        <span style={{ marginRight: 8 }}>
          <Tag
            dsVersion="2.0"
            _legacy_size="x-small"
            size="small"
            prefix={_.get(questionTypeDetails, "icon", null)}
          >
            {questionIndex}
          </Tag>
        </span>
      );
      _.map(fields, field => {
        const uid = _.get(field, "uid");
        if (uid in learningGoalsMapping) {
          const value = _.get(field, "value");
          const goalMap = _.get(learningGoalsMapping, uid);
          _.map(value, goalId => {
            if (_.isNil(goalMap[goalId])) {
              goalMap[goalId] = [];
            }
            goalMap[goalId].push({
              key: _.get(questionData, "id"),
              id: _.get(questionData, "id"),
              label: _.isEmpty(questionTitle)
                ? t("worksheet:untitled_question")
                : htmlToText(questionTitle),
              icon: icon,
            });
          });
        }
      });
    });
    return learningGoalsMapping;
  }
);

/**
 * @description Removes specified fields from various properties within a template object.
 * @param {Object} template - The template object containing various steps and fields.
 * @returns {Object} A new object with the specified fields removed.
 */
export const removeFieldsFromTemplate = _.memoize(
  (template = {}) => {
    // function to remove specified fields from template
    const removeFields = fields =>
      _.pullAll([...fields], TEMPLATE_FIELDS_TO_REMOVE);

    // Remove fields from step_list
    const updatedStepList = {
      ..._.omit(_.get(template, "step_list"), TEMPLATE_FIELDS_TO_REMOVE),
      implementation: {
        ..._.get(template, "step_list.implementation"),
        fields: _.without(
          _.get(template, "step_list.implementation.fields"),
          FIELD_UID_VOICE_INSTRUCTIONS
        ),
      },
    };

    // Update the template with the modified step_list and other fields
    const updatedTemplate = {
      ...template,
      step_list: updatedStepList,
      classroomEditSteps: removeFields(
        _.get(template, "classroomEditSteps", [])
      ),
      steps: removeFields(_.get(template, "steps", [])),
      view_steps: removeFields(_.get(template, "view_steps", [])),
      previewSteps: removeFields(_.get(template, "previewSteps", [])),
    };

    return updatedTemplate;
  },
  template => JSON.stringify(template)
);

/**
 *
 * @param {*} data
 * @returns Updating question score in cache
 */
const getParentQuestionScore = data => {
  return _.sumBy(_.get(data, "childrenV2.edges", []), edge => {
    const subQuestionScore = _.get(edge, "node.item.questionScore", 0);
    if (!checkScoreFieldValidity(subQuestionScore)) return 0;
    return _.toNumber(subQuestionScore);
  });
};

/**
 * Updates a question's score in the Apollo cache based on the provided parameters.
 *
 * @param {Object} params - The parameters for updating the question score in cache
 * @param {string} params.id - The ID of the question to update
 * @param {string} params.questionScore - The new score value to set for the question
 * @param {boolean} params.isSubQuestion - Whether the question is a sub-question of a multi-part question
 * @param {boolean} params.isFromInternalTool - Whether the update is coming from an internal tool
 * @param {string} params.subQuestionParentId - The ID of the parent question if this is a sub-question
 * @param {boolean} params.isQueriesV2Enabled - Whether to use the V2 version of queries
 * @returns {void}
 */
export const updateQuestionScoreInCache = ({
  id,
  questionScore = "",
  isSubQuestion = false,
  isFromInternalTool = false,
  subQuestionParentId = null,
  isQueriesV2Enabled = false,
}) => {
  if (!id) return;

  let questionCacheData = getQuestionFromCache({ id });

  if (!_.isEmpty(questionCacheData) && !isFromInternalTool) {
    if (isQueriesV2Enabled) {
      // Get question data using V2 query structure
      questionCacheData = getQuestionFromCacheV2({ id });

      /**
       * Updating question score in cache question cache data
       * using the new V2 field name (questionScoreV2)
       */
      const updatedData = update(questionCacheData, {
        questionScoreV2: { $set: questionScore },
      });

      writeQuestionInCacheV2({ id, data: updatedData });
    } else {
      //WORKSHEET_RESTRUCTURING:Remove else part
      /**
       * Updating question score in cache question cache data
       * using the legacy field name (questionScore)
       */
      const updatedData = update(questionCacheData, {
        questionScore: { $set: questionScore },
      });
      writeQuestionInCache({ id, data: updatedData });

      if (isSubQuestion && subQuestionParentId) {
        /**
         * @description
         * Getting parent question from resources
         * Calculating parent question score from sub questions
         * Updating parent question score in organization resources
         */
        const parentQuestion = getOrganizationResourceFromCache(
          subQuestionParentId,
          isSubQuestion
        );
        const parentQuestionScore = getParentQuestionScore(parentQuestion);
        const updatedParentQuestionData = update(parentQuestion, {
          item: { questionScore: { $set: parentQuestionScore } },
        });
        writeOrganizationResourceInCache(
          subQuestionParentId,
          updatedParentQuestionData,
          isSubQuestion
        );
      }
    }
  } else if (isFromInternalTool) {
    //WORKSHEET_RESTRUCTURING:Remove this once queriesV2 support is added for internal tool
    /**
     * Update question score in Question library question cache data
     */
    questionCacheData = getQuestionLibraryQuestionDetailsFromCache({
      id: isSubQuestion ? subQuestionParentId : id,
    });
    if (!_.isEmpty(questionCacheData)) {
      let updatedData = questionCacheData;
      let _questionScore = questionScore;

      if (isSubQuestion) {
        /**
         * For sub question
         * Finding sub question in question and updating its score
         */
        const questionIndex = _.findIndex(
          _.get(questionCacheData, "childrenV2.edges", []),
          edge => _.get(edge, "node.id") === id
        );
        if (questionIndex < 0) return;

        // Updating sub question score in data
        updatedData = update(questionCacheData, {
          childrenV2: {
            edges: {
              [questionIndex]: {
                node: {
                  item: { questionScore: { $set: questionScore } },
                },
              },
            },
          },
        });
        _questionScore = getParentQuestionScore(updatedData);
      }

      if (updatedData) {
        // * Updating question score
        updatedData = update(updatedData, {
          item: { questionScore: { $set: _questionScore } },
        });

        // * Writing question library updated data in cache
        writeQuestionLibraryQuestionDetailsInCache({
          id: isSubQuestion ? subQuestionParentId : id,
          data: { node: updatedData },
        });
      }
    }
  }
};

/**
 * @param {Array} toBeReplacedFieldsUIDs - represents the array containing all the fields uids needs to be replaced
 * @param {Array} originalFieldsData - represents the array containing all the data that needs to be replaced
 * @param {Array} replacementFieldsData - represents the array containing the new data to replace the original data
 * @returns {Array} modifiedFields - updated original data with replacement fields data
 */
export const replaceFields = _.memoize(
  ({ toBeReplacedFieldsUIDs, originalFieldsData, replacementFieldsData }) => {
    // * creating object of replacement's fields Data
    const _replacementFieldsData = _.keyBy(replacementFieldsData, "uid");

    // * replacing data
    const modifiedFields = _.reduce(
      originalFieldsData,
      (acc, field) => {
        const fieldUID = _.get(field, "uid");

        // * update field if found
        if (
          _.includes(toBeReplacedFieldsUIDs, fieldUID) &&
          _.has(_replacementFieldsData, fieldUID)
        ) {
          acc.push(_.get(_replacementFieldsData, fieldUID));
        }
        // * reseting fields
        else if (_.includes(toBeReplacedFieldsUIDs, fieldUID)) {
          const updatedField = {
            ...field,
            id: generateRandomId(),
            resolvedMinimalTree: {
              ..._.get(field, "resolvedMinimalTree", {}),
              id: generateRandomId(),
              nodes: [],
            },
            value: null,
          };
          acc.push(updatedField);
        } else {
          acc.push(field);
        }

        return acc;
      },
      []
    );

    return modifiedFields;
  },
  ({ toBeReplacedFieldsUIDs, originalFieldsData, replacementFieldsData }) => {
    return JSON.stringify({
      toBeReplacedFieldsUIDs: _.join(toBeReplacedFieldsUIDs, "|"),
      originalFieldsData,
      replacementFieldsData,
    });
  }
);

/**
 * @description getting data for `MYP_OBJECTIVE_RUBRIC` and `MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC` assessment tools
 * @param {string} assignmentId - id of assignment
 * @param {string} userType - logged in user type
 * @param {string} curriculumProgramType - current curriculum program type
 * @param {string} userId - logged in user id
 * @param {string} childID
 * @param {string} academicYearId - selected academic year id
 * @param {Array} questionFields - question's fields data
 * @returns object of required data
 */
export const getDataForAssessmentToolsDetails = _.memoize(
  ({
    assignmentId,
    userType,
    curriculumProgramType,
    userId,
    childID,
    academicYearId,
    questionFields,
  }) => {
    const assignmentData = getAssignmentDetailsFromCacheMemoized({
      assignmentId,
      userType,
      curriculumProgramType,
      userId,
      childID,
      academicYearId,
    });

    const assessmentFields = _.get(assignmentData, "content.allFields", []);

    const unitPlan = _.get(
      _.find(assessmentFields, { uid: "unitPlan" }),
      "resolvedMinimalTree.unitPlan"
    );
    const unitPlanFields = _.get(unitPlan, "allFields");

    const worksheetTemplateId = _.get(assignmentData, "content.templateId");
    const worksheetTemplateCacheData = getPlannerTemplateFromCache(
      { ids: [worksheetTemplateId] },
      false
    );

    const worksheetTemplate = _.get(worksheetTemplateCacheData, "body", {});

    const updatedAssessmentFields = replaceLearningGoalsFields({
      template: worksheetTemplate,
      fields: assessmentFields,
      replacementFields: questionFields,
    });

    return {
      assessmentFields: updatedAssessmentFields,
      field_list: _.get(worksheetTemplate, "field_list", {}),
      unitPlan: {
        ...unitPlan,
        allFields: _.cloneDeep(unitPlanFields),
      },
      unitPlanFields: _.cloneDeep(unitPlanFields),
    };
  },
  ({
    assignmentId,
    userType,
    curriculumProgramType,
    userId,
    childID,
    academicYearId,
    questionFields,
  }) => {
    const fields = _.map(questionFields, field =>
      _.pick(field, ["uid", "id", "value"])
    );
    return JSON.stringify({
      assignmentId,
      userType,
      curriculumProgramType,
      userId,
      childID,
      academicYearId,
      questionFields: fields,
    });
  }
);

/**
 * @description Removes empty lines from HTML content while preserving essential elements like inputs and images.
 * @param {string} htmlContent - The HTML content string from which empty lines should be removed.
 * @returns {string} A new HTML string with empty lines removed and important content preserved.
 */
export const removeEmptyLines = htmlContent => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlContent;

  //Each line generated by the editor generates a paragraph with the class tde-paragraph(rte) or ds-de-paragraph(doc-editor).
  //So using the above the selector we are able to select all the lines of the editor in a line by line order
  const paragraphs = tempDiv.querySelectorAll(
    "p.tde-paragraph, p.ds-de-paragraph, p.ds-de-mini-paragraph"
  );

  // Iterate from the beginning
  for (let i = 0; i < paragraphs.length; i++) {
    const paragraph = paragraphs[i];

    // Remove <br> and empty text nodes from the start
    while (
      paragraph.firstChild &&
      (paragraph.firstChild.tagName === "BR" ||
        (paragraph.firstChild.nodeType === Node.TEXT_NODE &&
          _.isEmpty(paragraph.firstChild.textContent.trim())))
    ) {
      paragraph.removeChild(paragraph.firstChild);
    }

    // If the paragraph has content, stop iterating from the beginning
    if (paragraph.hasChildNodes()) {
      break;
    }
  }

  // Iterate from the end
  for (let j = paragraphs.length - 1; j >= 0; j--) {
    const paragraph = paragraphs[j];

    // Remove <br> and empty text nodes from the end
    while (
      paragraph.lastChild &&
      (paragraph.lastChild.tagName === "BR" ||
        (paragraph.lastChild.nodeType === Node.TEXT_NODE &&
          _.isEmpty(paragraph.lastChild.textContent.trim())))
    ) {
      paragraph.removeChild(paragraph.lastChild);
    }

    // If the paragraph has content, stop iterating from the end
    if (paragraph.hasChildNodes()) {
      break;
    }
  }

  // Remove paragraphs that are completely empty (have no child nodes)
  paragraphs.forEach(paragraph => {
    if (!paragraph.hasChildNodes()) {
      paragraph.parentNode.removeChild(paragraph);
    }
  });

  return tempDiv.innerHTML;
};

/**
 * @description updating learning goals related fields in assessment data and unit plan data
 * @param {Object} template - configuration template for module
 * @param {Array} fields - fields data
 * @param {Array} replacementFields - fields needs to replace
 * @returns updated assessmentDetails and unitPlanDetails data
 */
export const replaceLearningGoalsFields = ({
  template,
  fields = [],
  replacementFields,
}) => {
  const learningGoalsFieldUIDs =
    _.get(template, "step_list.pypElements.fields") ||
    _.get(template, "step_list.dpElements.fields") ||
    [];

  const updatedFields = replaceFields({
    toBeReplacedFieldsUIDs: learningGoalsFieldUIDs,
    originalFieldsData: fields,
    replacementFieldsData: replacementFields,
  });

  return updatedFields;
};

/**
 * Calculates the total score for a given submission based on its ID and mode.
 * @param {string} submissionId - The ID of the submission.
 * @param {string} mode - The mode of assessment
 * @returns {number} - The total score calculated from SCORE type ratings.
 */
export const getTotalScore = ({ submissionId, mode }) => {
  const assessmentSubmissionQueryVariables = getAssessmentSubmissionQueryVariables(
    {
      submissionId,
      mode,
    }
  );
  const cacheData = getStudentAssignmentQuestionSubmissionsFromCache(
    assessmentSubmissionQueryVariables
  );
  const edges = _.get(cacheData, "questionSubmissions.edges");
  // Flatten the array of edges and filter for SCORE type ratings
  const scores = _.flatMap(edges, ({ node }) => {
    const ibPYPElementRatings = _.get(node, "ibPYPElementRatings", []);
    return _.filter(ibPYPElementRatings, {
      ibPYPElementType: "SCORE",
    });
  });
  // Sum the values of the SCORE type ratings
  return _.sumBy(scores, rating => parseFloat(_.get(rating, "value")) || 0);
};

/**
 * Determines if the lock screen feature should be enabled based on various conditions.
 */
export const getIsLockScreenEnabled = ({
  isSafeBrowserEnabled,
  isChromebookKioskMode,
  _isLockScreenEnabled,
  isLockScreenEnabledForStudent,
  isInSafeExamBrowser,
  mode,
}) => {
  const isWorksheetMonitoringEnabled = getIsWorksheetMonitoringEnabled();

  // Base rule
  let isLockScreenEnabled =
    (isSafeBrowserEnabled && isChromebookKioskMode) || _isLockScreenEnabled;

  if (!isWorksheetMonitoringEnabled) return isLockScreenEnabled;

  // Student specific override
  if (!_.isNull(isLockScreenEnabledForStudent) && !isInSafeExamBrowser) {
    isLockScreenEnabled =
      isLockScreenEnabledForStudent || mode === MODE_STUDENT_ATTEMPT;
  }

  return isLockScreenEnabled;
};

/**
 * Determines if Safe Browser mode should be enabled based on various conditions.
 */
export const getIsSafeBrowserEnabled = ({
  _isSafeBrowserEnabled,
  isChromebookKioskMode,
  isLockScreenEnabledForStudent,
  isInSafeExamBrowser,
  mode,
}) => {
  const isWorksheetMonitoringEnabled = getIsWorksheetMonitoringEnabled();

  // Base rule
  let isSafeBrowserEnabled = _isSafeBrowserEnabled && !isChromebookKioskMode;

  if (!isWorksheetMonitoringEnabled) return isSafeBrowserEnabled;

  // Student specific override
  if (
    !_.isNull(isLockScreenEnabledForStudent) &&
    isSafeBrowserEnabled &&
    !isInSafeExamBrowser
  ) {
    isSafeBrowserEnabled =
      !isLockScreenEnabledForStudent && mode !== MODE_STUDENT_ATTEMPT;
  }

  return isSafeBrowserEnabled;
};

/**
 * Extracts relevant assignment details from the student assignment object.
 * @param {Object} studentAssignmentData - The data object containing information about the student's assignment.
 * @param {string} mode - The mode of assessment.
 * @returns {Object} - An object containing specific flags and information about the assignment.
 */
export const getAssignmentData = ({ studentAssignmentData, mode }) => {
  if (_.isEqual(mode, MODE_TEACHER_PREVIEW)) {
    return {
      isEvaluationApplicable: true,
      isSharedWithStudent: false,
      isStudentEvaluationEnabled: false,
      isEvaluated: false,
      isSubmitted: false,
      isWorksheetEvaluated: false,
      showWorksheetAssessmentTool: false,
      isSubmissionStateLocked: false,
    };
  }
  const isStudentAssignmentRevampEnabled = getIsStudentAssignmentRevampEnabled();

  let submission = {};
  if (isStudentAssignmentRevampEnabled) {
    ({ currentSubmission: submission } = getCurrentAndPreviousSubmissions(
      studentAssignmentData
    ));
  }

  // Helper function to get properties
  const getValue = (path, defaultValue = false) =>
    _.get(studentAssignmentData, path, defaultValue);

  // Extract assignment data using the helper function
  const isEvaluated = isStudentAssignmentRevampEnabled
    ? _.get(submission, "evaluations.isEvaluated")
    : getValue("isSharedWithStudent");
  const isSubmitted = getValue("isSubmitted");
  const isSharedWithStudent = isStudentAssignmentRevampEnabled
    ? _.get(submission, "evaluations.isSharedWithStudent")
    : getValue("isSharedWithStudent");
  const isEvaluationApplicable = getValue("isEvaluationApplicable");
  const isStudentEvaluationEnabled = getValue(
    "assignment.isStudentEvaluationEnabled"
  );
  const isTeacherEvaluationEnabled = getValue(
    "assignment.isTeacherEvaluationEnabled"
  );
  const isStudentSubmissionEnabled = getValue(
    "assignment.isStudentSubmissionEnabled"
  );
  const events = getValue("events", []);
  const course = getValue("assignment.course", {});
  const isSubmissionStateLocked = getValue("lockingState.state") === "LOCKED";
  const isTimedTestEnabled = getValue("assignment.isTimedTestEnabled");
  const _isSafeBrowserEnabled = getValue("assignment.isSafeBrowserEnabled");
  const _isLockScreenEnabled = getValue("assignment.isLockScreenEnabled");
  const assessmentTools = getValue(
    "assignment.content.assessmentTools.edges",
    []
  );
  const isOnScreenCalculatorDefault = getValue(
    "assignment.isOnScreenCalculatorEnabled"
  );
  const isOnScreenCalculatorValue = getValue(
    "submissions.edges.0.isOnScreenCalculatorEnabled",
    null
  );
  const isOnScreenCalculator = _.isNull(isOnScreenCalculatorValue)
    ? isOnScreenCalculatorDefault
    : isOnScreenCalculatorValue;

  const showStudentResponse = getValue("assignment.showStudentResponse");

  const isLockScreenEnabledForStudent = isStudentAssignmentRevampEnabled
    ? _.get(submission, "isLockScreenEnabled", null)
    : getValue("submissions.edges.0.isLockScreenEnabled", null);

  const isChromebookKioskMode = isInKioskMode();
  const isInSafeExamBrowser = isSafeExamBrowser();

  const isSafeBrowserEnabled = getIsSafeBrowserEnabled({
    _isSafeBrowserEnabled,
    isChromebookKioskMode,
    isLockScreenEnabledForStudent,
    isInSafeExamBrowser,
    mode,
  });
  const isLockScreenEnabled = getIsLockScreenEnabled({
    isSafeBrowserEnabled,
    isChromebookKioskMode,
    _isLockScreenEnabled,
    isLockScreenEnabledForStudent,
    isInSafeExamBrowser,
    mode,
  });

  const hasAssessmentTools = !_.isEmpty(assessmentTools);
  const isWorksheetEvaluated = hasAssessmentTools
    ? isSharedWithStudent
    : isEvaluated;

  const showWorksheetAssessmentTool = getShowWorksheetAssessmentTool(
    assessmentTools
  );

  const isWorksheetSubmitted =
    (hasAssessmentTools ? isSubmitted || isEvaluated : isSubmitted) ||
    (!isTimedTestEnabled ? isSubmissionStateLocked : false);

  const startEvent = _.find(events, { eventType: "START" }) || {};
  const endEvent = _.find(events, { eventType: "END" }) || {};

  const ibPYPElementRatings = isStudentAssignmentRevampEnabled
    ? _.get(submission, "evaluations.ibPYPElementRatings", [])
    : getValue("ibPYPElementRatings", []);

  const submissionEndTime = _.get(submission, "endTime", null);
  const isWorksheetPaused = _.get(submission, "isPaused", false);

  const isTestStarted = !_.isEmpty(startEvent);
  const statusV2 = _.get(submission, "statusV2", null);
  const isTestEnded =
    !_.isEmpty(endEvent) || isWorksheetSubmitted || getIsTestEnded(statusV2);

  const timerComponentProps = {
    events,
    startEvent,
    isTestStarted,
    isTestEnded,
    timedTestDuration: getValue("assignment.timedTestDuration"),
    submissionEndTime,
    isWorksheetPaused,
    isFixedStartTime: getValue("assignment.isFixedStartTime", false),
    publishedAt: getValue("assignment.publishedAt", null),
  };

  return {
    isEvaluated,
    isSubmitted,
    isSharedWithStudent,
    isEvaluationApplicable,
    isStudentEvaluationEnabled,
    isTeacherEvaluationEnabled,
    isStudentSubmissionEnabled,
    events,
    course,
    isSubmissionStateLocked,
    isTimedTestEnabled,
    isSafeBrowserEnabled,
    isLockScreenEnabled,
    isWorksheetEvaluated,
    isTestEnded,
    showWorksheetAssessmentTool,
    timerComponentProps,
    isOnScreenCalculator,
    showStudentResponse,
    ibPYPElementRatings,
    isWorksheetPaused,
  };
};

export const isWorksheetWebView = () => {
  const params = new URLSearchParams(window.location.search);
  const isWorksheetWebView = params.get("isWorksheetWebView");
  return (
    _.isEqual(isWorksheetWebView, "true") ||
    (isSafeExamBrowser() && isMobileOrTablet())
  );
};

export const getDropDownOptions = isWorksheetWebView =>
  isWorksheetWebView
    ? _.filter(CREATE_DROP_DOWN_OPTIONS, { key: "upload_device" })
    : CREATE_DROP_DOWN_OPTIONS;

/**
 * @deprecated use getAssessmentTotalScoreV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
export const getAssessmentTotalScore = ({ assessmentQuestions }) => {
  const data = _.get(
    assessmentQuestions,
    "organizationResourcesV2.edges[0].node.childrenV2.edges",
    []
  );
  let totalMarks = 0;
  data?.forEach(section => {
    _.get(section, "node.childrenV2.edges", [])?.forEach(questionOption => {
      const questionScore = _.get(questionOption, "node.item.questionScore", 0);

      totalMarks += getRoundedDecimalValue(questionScore);
    });
  });

  return totalMarks;
};

/**
 * @description Extracts all media URLs (links and iframes) from a given HTML string.
 * @param {string} htmlString - The HTML content containing links to media resources.
 * @returns {Array} - An array of URLs extracted from the anchor tags (<a>) and iframes (<iframe>) in the HTML string.
 */
export const extractMediaAttachments = htmlString => {
  if (!_.isEmpty(htmlString)) {
    const span = document.createElement("span");
    span.innerHTML = htmlString;
    const links = span.querySelectorAll("a");
    const mediaUrls = _.map(links, link => {
      return {
        name: _.get(link, "innerText", "untitled"),
        url: _.get(link, "href", ""),
      };
    });
    const iframes = span.querySelectorAll("iframe");
    const iframeUrls = _.map(iframes, iframe => {
      return {
        name: _.get(iframe, "title", "untitled"),
        url: _.get(iframe, "src", ""),
      };
    });
    return [...mediaUrls, ...iframeUrls];
  } else {
    return [];
  }
};

export const getTypeDetailsFromUrl = url => {
  const googleLinksRegex = /https:\/\/docs.google.com\/(document|spreadsheets|presentation)/;
  if (googleLinksRegex.test(url)) {
    const match = url.match(googleLinksRegex);

    if (match) {
      switch (match[1]) {
        case "document":
          return {
            type: "LINK",
            mimeType: WORKSHEET_THEATER_MODE_MIMETYPES.docx,
          };
        case "spreadsheets":
          return {
            type: "LINK",
            mimeType: WORKSHEET_THEATER_MODE_MIMETYPES.xlsx,
          };
        case "presentation":
          return {
            type: "LINK",
            mimeType: WORKSHEET_THEATER_MODE_MIMETYPES.pptx,
          };
        default:
          return { type: "LINK", mimeType: "unknown" };
      }
    }
  }

  // Check for YouTube links
  const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  if (youtubeRegex.test(url)) {
    return {
      type: "LINK",
      mimeType: "video/youtube",
    };
  }

  const cleanUrl = url.split("?")[0]; // Remove query parameters
  const extension = cleanUrl.split(".").pop().toLowerCase(); // Extract file extension
  const mimeType = WORKSHEET_THEATER_MODE_MIMETYPES[extension];
  if (!_.isEmpty(mimeType)) {
    const fileType = _.get(
      getFileType(WORKSHEET_THEATER_MODE_MIMETYPES[extension]),
      "text",
      "LINK"
    );

    return {
      type:
        _.isEqual(fileType, "FILE") && !isToddleAppSubdomain(url)
          ? "LINK" //change to LINK for file type if it's not from toddle app subdomain, preview not supported in theatre mode
          : fileType,
      mimeType: mimeType,
    };
  }
  return {
    type: "LINK",
    mimeType: "unknown",
  };
};

/**
 * @deprecated Use `getLastQuestionIdFromQuestions` instead.
 * This is kept for backward compatibility.
 * It will be removed in future versions.
 */
/**
 *
 * @param {*} worksheetData
 * @returns Get last question id from worksheet data
 */
export const getLastQuestionIdFromAssessmentQuestions = worksheetData => {
  const sections = _.get(
    worksheetData,
    "organizationResourcesV2.edges[0].node.childrenV2.edges",
    []
  );
  const lastSection = _.last(sections);
  const questions = _.get(lastSection, "node.childrenV2.edges", []);
  const lastQuestion = _.last(questions);
  const lastQuestionId = _.get(lastQuestion, "node.item.id");
  return lastQuestionId;
};

/**
 * This function is used in the new assessment questions structure (v2).
 * It retrieves the last question ID from the questions hierarchy.
 * @param {Array} sections - The hierarchy of sections, where each section contains an array of questions.
 * @returns {string} - The ID of the last question in the last section.
 */
export const getLastQuestionIdFromQuestions = sections => {
  const lastSection = _.last(sections);
  const questions = _.get(lastSection, "children", []);
  const lastQuestion = _.last(questions);
  const lastQuestionId = _.get(lastQuestion, "item.id");
  return lastQuestionId;
};

/**
 * Calculates common worksheet variables used in multiple components.
 *
 * @param {string} showStudentResponse - The setting for showing student response.
 * @param {boolean} isEvaluated - Indicates if the worksheet is evaluated.
 * @param {boolean} isSharedWithStudent - Indicates if the worksheet is shared with the student.
 * @param {boolean} isSubmitted - Indicates if the worksheet is submitted.
 * @param {boolean} isSubmissionStateLocked - Indicates if the submission state is locked.
 * @param {boolean} isTimedTestEnabled - Indicates if the timed test is enabled.
 * @param {Object} studentAssignmentData - The student assignment data.
 * @param {string} publishedAt - The published date of the worksheet.
 * @param {Object} assessmentTools - The assessment tools data.
 * @returns {Object} The calculated worksheet variables.
 */
export const getModifiedAssignmentData = ({
  showStudentResponse,
  isEvaluated,
  isSharedWithStudent,
  isSubmitted,
  isSubmissionStateLocked,
  isTimedTestEnabled,
  studentAssignmentData,
  publishedAt,
  assessmentTools,
}) => {
  const hasAssessmentTools = !_.isEmpty(assessmentTools);

  const { isSubmitted: isAssessmentTurnedIn, status } = getSubmissionStatus({
    submission: _.get(studentAssignmentData, "submissions.edges.0", {}) || {},
  });

  const isWorksheetEvaluated = hasAssessmentTools
    ? isSharedWithStudent
    : isEvaluated;

  const isWorksheetSubmitted =
    (hasAssessmentTools ? isSubmitted || isEvaluated : isSubmitted) ||
    (!isTimedTestEnabled ? isSubmissionStateLocked : false) ||
    isAssessmentTurnedIn;

  const canShowResponse =
    showStudentResponse === "ONCE_EVALUATED"
      ? isWorksheetEvaluated
      : showStudentResponse === "ALWAYS"
      ? isWorksheetSubmitted
      : false;

  const events = _.get(studentAssignmentData, "events", []);
  const startEvent = _.find(events, { eventType: "START" }) || {};

  const timeTillScheduledTest = getRemainingTimeFromStartTime(publishedAt);

  const hideWorksheetResponse = isSubmitted && !canShowResponse;
  const showWorksheetResponse = isSubmitted && canShowResponse;
  const isTestStarted = !_.isEmpty(startEvent);

  const { isReopened } = getStudentWorksheetReopenState(events);
  const isWorksheetReopened = isReopened && !getIsTestEnded(status);

  return {
    isWorksheetSubmitted,
    isWorksheetEvaluated,
    timeTillScheduledTest,
    hideWorksheetResponse,
    isTestStarted,
    hasAssessmentTools,
    showWorksheetResponse,
    isWorksheetReopened,
  };
};

/**
 * Identifies and extracts URLs that contain the TestCloud domain.
 * This function examines an array of URLs and returns a mapping of indices to URLs
 * for those that match the TestCloud domain pattern.
 *
 * @param {Array<string>} rawUrls - Array of URL strings to check.
 * @returns {Object} A hashmap where keys are indices of TestCloud URLs and values are the URLs themselves.
 */
export const getTestCloudUrls = rawUrls =>
  _.reduce(
    rawUrls,
    (hashmap, url, index) => {
      // Added testcloud.toddleapp for testcloud urls and cloud for prod urls. Also haven't added .com/.cn as it can be different for different regions
      if (
        url.includes("testcloud.toddleapp") ||
        url.includes("cloud.toddleapp")
      ) {
        hashmap[index] = url;
      }
      return hashmap;
    },
    {}
  );

/**
 * Replaces unsigned URLs with their signed counterparts based on a provided mapping.
 * This function takes raw URLs, a mapping of indices to URLs that need signing,
 * and signed URL data to produce a new array with appropriate URLs replaced.
 *
 * @param {Object} params - The parameters object.
 * @param {Array<string>} params.rawAttachments - The original array of URL strings and name string in a obj.
 * @param {Object} params.urlHashmap - A mapping of indices to URLs that need to be signed.
 * @param {Array<Object>} params.signedUrls - Array of objects containing originalUrl and signedUrl pairs.
 * @returns {Array<string>} A new array with unsigned URLs replaced with their signed versions.
 */
export const replaceUnsignedUrls = ({
  rawAttachments,
  urlHashmap,
  signedUrls,
}) =>
  rawAttachments.map((attachment, index) => {
    const { url, name } = attachment;
    if (index in urlHashmap) {
      // Find the signed URL entry by matching originalUrl with the current URL
      const signedUrlEntry = _.find(signedUrls, { originalUrl: url });
      return { name, url: _.get(signedUrlEntry, "signedUrl", url) };
    }
    return attachment;
  });

/**
 * Normalizes a URL by removing query parameters and returning only the origin and pathname.
 * This function attempts to parse the URL and extract essential parts, handling parsing errors gracefully.
 *
 * @param {string} urlString - The URL string to normalize.
 * @returns {string} The normalized URL containing only origin and pathname, or the original URL if parsing fails.
 */ export const normalizeUrl = urlString => {
  try {
    const urlObj = new URL(urlString);
    return `${urlObj.origin}${urlObj.pathname}`;
  } catch (e) {
    return urlString;
  }
};

/**
 * Retrieves debug information for worksheet AI processes.
 *
 * @param {Object} params - The parameters containing AI conversation data.
 * @param {Object} params.aiConversations - AI conversation data for worksheet generation.
 * @param {Object} params.extractionAIConversations - AI conversation data for worksheet extraction.
 * @returns {Array<Object>} - Array of debug information objects containing usageMetricsId, model, temperature, and other metadata.
 */
export const getWorksheetAiDebugInfo = params => {
  const { aiConversations, extractionAIConversations } = params;

  const tooltips = {
    preStepDebugInfo: "AI : Worksheet plan creation",
    debugInfo: "AI : Generate worksheet questions",
    extractionDebugInfo: "Extraction: Extract worksheet questions",
    mappingDebugInfo: "Extraction: Map worksheet questions",
    extractionDebugInfoV2: "Extraction: Extract worksheet questions v2",
  };

  // * Get debug information from metadata
  const getDebugInfo = (infoKey, aiConversations) => {
    const metadata = _.get(aiConversations, "metadata", {});
    const infoData = _.get(metadata, infoKey, {});
    const usageMetricsId = _.get(infoData, "usageMetricsId", null);
    const model = _.get(infoData, "metaData.model", null);
    const temperature = _.get(infoData, "metaData.temperature", null);
    const aiConversationId = _.get(aiConversations, "id", "");
    return {
      usageMetricsId,
      model,
      temperature,
      tooltip: tooltips[infoKey],
      infoKey,
      aiConversationId,
    };
  };

  const debugInfos = [
    getDebugInfo("preStepDebugInfo", aiConversations),
    getDebugInfo("debugInfo", aiConversations),
    getDebugInfo("extractionDebugInfo", extractionAIConversations),
    getDebugInfo("extractionDebugInfoV2", extractionAIConversations),
    getDebugInfo("mappingDebugInfo", extractionAIConversations),
  ];

  // * Filter out invalid entries and return the array
  const isValid = id => id && !_.isEmpty(id) && _.isString(id);
  return _.filter(debugInfos, info => isValid(_.get(info, "usageMetricsId")));
};

/**
 * Updates data after a task extraction process is completed or failed.
 *
 * @async
 * @function
 * @param {Object} params - The parameters for the function.
 * @param {Object} params.data - The data object containing task details.
 * @param {string} params.portalType - The type of portal (e.g., teacher, student).
 * @param {Object} params.assignmentFeedFilters - Filters applied to the assignment feed.
 * @param {string} params.academicYearId - The ID of the academic year.
 * @param {Function} params.setToastMsg - Function to set a toast message.
 * @param {string|null} [params.from=null] - The source of the request (e.g., "course").
 *
 * @returns {Promise<void>} Resolves when the data update and refetching are complete.
 */

export const updateDataAfterExtraction = async params => {
  const {
    data,
    portalType,
    assignmentFeedFilters,
    academicYearId,
    setToastMsg,
    from = null,
  } = params;

  const taskCompleted = _.get(data, "taskState") === "COMPLETED";
  const taskFailed = _.get(data, "taskState") === "FAILED";
  const courseId = _.get(data, "courseId");
  const extractionConversationId = _.get(data, "aiConversationId");
  const assessmentTitle = _.get(data, "assessmentTitle");
  const assessmentId = _.get(data, "assessment_id");
  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  if (taskCompleted || taskFailed) {
    const refetchQuery = courseId
      ? {
          query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
          variables: {
            courseId,
            ...getQueryFiltersMemoize({
              filters: assignmentFeedFilters,
              academicYearId,
            }),
          },
        }
      : null;

    // Use either await or not based on the source
    if (from === "course") {
      await client.refetchQueries({ include: [refetchQuery] });
    } else {
      client.refetchQueries({ include: [refetchQuery] });
    }

    client.refetchQueries({
      include: [
        {
          query: getAIConversationsQuery,
          variables: { id: extractionConversationId, portalType },
        },
      ],
    });

    client.refetchQueries({
      include: [
        {
          query: getAssessmentQuery,
          variables: { id: assessmentId, portalType, collaboratorsFilter },
        },
      ],
    });
  }

  if (taskCompleted) {
    setToastMsg({
      title: assessmentTitle,
      type: "success",
      isClosable: true,
      msg: "toastMsgs:question_extraction_completed",
    });
  } else if (taskFailed) {
    setToastMsg({
      title: assessmentTitle,
      isClosable: true,
      msg: "toastMsgs:questions_not_extracted",
      type: "error",
    });
  }
};

/**
 * @description
 * Function to get the progress text for extraction loader
 * @param {number} progress - The progress percentage
 * @returns {string} - The text to display for the extraction loader
 */
export const getExtractionLoaderText = progress => {
  if (progress < 25) return EXTRACT_FROM_DOC_LOADER[0];
  if (progress <= 50) return EXTRACT_FROM_DOC_LOADER[25];
  if (progress <= 75) return EXTRACT_FROM_DOC_LOADER[50];
  if (progress <= 100) return EXTRACT_FROM_DOC_LOADER[75];
  return EXTRACT_FROM_DOC_LOADER[100];
};

/**
 * Determines if the assessment has only a SCORE tool and no other assessment tools.
 *
 * @param {Array} assessmentTools - An array of assessment tool objects
 * @returns {boolean} Returns true if there is exactly one assessment tool of type 'SCORE', false otherwise
 */
export const hasOnlyScoreTool = (assessmentTools = []) => {
  const toolType = _.get(assessmentTools, "[0].node.assessmentToolType");
  return _.size(assessmentTools) === 1 && _.isEqual(toolType, "SCORE");
};

/*
 * @param {*} action
 * @param {*} type
 * @returns Handling create type in local storage
 */
export const createTypeSessionStorage = (action, type) => {
  const sessionStorageKey = "worksheetCreationType";
  if (action === "SET") {
    sessionStorage.setItem(sessionStorageKey, type);
  } else {
    // * REMOVE OR GET
    const storedType = sessionStorage.getItem(sessionStorageKey);
    sessionStorage.removeItem(sessionStorageKey);
    return storedType;
  }
};

/**
 * @description organization resource for create section
 * @param {string} sectionKey
 * @returns {Array}
 */
export const getSectionTitle = (sectionKey = "") => [
  {
    uid: FIELD_UID_TITLE,
    value: `Section ${sectionKey}`,
  },
];
/**
 *
 * @param {*} aiConversations
 * @param {*} entitySubType
 * @returns Return AI Conversation ID based on entity sub type
 */
export const getAiConversationId = (
  assessmentDetails,
  entitySubType = "TASK_CREATION"
) => {
  const conversations = _.get(assessmentDetails, "aiConversation.edges", []);

  if (entitySubType === "TASK_CREATION") {
    // * For TASK_CREATION entity sub type
    // * Considering null as TASK_CREATION, this will help older worksheet to maintain flow
    const aiConversation = _.find(conversations, item => {
      const thisEntitySubType = _.get(item, "node.entitySubType");
      return thisEntitySubType === entitySubType || thisEntitySubType === null;
    });
    return _.get(aiConversation, "node.id");
  }

  // * For other entity sub types
  const aiConversation = _.find(conversations, { node: { entitySubType } });
  return _.get(aiConversation, "node.id");
};

/**
 *
 * @param {*} param0
 * @description
 * Mutates the steps for the worksheet single page flow.
 * This function modifies the steps array based on the provided parameters.
 * It checks if the worksheet single page flow is enabled and adjusts the steps accordingly.
 * It also checks for the presence of instructions and assessment tools, and hides the corresponding steps if necessary.
 */
export const mutateStepsForWorksheetSinglePageFlow = ({
  steps = [],
  newWorksheetBasicDetailManager = {},
  resourceFields = [],
  assessmentTools = {},
}) => {
  const FINAL_REMARKS_STEP = "finalRemarks";
  const hasFinalRemarks = _.includes(steps, FINAL_REMARKS_STEP);
  if (hasFinalRemarks) {
    steps = _.without(steps, FINAL_REMARKS_STEP);
    steps = [_.first(steps), FINAL_REMARKS_STEP, ..._.slice(steps, 1)];
  }

  const showInstructions = _.get(
    newWorksheetBasicDetailManager,
    "worksheetBasicDetailInfo.showInstructions"
  );
  const showAssessmentTools = _.get(
    newWorksheetBasicDetailManager,
    "worksheetBasicDetailInfo.showAssessmentTools"
  );

  // * Check if description field is present and has a value
  const description = _.find(resourceFields, { uid: "description" });
  const hasInstruction = !_.isEmpty(_.get(description, "value"));

  // * if not toggled on from button and no description field is present, then hiding step
  if (!showInstructions && !hasInstruction) {
    steps = _.without(steps, "implementation");
  }

  // * Check if assessment tools are present and not of type SCORE
  const assessmentToolsData = _.filter(
    _.get(assessmentTools, "edges"),
    item =>
      _.get(item, "node.assessmentToolType") !== "SCORE" &&
      _.get(item, "node.assessmentToolType") !== "COMMENT"
  );
  const hasAssessmentTools = !_.isEmpty(assessmentToolsData);

  // * if not toggled on from button and no assessment tools is present, then hiding step
  if (!showAssessmentTools && !hasAssessmentTools) {
    steps = _.without(steps, "assessmentTool");
  }
  return steps;
};

//* Checks that internal tool V2 queries and mutations should work based on both queries and mutations V2 being enabled
// Will be enabled after every v2 queries are added in the codebase
export const isMutationAndQueriesV2Enabled = () => {
  return false;
};

/**
 *
 * New Worksheet AI Panel, Common for all AI actions
 * @returns {boolean} - Returns false as the feature is not enabled.
 */
export const isWorksheetRevampV3 = () => {
  // * Returning false,
  return false;
};

/**
 * Generates a hierarchical tree structure from a flat array of questions.
 * Each question may have a parentIdV2 indicating its parent, and a sequence for ordering.
 * Sections are identified by questionType.uid === "section" and become root nodes.
 *
 * @param {Array} flatQuestions - The flat array of question objects.
 * @returns {Array} Sorted array of root section nodes, each with nested children.
 */
export const generateQuestionsHierarchy = (flatQuestions = []) => {
  if (_.isEmpty(flatQuestions)) return [];

  let parentItemId;

  // Sort the flat questions by parentIdV2 and sequence
  const sortedFlatQuestions = _.sortBy(flatQuestions, [
    "parentIdV2",
    "sequence",
  ]);

  // Map to hold question nodes by their id
  const questionsMap = new Map();
  _.forEach(sortedFlatQuestions, question => {
    const { id, parentTypeV2 } = question;
    if (_.isEqual(parentTypeV2, "ASSESSMENT")) {
      parentItemId = _.get(question, "id");
      return;
    } // Skip the parent resource

    questionsMap.set(id, { item: question, children: [] });
  });

  // Build the tree structure
  const data = [];
  _.forEach(sortedFlatQuestions, question => {
    const { id, parentIdV2, questionType, parentTypeV2 } = question;
    if (_.isEqual(parentTypeV2, "ASSESSMENT")) return; // Skip the parent resource

    const node = questionsMap.get(id);
    const parentNode = questionsMap.get(parentIdV2);
    const isSection = _.isEqual(
      _.get(questionType, "uid"),
      QUESTION_UID_SECTION
    );

    if (parentNode) {
      parentNode.children.push(node);
    } else if (isSection) {
      data.push(node);
    }
  });

  return { data, parentItemId };
};

/**
 *
 * @param {*} questionData - The question data object containing details about the question.
 * @param {*} t - Translation function for internationalization.
 * @param {*} questionIndex - The index of the question in the list.
 * @param {*} submissions - The list of submissions related to the question.
 * @param {*} showTickIcon - Boolean indicating whether to show the tick icon for completed questions.
 * @param {*} tier - The tier level of the question.
 * @param {*} parentResourceId - The ID of the parent resource to which the question belongs.
 * @description
 * This function formats a question option for display in the sidebar of a worksheet.
 * @returns {Object} - The formatted question option object.
 */
const getFormattedQuestionOptionV2 = ({
  questionData,
  t,
  questionIndex,
  submissions,
  showTickIcon,
  tier,
  parentResourceId,
}) => {
  const question = _.get(questionData, "item", {});
  const questionId = _.get(question, "id");
  const questionTypeUid = _.get(question, "questionType.uid");
  const { title: questionTitle } = getQuestionTitle({
    question,
    t,
    shouldIncludeMedia: true,
  });

  const fields = _.get(question, "fields", []);
  const assessmentTools = _.get(question, "assessmentTools", []);

  const hasIBGradeOnly = getHasIBGradeOnly({ assessmentTools });

  let assessmentToolsEvaluationDetails = {};

  const questionTypeDetails = _.get(QUESTION_TYPE_DETAILS, questionTypeUid, {});

  const scoreField = _.find(fields, { uid: FIELD_UID_SCORE });
  const intScore = getFormattedQuestionScore(scoreField);

  let icon = null,
    isCompleted = false,
    submission = {},
    isQuestion = false,
    isEvaluated = false,
    evaluatedScore;

  if (!isVisualWorksheetElement(questionTypeUid)) {
    icon = (
      <Tag
        dsVersion="2.0"
        _legacy_size="x-small"
        size="small"
        prefix={getIconFromQuestionDetails({
          questionTypeDetails,
        })}
      >
        {questionIndex}
      </Tag>
    );
    isQuestion = true;

    if (!_.isEmpty(submissions)) {
      submission = getQuestionSubmissionItem({
        questionId,
        submissions,
      });

      assessmentToolsEvaluationDetails = {
        parentId: _.get(submission, "id"),
        parentType: "QUESTION_SUBMISSION",
        toolEvaluationResponses: _.get(submission, "toolResponses"),
        ibPYPElementRatings: _.get(submission, "ibPYPElementRatings"),
        elementRemarks: _.get(submission, "elementRemarks"),
        questionFields: fields,
      };

      const scoreObj = getScoreObjFromSubmission({
        ibPYPElementRatings: _.get(submission, "ibPYPElementRatings"),
      });

      evaluatedScore = _.get(scoreObj, "value", null);

      if (!_.isNil(evaluatedScore)) {
        isEvaluated = true;
      }

      isCompleted = _.get(submission, "isQuestionAttempted", false);
    }
  }

  return {
    id: questionId,
    icon,
    label: questionTitle,
    tier,
    suffix: isQuestion ? intScore : null,
    maxMarks: isQuestion ? intScore : null,
    score: isQuestion && isEvaluated ? evaluatedScore : null,
    isCompleted,
    isEvaluated,
    showTickIcon: showTickIcon && !_.isEmpty(submission),
    isQuestion,
    submissionId: isQuestion ? _.get(submission, "id") : null,
    assessmentTools,
    hasIBGradeOnly,
    assessmentToolsEvaluationDetails,
    intScore,
    submission,
    evaluatedScore,
    questionTypeUid,
    questionIndex,
    parentResourceId,
  };
};
/**
 * Get sidebar options for the worksheet view.
 * @param {Array} data - The data containing sections and questions.
 * @param {Array} submissions - The list of submissions related
 * to the worksheet.
 * @param {string} mode - The mode of the worksheet (e.g., student, teacher).
 * @param {Function} t - The translation function for internationalization.
 * @param {number} scoreValue - The score value for
 * calculating scores.
 * @returns {Array} - The sidebar options for the worksheet view.
 */
export const getSideBarOptionsV2 = ({
  data,
  submissions = [],
  mode,
  t,
  scoreValue = 0,
}) => {
  const options = [];

  let evaluatedCount = 0,
    totalMarks = 0,
    totalScore = 0,
    questionIndex = 1,
    isAllSectionsEvaluated = true;

  const showTickIcon = _.includes(
    [
      MODE_STUDENT_ATTEMPT,
      MODE_STUDENT_VIEW,
      MODE_TEACHER_EVALUATE,
      MODE_TEACHER_VIEW,
    ],
    mode
  );

  data?.forEach(section => {
    const questionOptions = [];
    let sectionMarks = 0,
      sectionScore = 0,
      sectionComplete = true,
      sectionEvaluated = true;

    _.get(section, "children", [])?.forEach(questionOption => {
      const question = _.get(questionOption, "item", {});
      const questionTypeUid = _.get(question, "questionType.uid");

      let formattedQuestionOption = getFormattedQuestionOptionV2({
        questionData: questionOption,
        t,
        questionIndex,
        submissions,
        showTickIcon,
        tier: 2,
        parentResourceId: _.get(section, "id"),
      });

      const subQuestionOptions = [];
      let subQuestionIndex = 1,
        questionMarks = 0,
        questionScore = 0,
        questionComplete = true,
        questionEvaluated = true;

      _.get(questionOption, "children", [])?.forEach(subQuestionOption => {
        const subQuestion = _.get(subQuestionOption, "item", {});
        const subQuestionTypeUid = _.get(subQuestion, "questionType.uid");

        const formattedSubQuestionOption = getFormattedQuestionOptionV2({
          questionData: subQuestionOption,
          t,
          questionIndex: `${questionIndex}.${subQuestionIndex}`,
          submissions,
          showTickIcon,
          tier: 3,
          parentResourceId: _.get(subQuestionOption, "id"),
        });

        if (subQuestionTypeUid != CONTENT_UID_TEXT_BOX) {
          subQuestionIndex++;

          const subQuestionMarks = _.get(
            formattedSubQuestionOption,
            "intScore",
            0
          );
          totalMarks += subQuestionMarks;
          sectionMarks += subQuestionMarks;
          questionMarks += subQuestionMarks;

          if (!_.isEmpty(_.get(formattedSubQuestionOption, "submission", {}))) {
            const isSubQuestionCompleted = _.get(
              formattedSubQuestionOption,
              "isCompleted",
              false
            );
            const isSubQuestionEvaluated = _.get(
              formattedSubQuestionOption,
              "isEvaluated",
              false
            );

            sectionComplete = sectionComplete && isSubQuestionCompleted;
            questionComplete = questionComplete && isSubQuestionCompleted;

            sectionEvaluated = sectionEvaluated && isSubQuestionEvaluated;
            questionEvaluated = questionEvaluated && isSubQuestionEvaluated;

            const subQuestionEvaluatedScore = _.get(
              formattedSubQuestionOption,
              "evaluatedScore"
            );

            if (!_.isNil(subQuestionEvaluatedScore)) {
              const subQuestionEvaluatedScoreNum = Number(
                subQuestionEvaluatedScore
              );

              questionScore += subQuestionEvaluatedScoreNum;
              sectionScore += subQuestionEvaluatedScoreNum;
              totalScore += subQuestionEvaluatedScoreNum;
            }
          }
        }

        subQuestionOptions.push(formattedSubQuestionOption);
      });

      if (!_.isEmpty(subQuestionOptions)) {
        /** if it's a multipart question set the marks/score as the sum of its sub questions */

        questionMarks = getRoundedDecimalValue(questionMarks);
        questionScore = getRoundedDecimalValue(questionScore);

        formattedQuestionOption = update(formattedQuestionOption, {
          suffix: { $set: questionMarks },
          maxMarks: { $set: questionMarks },
          score: { $set: questionScore },
          isCompleted: { $set: questionComplete },
          isEvaluated: { $set: questionEvaluated },
          childOptions: { $set: subQuestionOptions },
        });
      }

      // Skip for separator and text box, they doesn't have score or evaluation associated with them and are for visual purposes only
      if (!isVisualWorksheetElement(questionTypeUid)) {
        questionIndex++;

        const questionMarks = _.get(formattedQuestionOption, "intScore", 0);
        totalMarks += questionMarks;
        sectionMarks += questionMarks;

        if (!_.isEmpty(_.get(formattedQuestionOption, "submission", {}))) {
          const isQuestionCompleted = _.get(
            formattedQuestionOption,
            "isCompleted",
            false
          );
          const isQuestionEvaluated = _.get(
            formattedQuestionOption,
            "isEvaluated",
            false
          );

          if (isQuestionEvaluated) evaluatedCount++;

          sectionComplete = sectionComplete && isQuestionCompleted;
          sectionEvaluated = sectionEvaluated && isQuestionEvaluated;

          const questionEvaluatedScore = _.get(
            formattedQuestionOption,
            "evaluatedScore"
          );

          if (!_.isNil(questionEvaluatedScore)) {
            sectionScore += Number(questionEvaluatedScore);
            totalScore += Number(questionEvaluatedScore);
          }
        }
      }

      questionOptions.push(formattedQuestionOption);
    });

    sectionScore = getRoundedDecimalValue(sectionScore);
    sectionMarks = getRoundedDecimalValue(sectionMarks);

    const parentTitleFieldId = _.get(
      _.find(_.get(section, "item.fields", []), {
        uid: FIELD_UID_TITLE,
      }),
      "id",
      null
    );
    const label = _.get(
      _.find(_.get(section, "item.fields", []), {
        uid: FIELD_UID_TITLE,
      }),
      "value",
      null
    );

    options.push({
      id: _.get(section, "item.id"),
      label,
      tier: 1,
      suffix: sectionMarks,
      maxMarks: sectionMarks,
      score: sectionScore,
      showTickIcon,
      isCompleted: sectionComplete,
      isEvaluated: sectionEvaluated,
      isQuestion: false,
      showSectionActions: mode == MODE_TEACHER_CREATE,
      childOptions: questionOptions,
      // section should be not clickable in revamp
      isNotClickable: true,
      parentItemId: _.get(section, "item.id"),
      parentTitleFieldId,
    });

    isAllSectionsEvaluated = isAllSectionsEvaluated && sectionEvaluated;
  });

  totalMarks = getRoundedDecimalValue(totalMarks);
  totalScore = getRoundedDecimalValue(scoreValue);

  return {
    questionCount: questionIndex - 1,
    evaluatedCount,
    totalMarks,
    options,
    totalScore,
    isAllSectionsEvaluated,
  };
};

/**
 *
 * @param {Array} sections - Array of section objects containing questions and potentially nested subquestions.
 * @param {boolean} isSubQuestion - A flag to determine if the active question is a subquestion.
 * @returns {Array} The array of question's objects
 */
export const getAllQuestionsFromSectionsV2 = (
  sections = [],
  isSubQuestion = false
) => {
  let allQuestions = [];
  // Flatten the questions and subquestions into a single array

  _.forEach(sections, section => {
    _.forEach(section?.children, question => {
      const subQuestions = _.get(question, "children", []);
      const sectionId = _.get(section, "item.id", "");
      if (isSubQuestion) {
        if (_.size(subQuestions) > 0) {
          allQuestions = allQuestions.concat(
            _.map(subQuestions, subQuestion => ({
              ...subQuestion?.item,
              sectionId,
            }))
          );
        }
      }
      allQuestions.push({ ...question?.item, sectionId });
    });
  });
  return allQuestions;
};

/**
 * @param {*} data - The worksheet data containing sections and questions.
 * @param {*} errorState - An object representing the error state of questions, where keys are question IDs and values are truthy if there's an error.
 * @returns {number} The count of errors found in the worksheet data.
 */
export const getErrorCountV2 = (data, errorState) => {
  let errorCount = 0;

  const filteredErrorStates = _.keys(_.pickBy(errorState, _.identity));

  _.forEach(data, section => {
    const questionEdges = _.get(section, "children", []);
    _.forEach(questionEdges, questionEdge => {
      const question = _.get(questionEdge, "item", null);
      if (!_.isEmpty(question)) {
        const questionId = _.get(question, "id");

        if (_.includes(filteredErrorStates, questionId)) {
          errorCount += 1;
        }
      }

      const subQuestionEdges = _.get(questionEdge, "children", []);
      _.some(subQuestionEdges, subQuestionEdge => {
        const subQuestion = _.get(subQuestionEdge, "item", null);
        if (!_.isEmpty(subQuestion)) {
          const subQuestionId = _.get(subQuestion, "id");
          if (_.includes(filteredErrorStates, subQuestionId)) {
            errorCount += 1;
            return true;
          }
        }
        return false;
      });
    });
  });

  return errorCount;
};

/**
 * @description - Creates an array of mock question submission based on
 * the question type configuration
 */
export const getDummyWorksheetSubmissionV2 = _.once(({ sections = [] }) => {
  const questionArray = [];

  _.forEach(sections, item => {
    const questionEdgeArray = _.get(item, "children", []);

    _.forEach(questionEdgeArray, questionEdge => {
      const question = _.get(questionEdge, "item", {});

      questionArray.push(question);

      _.get(questionEdge, "children", []).forEach(subQuestionEdge => {
        const subQuestion = _.get(subQuestionEdge, "item", {});

        questionArray.push(subQuestion);
      });
    });
  });

  return getDummySubmissionsFromQuestions(questionArray);
});

/**
 *
 * @param { aiConversationId, sections }
 * @returns AI Panel context options for the worksheet.
 */
export const getAIPanelContextOptions = ({ aiConversationId, sections }) => {
  // * If AI conversation ID is not provided, return an empty array
  const itemsList = [
    {
      label: "All content",
      key: aiConversationId,
      isConversationCreated: !!aiConversationId,
    },
  ];

  // * Flatten the sections to get all questions
  const flatten = _.flatMap(sections, section =>
    _.get(section, "childrenV2.edges", [])
  );

  // * Iterate through the flattened questions to create context options
  _.forEach(flatten, (item, index) => {
    const conversationId = _.get(
      item,
      "node.item.aiConversation.edges.0.node.id"
    );
    const questionType = _.get(item, "node.item.questionType.uid");
    if (!_.includes(AI_SUPPORTED_QUESTION_TYPES, questionType)) return;

    itemsList.push({
      label: `Question ${index + 1}`,
      questionId: _.get(item, "node.item.id"),
      isConversationCreated: !!conversationId,
      key: conversationId || `QUESTION_${index}`,
    });
  });
  return itemsList;
};

/**
 * Calculates the total score of an assessment by summing all question scores.
 * @param {Object} params - The parameters for the function
 * @param {Array} params.data - Array of section objects, each containing questions with scores
 * @returns {number} - The total marks calculated from all question scores, rounded to two decimal places
 */
export const getAssessmentTotalScoreV2 = ({ data }) => {
  let totalMarks = 0;

  _.forEach(data, question => {
    const questionScore = _.get(question, "questionScoreV2", 0);
    const questionTypeUid = _.get(question, "questionType.uid");
    // Don't count multi-part questions directly as their scores come from sub-questions
    if (!_.isEqual(QUESTION_UID_MULTI_PART, questionTypeUid))
      totalMarks += getRoundedDecimalValue(questionScore);
  });

  return totalMarks;
};

/**
 *
 * @param {*} id
 * @description Updates the metadata of a question in the cache.
 * It retrieves the question data from the cache, updates its metadata,
 * and writes the updated data back to the cache.
 */
export const updateQuestionMetadataInCacheV2 = (id, metadata) => {
  const questionCacheData = getQuestionFromCacheV2({ id });
  const updatedData = update(questionCacheData, {
    metadata: { $set: metadata },
  });

  writeQuestionInCacheV2({
    id,
    data: updatedData,
  });
};

/**
 * Gets the last question ID from flat data structure
 * @param {Object} worksheetData - Worksheet data
 * @param {boolean} isV2Data - Whether the data is in V2 format
 * @returns {string|null} - ID of the last question or null if no questions found
 */
export const getLastQuestionIdFromAssessmentQuestionsV2 = worksheetData => {
  // V2 format: flat questions array
  const questions = _.get(worksheetData, "questions.edges", []);

  if (_.isEmpty(questions)) return null;

  // First, find all sections and sort them by sequence
  const sections = _.filter(questions, question => {
    const questionTypeUid = _.get(question, "questionType.uid");
    return questionTypeUid === QUESTION_UID_SECTION;
  });

  // Sort sections by sequence to find the last section
  const sortedSections = _.sortBy(sections, "sequence");
  const lastSection = _.last(sortedSections);
  const lastSectionId = _.get(lastSection, "id");

  // Find all questions that belong to the last section
  const questionsInLastSection = _.filter(questions, question => {
    const questionTypeUid = _.get(question, "questionType.uid");
    const parentIdV2 = _.get(question, "parentIdV2");

    return (
      !isVisualWorksheetElement(questionTypeUid) &&
      questionTypeUid !== QUESTION_UID_SECTION &&
      parentIdV2 === lastSectionId
    );
  });

  if (_.isEmpty(questionsInLastSection)) return null;

  // Sort questions within the last section by sequence to get the last question
  const sortedQuestionsInLastSection = _.sortBy(
    questionsInLastSection,
    "sequence"
  );
  const lastQuestion = _.last(sortedQuestionsInLastSection);

  return _.get(lastQuestion, "id", null);
};

/**
 * Extracts and formats essential details from a question object for display in library card UI.
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.question - The question object containing all question data
 * @param {Function} params.t - Translation function for internationalization
 * @param {boolean} [params.isSideBarPreview=false] - Whether this is being rendered in the sidebar preview
 * @param {boolean} [params.isToddleLibrary=false] - Whether this is being rendered in the Toddle Library
 * @returns {Object} Formatted question card details with consistent properties
 */
export const getLibraryQuestionCardDetailsV2 = ({
  question,
  t,
  isSideBarPreview = false,
  isToddleLibrary = false,
}) => {
  const questionId = _.get(question, "id", "");
  const questionTypeUid = _.get(question, "questionType.uid", "");
  const questionTitle = _.get(question, "questionTitleV2", {});
  const questionScore = _.get(question, "questionScoreV2", 0);
  const difficulty = _.get(question, "difficulty", "");

  const questionTypeLabel = t(
    _.get(
      QUESTION_TYPE_DETAILS,
      [questionTypeUid, "localeLabel"],
      "common:untitled"
    )
  );

  const formattedMarks = parseFloat?.(questionScore) || 0;

  // Get the formatted title, trying different sources with fallbacks
  const formattedTitle =
    _.get(getFormattedQuestionTitle({ questionTitle }), "htmlString", false) ||
    _.get(getQuestionTitle({ question, t }), "htmlString", false) ||
    t("worksheet:untitled_question");

  const groupedTags = _.groupBy(
    _.get(question, "associatedEntities", []),
    "__typename"
  );

  const tagLabels = {};

  const subjects = _.get(question, "librarySubjects", []);
  const subjectLabel = _.get(_.first(subjects), "label", "");
  const subjectTooltip = _.map(subjects, "label");

  // Add subject tag component if there's at least one subject
  if (!_.isEmpty(subjectLabel)) {
    tagLabels[QUESTION_TAG_SUBJECT] = (
      <QuestionCardTag
        label={subjectLabel}
        tooltips={subjectTooltip}
        count={_.size(subjects) - 1}
        isSideBarPreview={isSideBarPreview}
        t={t}
      />
    );
  }

  const syllabusContentTopics = _.filter(
    _.get(groupedTags, "PlannerElementNode", []),
    item => _.get(item, "depth") == TOPIC_DEPTH
  );

  const genericTopics = _.filter(
    _.get(groupedTags, "GenericTag", []),
    item => _.get(item, "type") == QUESTION_TOPIC
  );

  const topics = isToddleLibrary ? syllabusContentTopics : genericTopics;

  const topicLabel = _.get(_.first(topics), "label", "");
  const topicTooltip = _.map(topics, "label");

  // Add topic tag component if there's at least one topic
  if (!_.isEmpty(topicLabel)) {
    tagLabels[QUESTION_TAG_TOPIC] = (
      <QuestionCardTag
        label={topicLabel}
        tooltips={topicTooltip}
        count={_.size(topics) - 1}
        isSideBarPreview={isSideBarPreview}
        t={t}
      />
    );
  }

  return {
    key: questionId,
    id: questionId,
    questionId,
    questionTypeLabel,
    marks: formattedMarks,
    title: formattedTitle,
    questionTypeUid,
    tagLabels,
    difficulty,
  };
};

// Feature flag for new student end sidebar
export const isStudentEndMode = (mode = MODE_STUDENT_ATTEMPT) => {
  return _.includes(
    [
      MODE_STUDENT_ATTEMPT,
      MODE_STUDENT_VIEW,
      MODE_STUDENT_EVALUATE,
      MODE_TEACHER_PREVIEW,
    ],
    mode
  );
};

/**
 * @description & Codebase changes
 * - In worksheet sidebar for all modes - Monitoring sidebar items will be visible
 * - One new route is added for monitoring(/monitoring) in sidebar
 * - Monitoring is route landing components in screen
 * - Rest all the code is inside `AppComponents/WorksheetMonitoring
 * @returns "FeatureFlag:WorksheetMonitoringV1" is enabled or not
 */
export const getIsWorksheetMonitoringEnabled = () => {
  return ACLStore.can("FeatureFlag:WorksheetMonitoringV1");
};

export { getIsWorksheetAssignModalV2Enabled } from "./WorksheetFeatureFlags";

export const getDifficultyLevelOptions = t => {
  return [
    {
      label: <div style={{ color: colors.teal400 }}>{t("worksheet:easy")}</div>,
      value: "EASY",
      key: "EASY",
      localeLabel: t("worksheet:easy"),
    },
    {
      label: (
        <div style={{ color: colors.yellow300 }}>{t("worksheet:medium")}</div>
      ),
      value: "MEDIUM",
      key: "MEDIUM",
      localeLabel: t("worksheet:medium"),
    },
    {
      label: <div style={{ color: colors.red52 }}>{t("worksheet:hard")}</div>,
      value: "HARD",
      key: "HARD",
      localeLabel: t("worksheet:hard"),
    },
  ];
};

// * Checks if the new MCQ settings feature is enabled.
export const getIsMCQNewSettingsEnabled = () => {
  return ACLStore.can("FeatureFlag:WorksheetMCQSettingsV2");
};

/**
 * Filters question settings options based on question type UID.
 * @param {Array} params.options - Array of settings options.
 * @param {string} params.questionTypeUid - The UID of the question type.
 * @returns {Array} - Filtered settings options.
 */
export const getFilteredQuestionSettings = ({ options, questionTypeUid }) => {
  let updatedOptions = _.isArray(options) ? [...options] : [];

  switch (questionTypeUid) {
    case QUESTION_UID_MULTI_CHOICE: {
      const isMCQNewSettingsEnabled = getIsMCQNewSettingsEnabled();
      if (!isMCQNewSettingsEnabled) {
        const excludedSettingUids = [
          FIELD_UID_ALLOW_MULTIPLE_SELECTION_SETTING,
          FIELD_UID_ADDITIONAL_FIELD_SETTING,
        ];

        updatedOptions = _.filter(
          updatedOptions,
          option => !_.includes(excludedSettingUids, option?.uid)
        );
      }
      return updatedOptions;
    }

    default:
      return updatedOptions;
  }
};

/**
 *
 * @param {*} eventData
 * @param {*} setToastMsg
 * @return toast notification dispatcher
 */
export const dispatchStudentMonitoringEventToast = ({
  t,
  eventData,
  setToastMsg,
}) => {
  const eventType = _.get(eventData, "eventType");
  if (eventType === "ADD_EXTRA_TIME") {
    setToastMsg({
      msg: "toastMsgs:extra_time_added_with_time",
      locale_params: [
        {
          key: "time",
          value: getFormattedDuration({
            duration: _.get(eventData, "duration", 0),
            unit: "seconds",
            durationFormat: "m [minute]",
            trim: true,
          }),
        },
      ],
      type: "success",
      isClosable: true,
    });
  } else if (eventType === "REMOVE_ALL_EXTRA_TIME") {
    setToastMsg({
      msg: "toastMsgs:extra_time_removed",
      type: "success",
      isClosable: true,
    });
  } else if (_.has(eventData, "isOnScreenCalculatorEnabled")) {
    setToastMsg({
      isClosable: true,
      msg: "toastMsgs:on_screen_calculator_with_status",
      type: "success",
      locale_params: [
        {
          key: "status",
          value: _.get(eventData, "isOnScreenCalculatorEnabled", false)
            ? t("common:enabled")
            : t("common:disabled"),
        },
      ],
    });
  } else if (_.has(eventData, "isLockScreenEnabled")) {
    setToastMsg({
      isClosable: true,
      msg: "toastMsgs:browser_lock_mode_with_status",
      type: "success",
      locale_params: [
        {
          key: "status",
          value: _.get(eventData, "isLockScreenEnabled", false)
            ? t("common:enabled")
            : t("common:disabled"),
        },
      ],
    });
  }
};

/*
 * @description
 * - Checks if Worksheet AI is enabled based on access control permissions.
 *
 * @codes_changes
 * - Do not show Worksheet create modal, directly land on create worksheet manually screen
 * - Hide all AI panel icons - AI Question assistant, AI Assessment tool etc
 * - Update Add Questions Dropdown - Only show import from library option
 *
 * @returns True if Worksheet AI is enabled
 */
export const getIsWorksheetAIEnabled = () => {
  return ACLStore.can("FeatureFlag:WorksheetAIAddon");
};

/*
 *
 * @param {*} status
 * @returns Boolean indicating if the test is ended based on submission status
 */
export const getIsTestEnded = status => {
  switch (status) {
    case "TURNED_IN_ON_TIME":
    case "TURNED_IN_LATE":
    case "NOT_SUBMITTED":
    case "RESUBMISSION_NOT_SUBMITTED":
    case "SUBMISSION_NOT_REQUIRED":
      return true;
    case "DRAFT":
    case "SUBMISSION_PENDING":
    case "REQUEST_RESUBMISSION":
    case "REQUEST_RESUBMISSION_OVERDUE":
    case "OVERDUE":
    case "SCHEDULED":
      return false;
    default:
      return false;
  }
};

export const extractTextWithLatex = htmlText => {
  if (!htmlText || typeof htmlText !== "string") return "";
  if (!htmlText.includes("<")) return _.trim(htmlText);

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlText, "text/html");

  const imgs = doc.querySelectorAll("img");

  _.forEach(imgs, img => {
    const latex =
      img.getAttribute("data-latex") || img.getAttribute("alt") || "";

    // Replace with proper text node
    img.replaceWith(doc.createTextNode(latex));
  });

  const htmlString = doc.body.innerHTML;

  // Convert non-breaking spaces (&nbsp;, &#160;, \u00A0) into normal spaces and trim the trailing spaces
  return _.trim(
    _.replace(htmlToText(htmlString), /(&nbsp;|&#160;|\u00A0)/gi, " ")
  );
};
